<template>

    <div id="app" class="white pt-0 pa-0" v-if="(agenda_show)">

        <!-- dialog_fields: {{dialog_fields}} <br/> -->
        <!-- {{tipo_de_cliente}} -->
        <!-- {{lista_fornecedores}} -->
        <!-- {{value_expansion_3}} -->
        <!-- mostrar_items_multipla: {{mostrar_items_multipla}} <br/><br/> -->
        <!-- veiculosFiltrados: {{veiculosFiltrados}} <br/><br/> -->
        <!-- obj_user: {{obj_user}} <br/><br/> -->
        <!-- item_menu = quando clica no evento: {{item_menu}} <br/><br/> -->

        <!-- {{card_titulo}} -->
        <!-- obj_dados_empresa: {{obj_dados_empresa}} <br/> -->

        <!-- menu_de_tabelas : {{menu_de_tabelas}} <br/><br/> -->
        <!-- tabela_selecionada: {{tabela_selecionada}} <br/> <br/> -->
        <!-- tabela_selecionada_2: {{tabela_selecionada_2}} <br/> <br/> -->
        <!-- tabela_selecionada_agora: {{tabela_selecionada_agora}} <br/> <br/> -->
        <!-- obj_clicado: {{obj_clicado}} <br/> <br/> -->
        <!-- selected: {{selected}} <br/><br/> -->
        <!-- obj_clicado_2: {{obj_clicado_2}} <br/> <br/> -->
        <!-- selected_2: {{selected_2}} <br/><br/> -->
        
        <!-- item_horario_clicado : {{item_horario_clicado}} <br/><br/> -->
        <!-- menu_selecionado: {{menu_selecionado}} <br/><br/> -->


        <!-- item_edita : {{ item_edita }} <br/><br/> -->
        <!-- lista_horarios.length : {{ lista_horarios.length }} <br/><br/> -->
        <!-- lista_horarios : {{ lista_horarios }} <br/><br/> -->
        <!-- horarios_veiculo  : {{ horarios_veiculo  }} <br/><br/> -->
        <!-- items_eventos : {{ items_eventos }} <br/><br/> -->
        <!-- items_lista : {{ items_lista }} <br/><br/> -->
        <!-- events : {{ events }} <br/><br/> -->
        <!-- in_today : {{ in_today }} <br/><br/> -->
        <!-- selectedEvent : {{ selectedEvent }} <br/><br/> -->
        <!-- selectedElement : {{ selectedElement }} <br/><br/> -->
        <!-- selectedOpen : {{ selectedOpen }} <br/><br/> -->

        <!-- lista_aulas_aluno : {{ lista_aulas_aluno }} <br/><br/> -->
        <!-- lista_aulas_aluno : {{ lista_aulas_aluno }} <br/><br/> -->
        <!-- lista_instrutores : {{ lista_instrutores }} <br/><br/> -->
        <!-- instrutor_selecionado : {{ instrutor_selecionado }} <br/><br/> -->
    
        <!-- lista_cadastros : {{ lista_cadastros }} <br/><br/> -->
        <!-- cadastro_selecionado : {{ cadastro_selecionado }} <br/><br/> -->
        
        <!-- lista_veiculos : {{ lista_veiculos }} <br/><br/> -->
        <!-- lista_veiculos_A : {{ lista_veiculos_A }} <br/><br/> -->
        <!-- veiculo_selecionado : {{ veiculo_selecionado }} <br/><br/> -->

        <!-- tipo_lista : {{ tipo_lista }} <br/><br/> -->
        <!-- tipo_selecionado : {{ tipo_selecionado }} <br/><br/> -->

        <!-- selectedDate : {{ selectedDate }} <br/><br/> -->
        <!-- data_inicial : {{ data_inicial }} <br/><br/> -->
        <!-- data_final : {{ data_final }} <br/><br/> -->



        <v-snackbar
          v-model="snackbar"
          :timeout="3000"
          top
          :color="snack_color"    
      >
      <center v-html="snack_text"></center>
      </v-snackbar>



  <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog_ok"
          width="auto"
          persistent
        >


          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              {{  (dialog_ok_tipo == 'conectar_zap') ? 'Concluído' : 'Concluído'  }}
            </v-card-title>

            <v-card-text>
              
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="clicou_em(dialog_ok_tipo), dialog_ok=false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

 <!-- DIALOG RELATORIOS -->
    <v-dialog
        v-model="dialog_relatorios"
        max-width="900px"
        scrollable
        heigth="100%"
        >
    <v-card
        class="mx-auto"
        :style="dialog_relatorios_acao=='filtrar_multipla_agenda_2' ? { height: '60vh' } : { height : 'auto' }"
    >
        <v-card-title class=" grey lighten-5">
        <h5>Parâmetros </h5>

        <v-spacer></v-spacer>
        
        <v-icon
            color="red"
            @click="dialog_relatorios=!dialog_relatorios"
        >
            mdi-close
        </v-icon>

        </v-card-title>

        <v-card-text>
        <v-container class="mx-0 px-0 mt-2">
            <v-row>
            
            <v-col cols="auto mt-1" v-if="(dialog_relatorios_acao!='filtrar_multipla_agenda_2')">

                <v-row>
                    <v-col
                        cols="auto"
                        class="pl-2 "
                    >      
                        <v-text-field
                        dense
                        v-model="rel_data_de"
                        label="De"
                        hide-details
                        type="date"
                        
                        ></v-text-field>
                    </v-col> 
                    
                    <v-col
                        cols="auto"
                        class="pl-2"
                    >      
                        <v-text-field
                        dense
                        v-model="rel_data_ate"
                        label="Até"
                        hide-details
                        type="date"
                        
                        ></v-text-field>
                    </v-col> 
                </v-row>
            </v-col>

            <v-col cols="6" md="3" class="px-2 pt-0 " v-if="(dialog_relatorios_acao=='gerar_lista_3_1')">

                <v-select
                    v-model="dialog_fields.EMPRESA"
                    :items="[{ 'CODIGO': 0, 'NOME' : 'TODOS'}, ...lista_fornecedores]"
                    label="Empresa"
                    item-value="CODIGO"
                    item-text="NOME"
                    return-object
                    hide-details="true"
                    >
                
                    <!-- <template slot='item' slot-scope='{ item }'>
                        <div class="caption ml-4">
                            {{ item.NOME }}
                        </div>
                    </template> -->
                </v-select>
            </v-col>
            
            <v-col cols="6" md="3" class="px-2 pt-0 " v-if="(dialog_relatorios_acao=='gerar_lista_3_1')">

                <v-text-field
                
                v-model="dialog_fields.NOME"
                label="Filtrar por Nome"
                hide-details
                type="text"
                clearable
                @input="dialog_fields.NOME = ($event || '').toUpperCase()"
                ></v-text-field>
            </v-col>

            <v-col cols="12" class="mx-2 pt-0 " v-if="(dialog_relatorios_acao=='filtrar_multipla_agenda_2')">
                <v-select
                    v-model="mostrar_items_multipla"
                    :items="lista_veiculos_slim"
                    attach
                    chips
                    label="Mostrar na Agenda Multipla (Deixe em branco para mostrar Todos)"
                    multiple

                    item-value="CODIGO"
                    :item-text="item => `${item.PLACA} - ${item.NOME} ${item.CATEGORIA ? '('+item.CATEGORIA+')' : ''}`"
                    return-object
                    hide-details="true"
                    clearable
                    @change="initScrollSync()"
                >
                    <!-- item-text="NOME" -->

                    <!-- Chips -->
                    <template v-slot:selection="{ item }">
                        <v-chip small class="text-caption">
                        {{ item.PLACA }} - {{ item.NOME }} ({{ item.CATEGORIA || '' }})
                        </v-chip>
                    </template>
            
                    <!-- <template slot='item' slot-scope='{ item }'>
                        <div class="caption ml-4">
                            {{ item.NOME }}
                        </div>
                    </template> -->
                
            </v-select>
            </v-col>    


            <v-col cols="3" class="mx-2 pt-0 " v-if="(dialog_relatorios_acao=='imprimir_agenda_geral_veiculos_3')">

                <v-select
                    v-model="rel_instrutor"
                    :items="lista_instrutores"
                    label="Instrutor"
                    item-value="CODIGO"
                    item-text="NOME"
                    return-object
                    hide-details="true"
                    >
                
                    <template slot='item' slot-scope='{ item }'>
                        <div class="caption ml-4">
                            {{ item.NOME }}
                        </div>
                    </template>
                </v-select>
            </v-col>

            <v-col cols="2" class="mx-2 pt-0" v-if="(dialog_relatorios_acao=='imprimir_agenda_geral_veiculos_3')">
                <v-select
                    v-model="rel_categoria"
                    label="Categoria"
                    :items="['TODOS','A','B','C','D','E']"
                    hide-details=""
                    >
                </v-select>
            </v-col>
            
            <v-spacer></v-spacer>
            
            <v-col
                cols="auto"
                class="mt-0 mr-4"
            >   

            <!-- offset-md="2" -->
                <v-btn
                color="primary"
                small
                fab
                @click="clicou_menu_de_tabelas(dialog_relatorios_acao)"
                >
            <v-icon>
                <!-- mdi-printer  -->
                mdi-send
            </v-icon>
                </v-btn>
            </v-col> 


            </v-row>



        </v-container>
        </v-card-text>
    </v-card>
    </v-dialog>


      <template>
        <div class="text-center">
            <v-dialog
            v-model="dialog_texto"
            width="700"
            >

            <v-card>
                <v-card-title class="text-h6 grey lighten-3 justify-center">
                 Agendamento
                </v-card-title>

                <v-card-text class="mt-5">          
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="texto_1"
                                label="Descrição"
                                hide-details="true"  
                                autofocus
                                @keydown="firstUpper($event, texto_1)"
                                @keypress.enter="clicou_hora(item_horario_clicado), dialog_texto = false"
                            >
                            
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>

                <v-spacer></v-spacer>


                <v-btn
                    color="error"
                    text
                    x-large
                    @click="dialog_texto = false"
                >
                    cancelar
                </v-btn>

                <v-btn
                    color="primary"
                    text
                    x-large
                    @click="clicou_hora(item_horario_clicado), dialog_texto = false"
                >
                    salvar
                </v-btn>

                </v-card-actions>
            </v-card>
            </v-dialog>
        </div>
      </template>

      <template>
        <div class="text-center">
            <v-dialog
            v-model="dialog_img"
            width="500"
            >

            <v-card>
                <v-card-title class="text-h6 grey lighten-3 justify-center">
                <!-- {{item_clicou.NOME}}  -->
                {{dialog_img_titulo}} 
                </v-card-title>

                <v-card-text>          
                <v-img
                    alt="user"
                    :src="dialog_img_url"
                    height="30%"
                    v-if="(dialog_img_url)"
                >
                </v-img>
                </v-card-text>

                <v-card-actions>
                <v-btn
                    color="primary"
                    text
                    x-large
                    @click="saiba_mais_click(dialog_img_mais)"
                    v-if="dialog_img_mais"
                >
                    saiba mais
                </v-btn>

                <v-spacer></v-spacer>


                <v-btn
                    color="primary"
                    text
                    x-large
                    @click="dialog_img = false"
                >
                    FECHAR
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </div>
      </template>





  <!-- MENU -->
  <v-dialog
      v-model="dialog_menu"
      max-width="250px"
      scrollable
    >


        <v-card class="mx-auto">

           <v-list dense >

                <v-subheader class="grey lighten-3 pl-2">
                  <span v-if="(selecionou_varios)">
                    <h3> ÍTEMS SELECIONADOS: {{ selected.length}} </h3>
                  </span>
                  <span v-else>
                    <h3 class="black--text"> {{ retorna_titulo(menu_selecionado, item_menu) }} </h3>
                    <!-- <v-chip class="black--text "> {{ retorna_titulo(tabela_selecionada, item_menu) }} </v-chip> -->
                  </span>
                </v-subheader>

                <v-divider class="mx-0"></v-divider>

                <v-list-group
                    v-for="(item, i) in ((selecionou_varios) ? menu_de_tabelas_selecionados : menu_de_tabelas)"
                    :key="i"
                    v-model="item.active"
                    
                    no-action
                    @click.stop="" 
                    v-if="(item.type=='group') && vif_here(item.click)"
                >

                    <template v-slot:activator>

                      <v-list-item-icon class="ml-1">
                        <v-icon :color="item.icon_color" small> {{ item.icon }}</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content class="ml-n6">
                          <v-list-item-title v-text="item.title"></v-list-item-title>
                      </v-list-item-content>
                    </template>


                    <v-list-item
                      v-for="sub in item.items"
                      :key="sub.title"
                      link
                      @click="clicou_menu_de_tabelas(sub.click)"
                      v-if="vif_here(item.click)"
                    >

                      <v-list-item-content>
                          <v-list-item-title v-text="sub.title"></v-list-item-title>
                      </v-list-item-content>
                      
                      
                      <v-list-item-icon>
                        <v-icon :color="sub.icon_color"> {{ sub.icon }}</v-icon>
                      </v-list-item-icon>

                    </v-list-item>

                </v-list-group>

                <v-divider class="mx-0"></v-divider>


                  <span v-for="item in ((selecionou_varios) ? menu_de_tabelas_selecionados : menu_de_tabelas)" :key="item.title" v-if="vif_here(item.click)">
                    <v-list-item
                          link
                          @click="clicou_menu_de_tabelas(item.click)"
                          v-if="item.type=='menu'"
                        >

                        <v-list-item-icon class=" ml-2">
                            <v-icon  :color="item.icon_color"> {{ item.icon }}</v-icon>
                          </v-list-item-icon>

                          <v-list-item-content class=" ml-n5">
                              <v-list-item-title v-text="item.title"></v-list-item-title>
                          </v-list-item-content>

                    </v-list-item>
                    
                    <v-divider
                        class="mx-2"
                    ></v-divider>
                </span>



            </v-list>
        </v-card>


  </v-dialog> 




        <v-dialog
          v-model="dialog_tabela"
          persistent
          max-width="999"
          scrollable
      >
  
          <v-card
          class=""
          >
          <!-- height="80%" -->
          <v-card-title>
              <span class="text-h5" 
                v-text="(item_edita.CODIGO>0) ? 'Alterar '+ card_titulo +' '+item_edita.CODIGO : 'Novo '+ card_titulo "
              >
              Alterar
             </span>
             
             <span class="fs-6 ml-2 grey--text"> {{tabela_selecionada}} </span>
          </v-card-title>
  
  

              <!-- passo 4 monto os campos editaveis -->
              <!-- :readonly = "readonly" -->
                  <v-card-text class="pa-1">
                    <v-form
                      ref="form"
                      v-model="valido"
                      >
                      <v-container>
                          <v-row >
                              <v-col
                                  :class="[item.col_class]"
                                  v-for="(item, i) in items_editaveis_agora"
                                  :key="i"
                                  :cols="(isMobile) ? 12 : item.cols"
                                  v-if="parseInt(item.cols)>0"   
                              >




                                  <v-chip
                                  v-if="item.tag == 'v-chip'" :color="item.color" @click="clicou_em(item.click)"
                                  >
                                    {{ item.text }}
                                  </v-chip>

                                  <v-icon  v-if="item.tag == 'v-icon'" :color="item.color" @click="clicou_em(item.click)"
                                  >
                                    {{ item.icon }}
                                  </v-icon>

                                  <v-btn v-if="(item.tag == 'v-btn')" :color="item.color"
                                  @click="modal_clicou(item.click)"
                                  >
                                    {{item.text}}
                                  </v-btn>


                                  <!-- <span v-if="item.tag == 'span'">
                                    <b> {{ item.text }}</b>
                                  </span> -->

                                  <div v-if="item.grupo" class="mt-n7 pb-2">
                                    <b> {{ item.grupo }}</b>
                                  </div>

                                 <!-- COM V-MASK -->
                                  <v-text-field 
                                      dense
                                      v-model="item_edita[item.value]"
                                      :label="item.rule == 'S' ? item.text+' *': item.text"
                                      :type="item.type"
                                      v-if="(item.tag == 'v-text') && (item.vmask)"
                                      @keyup="meu_keyup($event, item.value, item.upper)"
                                      :rules="item.rule == 'S' ? notnullRules: noRules"
                                      :autofocus="i==1"
                                      :hint="item.hint"
                                      v-mask = "getVmask(item.vmask)"
                                  ></v-text-field>
                                  
                                  <!-- SEM V-MASK  acaba dando erro, por isso separei-->
                                  <v-text-field
                                      dense
                                      v-model="item_edita[item.value]"
                                      :label="item.rule == 'S' ? item.text+' *': item.text"
                                      :type="item.type"
                                      v-if="(item.tag == 'v-text') && (!item.vmask)"
                                      @keyup="meu_keyup($event, item.value, item.upper)"
                                      :rules="item.rule == 'S' ? notnullRules: noRules"
                                      :autofocus="i==1"
                                      :hint="item.hint"
                                      :disabled="item.disabled=='S'"
                                  ></v-text-field>



                                  <v-combobox
                                      dense
                                      v-model="item_edita[item.value]"
                                      :label="item.text"
                                      v-if="item.tag == 'v-autocomplete'"
                                      :items="item.tag_items"
                                      :rules="item.rule == 'S' ? notnullRules: noRules"
                                      clearable

                                      @keyup="meu_keyup($event, item.value, item.upper)"

                                      :return-object = 'item.return_object'
                                      :item-value='item.item_value'
                                      :item-text='item.item_text'
                                      hide-details=""
                                  >
                                
                                     <!-- mudei faz pouco tempo.. pode dar pau em algum momento..ficar de olho -->
                                      <!-- modo visual -->
                                      <template slot="selection" slot-scope="{ item: selecionado }">
                                            <span class="no_wrap">
                                                {{ (item.tag_items.find(x => x[item.item_value] == selecionado) || {})[item.item_text] }}
                                            </span>
                                      </template>

                                </v-combobox>
                                  
                                  
                                  <v-select
                                      :class="[item.class]"
                                      dense
                                      v-model="item_edita[item.value]"
                                      :label="item.text"
                                      v-if="item.tag == 'v-select'"
                                      :items="item.tag_items"
                                      :rules="item.rule == 'S' ? notnullRules: noRules"

                                      item-value='CODIGO'
                                      :item-text='item.tag_item_text'
                                      :clearable = "item.tag_clear == 'S'"
                                      :persistent-hint="item.cols>2"
                                      :hint="item.hint"
                                  >
                                  
                                  <!-- <template slot="selection" v-slot-scope="item"> -->
                                    
                                  <!-- <template slot="selection" v-slot-scope="item"> -->
                                    <template v-slot:label>
                                      <v-tooltip bottom v-if="item.hint">
                                          <template v-slot:activator="{ on, attrs }">
                                            <span
                                                v-bind="attrs"
                                                v-on="on"
                                            > 
                                              <span :class="item.class">
                                                {{ item.text }} 
                                                <!-- {{ item_edita[item.value] }} -->
                                              </span>
                                            </span>

                                          </template>
                                          <span> {{ item.hint }} </span>
                                        </v-tooltip>

                                        <span :class="item.class" v-else>
                                          {{ item.text }} 
                                        </span>
                                    </template>
       
                                </v-select>


                                  <!-- CAMPO ANOTAÇÕES OU OBSERVAÇÃO -->
                                  <v-textarea
                                    v-model="item_edita[item.value]"
                                    :label="item.text"
                                    v-if="item.tag == 'v-textarea'"
                                    :hint="item.hint"
                                    :persistent-hint="item.cols>2"
                                    dense
                                  >
                                  </v-textarea>




                                  <!-- INICIO DIV IMAGEM -->
                                  <div class=""
                                   v-if="item.tag == 'img'"
                                  >
                                  
                                  <v-row dense class="grey lighten-5">
                                    <v-col  class="">
                                      <span class="pb-2">Logo</span>
                                        <v-img
                                        v-if="urlLogo"
                                        max-height="90"
                                        max-width="170"
                                        :src="urlLogo"
                                        contain
                                      >
                                      </v-img>
                                    </v-col>
                                    
                                    <v-col  class="mt-5">
                                      <p class="primary--text"><label for="file_upload" style="cursor: pointer;">Alterar Logo</label></p>
                                      <!-- <p class="primary--text"><label for="file_upload" style="cursor: pointer;">Alterar Logo</label></p> -->
                                      <!-- <p>Remover</p> -->
                                      <v-btn text x-small color="red" for="file_upload"
                                        @click="item_edita[item.value] = '', urlLogo=''"
                                      >
                                        Remover
                                      </v-btn>
                                    </v-col>


                                    </v-row>
                                    <!-- oculto -->
                                    <v-row dense class="grey lighten-3">
                                      <v-col>
                                        <!-- necessario para fazer upload logo -->
                                        <v-file-input
                                          v-model="files_upload"
                                          accept="image/*"
                                          label="Logomarca"
                                          @change="upload_logo(files_upload, session_bd ,'logo',item.value)"
                                          style="display: none"
                                          id="file_upload"
                                        >
                                        <!-- session_bd = nome da pasta onde salvar as imagens..peguei pelo nome do banco de dados -->
                                        </v-file-input>
                                        <!-- necessario para fazer upload logo -->
                                      </v-col>
                                    </v-row>
                                  </div>
                                  <!-- FINAL DIV IMAGEM -->


                                  
                                  
                              </v-col>
                          </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
  
          <v-card-actions>
              <v-btn
                  x-small
                  color="red"
                  text
                  @click="remover_tabela(tabela_selecionada_agora, item_edita, card_titulo), dialog_tabela = false"
              >
                Excluir
              </v-btn>
  
              <v-spacer></v-spacer>
  
              <v-btn
                  color="red"
                  text
                  @click="dialog_tabela = false"
              >
                Cancelar
              </v-btn>
              
              &nbsp
  
              <v-btn
                  :disabled="!valido"
                  color="primary"
                  @click="salvar_tabela(tabela_selecionada_agora, item_edita, 'dialog_tabela')"
              >
              <!-- @click="salvar_tabela(tabela_selecionada, item_edita, 'dialog_tabela')" -->
                Salvar
              </v-btn>
          </v-card-actions>
          </v-card>
      </v-dialog>




        <section class="grid-1">
            
            <div class="item-2 grey lighten-5">
                <!-- <div class="item-5">5</div> -->

                <!-- coluna esquerda calendario mes -->
                <div class="item-6 lighten-4 ">


                    
                    <v-row dense class="">
                        <v-col class="grey lighten-5" cols="12">
                            <template>
                            <v-card
                                elevation="0"
                                class="grey lighten-3 ml-0"
                            >
                                <v-expansion-panels 
                                    :multiple="false"
                                    :focusable='false'
                                    v-model="value_expansion_1"
                                    >


                                        <!-- MOSTRA CALENDARIO -->
                                        <v-expansion-panel>
                                            <v-expansion-panel-header 
                                            class="pa-1 px-1"
                                            style="min-height: 25px"
                                            >
                                              <span class="fs-14 bold" v-if="(!(value_expansion_1>=0))">
                                                  <v-icon color="blue" size="18">mdi-calendar-month-outline</v-icon>
                                                  Calendário 
                                              </span>
                                              
                                            </v-expansion-panel-header>

                                            <v-expansion-panel-content>
                                                <!-- class="py-0 ma-0" -->

                                                <v-container>

                                                    <v-row>
                                                       <v-col class="px-0 py-0 mb-1">
                                                        <v-date-picker
                                                            v-model="in_today"
                                                            width="287"
                                                            :full-width = "$vuetify.breakpoint.smAndDown"
                                                            elevation="4"
                                                            locale="pt-br"
                                                            :first-day-of-week="0"
                                                            :landscape = false
                                                            class="ml-1"
                                                            @input="selectedDate=in_today"
                                                            >
                                                            </v-date-picker>
                                                       </v-col>
                                                    </v-row>
                                                </v-container>

                                            </v-expansion-panel-content>
                                        </v-expansion-panel>


                                </v-expansion-panels>
                            </v-card>
                            </template>
                        </v-col>
                    </v-row>



                  <div v-if="tipo_de_cliente=='CFC'" class="white pa-0">
                    <v-card elevation="1" class="mt-0">
                        <v-row dense class="my-0 pt-1">


                            
                            <v-col class="mx-2 mt-0 pt-0" cols="">

                                <v-select
                                    :items="lista_veiculos "
                                    label="Veículo"
                                    item-value="CODIGO"
                                    item-text="NOME"
                                    return-object
                                    v-model="veiculo_selecionado"
                                    hide-details="true"
                                    @change="tabela('agenda')"
                                    @input="salva_session('veiculo_selecionado')"
                                    >
                                
                                    <template slot='item' slot-scope='{ item }'>
                                            <div class="fs-12">
                                                <span v-if="(item.CODIGO>0)">
                                                   <strong> {{ item.PLACA }} </strong> | {{ item.NOME }} | {{ item.CATEGORIA }}
                                                </span>
                                                <span v-else> {{ item.NOME }} </span>
                                            </div>
                                    </template>


                                    <template slot='selection' slot-scope='{ item }'>
                                            <div class="caption bold">
                                                <span v-if="(item.CODIGO>0)">
                                                    {{ item.PLACA  }} | {{ item.NOME }} | {{ item.CATEGORIA }}
                                                </span>
                                                <span v-else> {{ item.NOME }} </span>
                                            </div>
                                    </template>
                                



                                </v-select>
                            </v-col>


                            <v-col cols="1 ma-0 pa-0 mr-3 mt-5 ">
                                <div class="d-flex justify-end">
                                    <v-tooltip bottom eager>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-checkbox
                                            v-model="filtrar_veiculo"
                                            label="Filtrar"
                                            dense
                                            class="ma-0 pa-0"
                                            hide-details=""
                                            @change="tabela('agenda')"
                                            
                                            >
                                            <template v-slot:label>
                                                <span :class="['fs-12 ml-n7']" v-bind="attrs" v-on="on">⠀⠀</span>
                                            </template>
                                            </v-checkbox>
                                        </template>
                                            <span>Filtrar Veículo</span>
                                    </v-tooltip>
                                </div>
                            </v-col>

                        </v-row>

                        <v-row dense class="mb-1 pl-2">

                            <div >
                                <v-avatar  class="pb-0 ma-0 pa-0" size="50" >
                                    <v-img
                                        alt="..."
                                        contain
                                        :src="instrutor_selecionado.FOTO_URL"
                                        v-if="(instrutor_selecionado.FOTO_URL)"
                                        @click="abre_img(instrutor_selecionado .NOME, instrutor_selecionado .FOTO_URL, '')"
                                        class="hand">
                                    </v-img>
                                        
                                        <!-- @click="dialog_img=true"  -->

                                        <v-icon size="55" v-else class="pa-0 ma-0">
                                        mdi-account-circle
                                        </v-icon>
                                    </v-avatar>
                            </div>


                            <v-col class="mx-2 pt-0">

                                <v-select
                                    :items="lista_instrutores"
                                    label="Instrutor"
                                    item-value="CODIGO"
                                    item-text="NOME"
                                    return-object
                                    v-model="instrutor_selecionado"
                                    hide-details="true"
                                    @change="tabela('agenda')"
                                    @input="salva_session('instrutor_selecionado')"
                                    >
                                
                                    <template slot='item' slot-scope='{ item }'>
                                        
                                        <v-avatar  class="pb-0 ma-0 mr-1 pa-0" size="22" >
                                                <v-img
                                                    alt="..."
                                                    contain
                                                    :src="item.FOTO_URL"
                                                    v-if="(item.FOTO_URL)"
                                                    @click="abre_img(item.NOME, item.FOTO_URL, '')"
                                                    class="hand">
                                                </v-img>
                                                <v-icon size="22" v-else class="pa-0 ma-0">
                                                    mdi-account-circle
                                                </v-icon>

                                            </v-avatar>
                                            
                                            <div class="caption ml-4">
                                                {{ item.NOME }}
                                            </div>

                                    </template>

                                    <!-- <template slot='selection' slot-scope='{ item }'>
                                        <v-avatar  class="pb-0 ma-0 mr-1" size="22" >
                                            <v-img
                                                alt="..."
                                                contain
                                                :src="item.FOTO_URL"
                                                v-if="2>1"
                                                @click="abre_img(item.NOME, item.FOTO_URL, '')"
                                                class="hand">
                                            </v-img>

                                                <v-icon size="22" v-else class="pa-0 ma-0">
                                                mdi-account-circle
                                                </v-icon>
                                            </v-avatar>

                                            <div class="caption ml-4">
                                            {{ item.NOME }}
                                            </div>
                                    </template> -->
                                



                                </v-select>
                            </v-col>

                            <v-col cols="1 ma-0 pa-0 mr-3 mt-5 ">
                                <div class="d-flex justify-end">
                                    <v-tooltip bottom eager>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-checkbox
                                            v-model="filtrar_instrutor"
                                            label="Filtrar"
                                            dense
                                            class="ma-0 pa-0"
                                            hide-details=""
                                            @change="tabela('agenda'),salva_session('filtrar_instrutor')"
                                            
                                            >
                                            <template v-slot:label>
                                                <span :class="['fs-12 ml-n7']" v-bind="attrs" v-on="on">⠀⠀</span>
                                            </template>
                                            </v-checkbox>
                                        </template>
                                            <span>Filtrar Instrutor</span>
                                    </v-tooltip>
                                </div>
                            </v-col>
    
                        </v-row>

                        <v-row dense class="my-0 pl-2">

                            <v-col class="pl-15 pr-6 py-0" cols="11">

                                <v-select
                                    v-model="tipo_selecionado"
                                    :items="tipo_lista"
                                    label="Tipo"
                                    hide-details="true"
                                    @change="tabela('agenda'), aulas_alunos(cadastro_selecionado.CODIGO_ALUNO || cadastro_selecionado.CODIGO)"
                                    @input="salva_session('tipo_selecionado')"
                                    class="py-2"
                                    dense
                                    >
                                
                                    <template slot='item' slot-scope='{ item }'>
                                            <div class="caption ml-4 " >
                                                {{ item }}
                                            </div>
                                    </template>

                                    <template slot='selection' slot-scope='{ item }'>
                                        <div class="caption text-ellipsis bold">
                                            <v-chip x-small :color="retorna_cor_tipo(item)"  class="ml-0 " dark> {{ item }} </v-chip>
                                             <!-- <span class="red--text"> {{item}} </span> -->
                                        </div>
                                    </template>
                                </v-select>
                            </v-col>
    
                        </v-row>

                        <v-row dense class="my-0 pl-2">

                            <div class="pt-1">
                                <v-avatar  class="pb-0 ma-0 pa-0" size="50" >
                                    <v-img
                                        alt="..."
                                        contain
                                        :src="cadastro_selecionado.FOTO_URL"
                                        v-if="(cadastro_selecionado.FOTO_URL)"
                                        @click="abre_img(cadastro_selecionado .NOME, cadastro_selecionado .FOTO_URL, '')"
                                        class="hand">
                                    </v-img>
                                        
                                        <!-- @click="dialog_img=true"  -->

                                        <v-icon size="55" v-else class="pa-0 ma-0">
                                        mdi-account-circle
                                        </v-icon>
                                </v-avatar>
                            </div>


                            <v-col class="mx-2 mr-0 pr-2 " cols="8">

                                <v-select
                                    :items="lista_cadastros"
                                    label="Cadastro"
                                    item-value="CODIGO"
                                    item-text="NOME"
                                    return-object
                                    v-model="cadastro_selecionado"
                                    hide-details="true"
                                    @change="tabela('agenda'), aulas_alunos(cadastro_selecionado.CODIGO_ALUNO || cadastro_selecionado.CODIGO)"
                                    @input="salva_session('cadastro_selecionado')"
                                    class="py-2"
                                    dense
                                    >
                                
                                    <template slot='item' slot-scope='{ item }'>
                                        
                                        
                                        <v-avatar  class="pb-0 ma-0 mr-1" size="22" >
                                                <v-img
                                                    alt="..."
                                                    contain
                                                    :src="item.FOTO_URL"
                                                    v-if="(item.FOTO_URL)"
                                                    @click="abre_img(item.NOME, item.FOTO_URL, '')"
                                                    class="hand">
                                                </v-img>
                                                <v-icon size="22" v-else class="pa-0 ma-0">
                                                    mdi-account-circle
                                                </v-icon>

                                            </v-avatar>
                                            
                                            <div class="caption ml-4" >
                                                {{ item.NOME }}  {{(item.CODIGO_ALUNO)?' | '+ item.CODIGO_ALUNO : '' }}
                                            </div>

                                    </template>


                                    <template slot='selection' slot-scope='{ item }'>
                                        <div class="caption text-ellipsis ">
                                            <span :class="[(cadastro_selecionado.POSSUI_ATRASO =='SIM') ? 'red--text' : 'black--text']  ">
                                                {{ item.NOME }}
                                            </span>
                                        </div>
                                    </template>

                                </v-select>

                                <div v-if="cadastro_selecionado.CODIGO_ALUNO" class="mt-0 fs-11">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-chip  x-small class="px-1" @click="abrir_cadastro(cadastro_selecionado.CODIGO_ALUNO, true)" v-bind="attrs" v-on="on"
                                              :color="(cadastro_selecionado.POSSUI_ATRASO =='SIM') ? 'error' : 'primary'"
                                            >
                                                {{ cadastro_selecionado.CODIGO_ALUNO }}
                                                <v-icon  x-small>
                                                    mdi-account
                                                </v-icon>
                                            </v-chip>

                                        </template>
                                        <span> Ver Cadastro </span>
                                        <div class="pa-0"> {{ (cadastro_selecionado.POSSUI_ATRASO =='SIM') ? `** Cadastro com Parcela Atrasada` : `` }} </div>
                                    </v-tooltip>


                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-chip dark x-small class="px-1 mx-1"
                                              :color="(cadastro_selecionado.POSSUI_ATRASO =='SIM') ? 'error' : 'primary'"
                                              @click="go_copiarParaClipboard(cadastro_selecionado.PROCESSO)"
                                             v-bind="attrs" v-on="on">
                                                {{ cadastro_selecionado.PROCESSO }}
                                            </v-chip>

                                        </template>
                                        <span> Copiar Processo </span>
                                        <div class="pa-0"> {{ (cadastro_selecionado.POSSUI_ATRASO =='SIM') ? `** Cadastro com Parcela Atrasada` : '' }} </div>

                                    </v-tooltip>


                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-chip color="orange" dark x-small class="px-1" v-bind="attrs" v-on="on">
                                                {{ cadastro_selecionado.x_DATA_PROCESSO }}
                                            </v-chip>

                                        </template>
                                        <span> Data do Processo </span>
                                    </v-tooltip>

                                    <!-- <span class="px-1 bold"> {{cadastro_selecionado.PROCESSO}} </span> -->
                                    <!-- <span class="px-1"> {{cadastro_selecionado.CELULAR}} </span> -->
                                </div>

                            </v-col>


                            <v-col cols="1 ma-0 pa-0 pl-2 ml-1 mt-4 ">
                                <div class="d-flex justify-end">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn x-small fab color="primary"  @click="abre_janela_modal(true, false, 'ALUNOS', 'CADASTRO')" v-bind="attrs" v-on="on">
                                            <v-icon>mdi-account-search </v-icon>
                                            </v-btn>
                                        </template>
                                        <span> Procurar Cadastro </span>
                                    </v-tooltip>
                                </div>
                            </v-col>
    
                        </v-row>
                    </v-card>    

                    <v-divider class="mx-1"/>


                    <v-row dense v-if="(lista_aulas_aluno.length > 0)" class="blue mr-0">
                        <v-col class="red lighten-5 px-0 pl-1" cols="12">
                            <template>
                            <v-card 
                                flat
                                elevation="4"
                                class="grey lighten-3"
                                >
                                <v-expansion-panels 
                                    :multiple="false"
                                    :focusable='false'
                                    v-model="value_expansion_2"
                                    >


                                        <!-- LISTA DE AULAS -->
                                        <v-expansion-panel>
                                            <v-expansion-panel-header 
                                            class="pa-2 px-1"
                                            style="min-height: 28px"
                                            >

                                                <div v-if="2>1">
                                                <v-row>
                                                    <v-col cols="12">
                                                        <!-- <v-icon size="30" class="pr-1" color="primary"> 
                                                        mdi-chart-line-variant 
                                                        </v-icon>  -->
                                                        

                                                        <span>

                                                            <div class="fs-12 pb-1 ml-0" >                                                                
                                                                <!-- {{ cadastro_selecionado.DESCRICAO }}  -->
                                                                <v-chip small @click.stop="" v-if="cadastro_selecionado.DESCRICAO"> {{cadastro_selecionado.DESCRICAO || ''}} </v-chip> |
                                                                <v-chip small @click.stop="" color=""> {{tipo_selecionado}} </v-chip>
     
                                            
                                                            </div>

                                                            <v-icon
                                                            size="33"
                                                            color="blue darken-2"
                                                            @click.stop=""
                                                            class="pl-1"
                                                            @click="monta_menu_de_tabelas('menu_aulas')"
                                                            >
                                                              mdi-menu
                                                            </v-icon>


                                                            <span class="bold mx-1" @click.stop=""> {{ lista_aulas_aluno.length }} </span>

                                                            <v-chip color="primary" small v-if="categoria_filtrar!==''" class="mx-1" @click.stop="" @click="categoria_filtrar='', aulas_alunos(cadastro_selecionado.CODIGO_ALUNO || cadastro_selecionado.CODIGO)" 
                                                                :color="cor_limite('D')">
                                                                TUDO
                                                            </v-chip>

                                                            <v-chip  small v-if="lista_aulas_aluno[0].TOTAL_A>0"  @click.stop="" @click="categoria_filtrar='A', aulas_alunos(cadastro_selecionado.CODIGO_ALUNO || cadastro_selecionado.CODIGO)"
                                                                :color="cor_limite('A')">
                                                                {{ lista_aulas_aluno[0].TOTAL_A }} A
                                                            </v-chip>
                                                            
                                                            <v-chip color="primary" small v-if="lista_aulas_aluno[0].TOTAL_B>0" class="ml-1" @click.stop="" @click="categoria_filtrar='B', aulas_alunos(cadastro_selecionado.CODIGO_ALUNO || cadastro_selecionado.CODIGO)" 
                                                                :color="cor_limite('B')">
                                                                {{ lista_aulas_aluno[0].TOTAL_B }} B
                                                            </v-chip>
                                                            
                                                            <v-chip color="primary" small v-if="lista_aulas_aluno[0].TOTAL_C>0" class="ml-1" @click.stop="" @click="categoria_filtrar='C', aulas_alunos(cadastro_selecionado.CODIGO_ALUNO || cadastro_selecionado.CODIGO)" 
                                                                :color="cor_limite('C')">
                                                                {{ lista_aulas_aluno[0].TOTAL_C }} C
                                                            </v-chip>
                                                            
                                                            <v-chip color="primary" small v-if="lista_aulas_aluno[0].TOTAL_D>0" class="ml-1" @click.stop="" @click="categoria_filtrar='D', aulas_alunos(cadastro_selecionado.CODIGO_ALUNO || cadastro_selecionado.CODIGO)" 
                                                                :color="cor_limite('D')">
                                                                {{ lista_aulas_aluno[0].TOTAL_D }} D
                                                            </v-chip>
                                                            
                                                            <v-chip color="primary" small v-if="lista_aulas_aluno[0].TOTAL_E>0" class="ml-1" @click.stop="" @click="categoria_filtrar='E', aulas_alunos(cadastro_selecionado.CODIGO_ALUNO || cadastro_selecionado.CODIGO)" 
                                                                :color="cor_limite('E')">
                                                                {{ lista_aulas_aluno[0].TOTAL_E }} D
                                                            </v-chip>

                                                        </span>

                                                        

                                                    </v-col>
                                                </v-row>
                                                </div>
                                            </v-expansion-panel-header>

                                            <v-expansion-panel-content>
                                                <!-- class="py-0 ma-0" -->

                                                <v-container>


                                            <v-row class="mt-1 px-0" v-if="0>1">
                                                <v-col cols="12">
                                                        <!-- <v-icon size="30" class="pr-1" color="primary"> 
                                                        mdi-chart-line-variant 
                                                        </v-icon>  -->
                             

                                                    </v-col>
                                                </v-row>


                                                    <v-row>
                                                    <v-col class="px-0 py-0  ">

                                                    <v-list
                                                        dense
                                                        :height="altura_desse(260, 520)"
                                                        class="overflow-y-auto px-0 py-0"
                                                        >
                                                        <v-list-item-group active-class="border">

                                                            <v-list-item
                                                            v-for="(item, i) in lista_aulas_aluno"
                                                            :key="i"
                                                            class="px-0 py-0 grey lighten-5"
                                                            style="min-height: 30px !important;"
                                                            @contextmenu.prevent="monta_menu_de_tabelas('agenda'), rightClick(item, $event)"
                                                            @click="monta_menu_de_tabelas('agenda'), seleciona_linha(item)"
                                                            >

                                                            <v-list-item-content class="py-0 mx-1">
                                                                <!-- <div> -->
                                                                <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                                                    <v-row>

                                                                    <v-col cols="1" class=""> 
                                                                        <span style="text-align: right; font-size: 9px;" class="grey--text pl-1  "> {{ i + 1 }}º &nbsp </span>
                                                                    </v-col>

                                                                    <v-col cols="10" class="">

                                                                        <span class="fs-11 bold">
                                                                            {{ item.xx_DATA }}
                                                                        </span>

                                                                        <span class="fs-11 ml-1">
                                                                            {{ item.HORA }}
                                                                        </span>
                                                                        

                                                                        <!-- <span v-if="tipo_selecionado=='TODOS'">
                                                                            <span class="fs-11 ml-1 bold">
                                                                               <span :style="{'color': retorna_cor_tipo(item.TIPO)}">
                                                                                {{ item.TIPO }}
                                                                               </span> 
                                                                            </span>
                                                                        </span> -->
                                                                        <span v-if="tipo_selecionado!=='TODOS'">
                                                                            <span class="fs-11 ml-1 bold">
                                                                                {{ item.CATEGORIA }}
                                                                            </span>
                                                                        </span>

                                                                        <span class="fs-11 ml-1 bold">
                                                                            {{ item.x_PLACA }}
                                                                        </span>


                                                                        <span class="fs-11 ml-1 ">
                                                                            {{ item.x_INSTRUTOR }}
                                                                        </span>


                                                                        <span class="fs-11 ml-1 bold" v-if="tipo_selecionado=='TODOS'">
                                                                            <span :style="{'color': retorna_cor_tipo(item.TIPO)}">
                                                                            {{ item.TIPO }}
                                                                            </span> 
                                                                        </span>


                                                                    </v-col>

                                            
                                                                    </v-row>
                                                                </div>

                                                                <v-divider class="mx-0"/>
                                                            </v-list-item-content>
                                                            </v-list-item>




                                                        </v-list-item-group>
                                                        </v-list>

                                                    </v-col>
                                                    </v-row>
                                                </v-container>

                                            </v-expansion-panel-content>
                                        </v-expansion-panel>


                                </v-expansion-panels>
                            </v-card>
                            </template>
                        </v-col>
                    </v-row>
                  </div>


                  <div v-if="tipo_de_cliente=='CHAMADA'" class=" pa-0">

                    <v-card flat  elevation="4" class="white lighten-5 mt-1">
                        
                        <v-container class="">
                                
                            <v-row dense class="">
                                <v-col cols="7" class="pb-2 pt-1">
                                    <v-text-field
                                    v-model="procurar"
                                    label="Procurar"
                                    dense
                                    clearable
                                    append-icon="mdi-magnify"
                                    :hide-details="true"
                                    @keyup.esc="procurar=''"
                                    @click:clear="procurar=''"
                                    >
                                    <!-- @keypress.enter="estatisticas_recibos(procurar_recibo)" -->
                                    <!-- @click:append="estatisticas_recibos(procurar_recibo)" -->
                                    </v-text-field>
                                </v-col>

                                <v-spacer></v-spacer>
                                <v-col cols="2" class="">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">

                                            <v-btn x-small fab color="primary" class="" @click="nova_tabela('item_edita','dialog_tabela')"
                                            v-bind="attrs" v-on="on"
                                            >
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>

                                        </template>
                                        <span> Nova Chamada </span>
                                    </v-tooltip>
                                </v-col>

                                <!-- {{items_lista}} -->
                            </v-row>

                        </v-container>
                    </v-card>

                    <v-card flat  elevation="4" class="grey lighten-3 mt-1">

                        <v-container class="pa-1">
                            <v-row dense class="">
                                <v-col>
                                    <!-- PASSO 5 -->
                                    <v-data-table
                                        v-model="selected"
                                        item-key="CODIGO"
                                        @click:row="seleciona_chamada"

                                        :headers="items_header"
                                        :items="items_lista"
                                        :search="procurar"

                                        class="elevation-1 pl-1"
                                        :items-per-page="-1"
                                        
                                        :mobile-breakpoint="55"
                                        hide-default-footer
                                        dense
                                        :height="(isMobile)? '250' : retorna_altura(280)"
                                        >


                                        <template v-slot:item.HORA="{ item }">
                                            <v-chip small class="bold px-2" >
                                                {{ item.HORA }} 
                                            </v-chip>
                                        </template>

                                        <template v-slot:item.DESCRICAO="{ item, index }">

                                            <v-icon
                                                class="mr-0"
                                                color="blue"
                                                :size = "size_mobile"
                                                v-if="pode_alterar(tabela_selecionada)"
                                                @click="editar_tabela(item, 'item_edita', 'dialog_tabela')"
                                            >
                                            mdi-pencil
                                            </v-icon>

                                            <!-- <span style=" text-align: right; font-size: 8px;" class="grey--text pa-0 mt-2 ml-n2 mr-1"> {{ index + 1 }}º </span>   -->

                                            <a class="font-weight-medium fs-8">{{ item.CODIGO }} </a> -
                                            <a class="font-weight-medium fs-13">{{ item.x_NOME_FORNECEDOR }} </a>
                                            <a class="font-weight-medium fs-9 ml-1">{{ item.double_VALOR }} </a>

                                        </template>


                                    </v-data-table>
                                </v-col>
                            </v-row>
                            </v-container>
                    </v-card>
                      
                  </div>



                </div>

                

                <!-- calendario semana -->
                <div class="item-7 red lighten-5 " :class="[(tipo_de_cliente=='CHAMADA') ? 'grey lighten-5':'']">

                    <div>
                        <v-row dense class="" v-if="2>1">

                           
                          <v-col cols="5" md="2" class=" ma-0 " v-if="(tipo_de_cliente=='CFC')">
                            <div class="d-flex ">
                            <!-- height="54" -->
                            <v-btn
                                icon
                                class="ma-2"
                                @click="muda_dia('prev')"
                                >
                                <!-- @click="$refs.calendar1.prev()" -->
                                <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>

                            <v-select
                                v-model="type"
                                :items="viewOptions"
                                dense
                                :outlined="false"
                                hide-details
                                class="mt-4"
                                label="Tipo"
                                v-if="2>1"
                            >
                        
                            <template v-slot:selection="{ item }">
                                <div class="fs-12">{{ item.text }}</div> <!-- Usando a classe para diminuir a fonte -->
                            </template>

                            </v-select>


                            <v-spacer></v-spacer>
                            <v-btn
                                icon
                                class="ma-2"
                                @click="muda_dia('next')"
                                >
                                <!-- @click="$refs.calendar1.next()" -->
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>

                            </div>
                          </v-col>


                          
                          <v-col cols="auto"  class="pt-4 " v-if="(tipo_de_cliente=='CFC')">
                            <v-chip color="secondary" small > {{ mes_selecionado }} </v-chip>
                            <v-chip color="primary" small class="ml-1" @click="clicou_hoje()">Hoje</v-chip>
                          </v-col>

                          <v-col cols="auto"  class="pt-3 " v-if="(tipo_de_cliente=='CFC')">
                            <v-icon
                            size="33"
                            color="blue darken-2"
                            @click.stop=""
                            class=""
                            @click="monta_menu_de_tabelas('menu_geral')"
                            >
                            mdi-menu
                            </v-icon>
                            <span  class="count_item fs-14 bold  ml-n1 "> 2 </span>
                          </v-col>


                          <v-col cols="2" md="1" class="pt-4  pl-3 " v-if="(obj_user.SUPER=='S')">
                            
                            <div class="" v-if="(tipo_de_cliente=='CFC')">
                                    <v-tooltip bottom eager>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-checkbox
                                            v-model="agendar_simultaneo"
                                            label="Simultâneo"
                                            dense
                                            class="ma-0 pa-0"
                                            hide-details=""
                                            @change="tabela('agenda')"
                                            
                                            >
                                            <template v-slot:label>
                                                <span :class="['fs-12 ml-n2']" v-bind="attrs" v-on="on">Simultâneo</span>
                                            </template>
                                            </v-checkbox>
                                        </template>
                                            <span>Permite agendar no mesmo horário simultâneamente</span>
                                    </v-tooltip>

                                    </div>

                          </v-col>

                          <v-col cols="auto"  class="pt-4  pl-3 " v-if="(mostrar_dupla) && (type=='day')">
                             
                            
                            <div class="">
                                <v-row>
                                   
                                   <v-col cols="auto" class="">

                                       <v-tooltip bottom eager>
                                           <template v-slot:activator="{ on, attrs }">

                                               <v-checkbox
                                               v-model="agenda_multipla"
                                               label="Multipla"
                                               dense
                                               class="ma-0 pa-0"
                                               hide-details=""
                                               @change="tabela('agenda'), initScrollSync()"
                                               @click="clicou_em('agenda_multipla')"
                                               on-icon="mdi-checkbox-marked"
                                               off-icon="mdi-checkbox-blank-outline"
                                               
                                               >
                                               <template v-slot:label>

                                                    <span :class="['fs-12 ml-n2']" v-bind="attrs" v-on="on">Multipla</span>
                                                   
                                                    <v-icon size="20" class="ml-2" color="primary"
                                                     @click="clicou_menu_de_tabelas('filtrar_multipla_agenda')"
                                                     @click.stop=""
                                                   >
                                                    mdi-information
                                                    <!-- mdi-dots-vertical -->
                                                   </v-icon>

                                               </template>
                                               </v-checkbox>
                                           </template>
                                               <span>Mostrar Agenda Multipla</span>
                                       </v-tooltip>
                                   
                                   </v-col>
                                   <v-col cols="auto">
                                         <v-chip  color="success" class="py-0" v-if="(0>1)">
                                            {{ formata_dia_da_semana(in_today) }}
                                        </v-chip>
                                   </v-col>
                                </v-row>
                            </div>


                          </v-col>


                          <v-col class="ml-auto" cols="auto" v-if="(!isMobile) && (0>1)">
                              <v-chip
                                class="ma-2"
                                color="error"  
                                href="https://youtu.be/PdhW4sLRkwc"
                                target="_blank"
                              >
                                <v-icon left color="white">
                                  mdi-youtube
                                </v-icon>
                                Tutorial
                              </v-chip>
                          </v-col>

                        </v-row>

                    


                        <div :class="[
                            'container-calendarios',
                            { 'modo-scroll': modoScrollHorizontal }
                        ]"

                        >

                            <div :class="{'calendarios' : agenda_multipla}" v-if="(agenda_multipla && tipo_de_cliente=='CFC')" class="">

                                <div :class="{'coluna' : agenda_multipla}"   
                                
                                    v-for="(veiculo, index) in veiculosFiltrados"
                                    :key="veiculo.CODIGO"
                                    class="coluna"
                                    :style="{ flex: `0 0 ${larguraColuna}`, minWidth: larguraColuna }"

                                >
                                    <!-- style="max-width:400px" -->
                                                    <v-sheet :height=retorna_altura(-20) class="red pa-0 " v-if="2>1">

                                                    <!-- 🔥 NOME DO VEÍCULO -->
                                                    <h5 class="text-center  font-weight-bold py-1 grey lighten-3"
                                                        @click="seleciona_veiculo_coluna(veiculo.CODIGO)"
                                                    >
                                                        <v-chip small color="primary"
                                                            @click="seleciona_veiculo_coluna(veiculo.CODIGO)"
                                                        >
                                                            {{ veiculo.PLACA }} ({{ veiculo.NOME }})
                                                            <span class="fs-8 pl-1">{{veiculo.CATEGORIA}}</span>
                                                            <!-- <span class="fs-8 pl-1">{{veiculo.CODIGO}}</span> -->
                                                        </v-chip>
                                                    </h5>

                                                    <!-- ref="calendar1" -->
                                                    <!-- :ref="veiculo.CODIGO" -->
                                                    <!-- {{veiculo.CODIGO}} -->
                                                    <v-calendar

                                                        
                                                        :ref="'calendar-' + veiculo.CODIGO"
                                                        :id="'calendar-'+ veiculo.CODIGO"
                                                        v-model="selectedDate"
                                                        locale="pt-br"
                                                        :weekdays="weekday"
                                                        

                                                        :events="eventosPorVeiculo(veiculo)"


                                                        :type="type"
                                                        :event-overlap-mode="mode"
                                                        :event-overlap-threshold="30"
                                                        :event-color="getEventColor"
                                                        :show-interval-label="showIntervalLabel"
                                                        first-day-of-week="4"

                                                        :interval-format="intervalFormat"

                                                        :interval-count="lista_horarios.length"
                                                        :interval-height="interval_height"
                                                        :interval-minutes="interval_minutes"
                                                        :first-time="first_time"
                                                        

                                                        @change="getEvents"
                                                        @click:event="abre_evento"
                                                        @click:more="viewDay"
                                                        @click:date="go_menu_data_clicada"
                                                        
                                                        @click:time="(payload) => pre_clicou_hora(payload, 'calendar-' + veiculo.CODIGO)"
                                                        
                                                    >
                                                    <!-- @click:event="showEvent" -->
                                                    <!-- @click:time="clicou_hora" -->
                                        


                                                    <template v-slot:day-body="{ date, week }">
                                                        <div v-for="(time, i) in horarios_veiculo.HORARIOS" :key="i" class="v-current-time"    
                                                            
                                                                :class="{ first: date === week[0].date }"
                                                                :style="{ top: calculateTop(time) }"> 
                                                                <!-- {{ time }} -->
                                                        </div>
                                                    </template>

                                                    
                                                    <!-- <template v-slot:day-body="{ date, week}">
                                                        <div
                                                        class="v-current-time"
                                                        :class="{ first: date === week[0].date }"
                                                        :style="{ top: nowY }"
                                                        > 
                                                        {{ week[0].date }}
                                                        {{ nowY }}
                                                        </div>
                                                    </template> -->

                                                    <!-- <template v-slot:day-body="{ date, week}">
                                                        <div
                                                        class="v-current-time"
                                                        :class="{ first: date === week[0].date }"
                                                        :style="{ top: nowY }"
                                                        > 
                                                        {{ day }}
                                                        </div>
                                                    </template> -->

                                                    <!-- <template v-slot:event="{ event }">
                                                        <div class="custom-event" :style="{ backgroundColor: event.color }">
                                                            {{ event.name }}
                                                        </div>
                                                    </template> -->



                                                    <template v-slot:event="{ event }">
                                                        <div class="pa-1 pt-0 "
                                                        
                                                        :class="{
                                                            left: event.x_PLACA === 'BCX-8J17',
                                                            right: event.x_PLACA === 'BCY-0D57'
                                                            }"
                                                        >
                                                            <!-- style="max-width:50%" -->
                                                            <!-- <v-icon>mdi-calendar</v-icon> Exemplo: ícone -->

                                                            <span v-if="event.TIPO!=='AGENDA'" class="">
                                                                <v-avatar  class="white pa-0" size="26" 
                                                                v-if="(event.x_FOTO_URL_INSTRUTOR)"
                                                                >
                                                                    <v-img
                                                                        alt="..."
                                                                        contain
                                                                        :src="event.x_FOTO_URL_INSTRUTOR"
                                                                        class="hand pa-2">
                                                                    </v-img>
                                                    

                                                                </v-avatar>

                                                                <!-- <v-icon size="32" v-else class="">
                                                                    mdi-account-circle
                                                                </v-icon> -->

                                                                <span v-else  class="caption ml-1">
                                                                    <!-- <span> {{ event.HORA }} </span> -->
                                                                    <v-chip x-small class="px-1 mt-n1 mr-1 " style="height:13px"> {{ event.x_NOME_INSTRUTOR }} </v-chip>
                                                                </span>
                                                                

                                                                <span class="caption ml-1">
                                                                    {{ event.x_PLACA }} ({{ event.CATEGORIA }})
                                                                </span>

                                                            </span>
                                                            

                                                            <div 
                                                            :class="['caption ml-1 mt-n2 fs-10 ' + cor_cadastro(event) ]"
                                                            >


                                                            <span class=" pt-2 ">
                                                            {{ (event.CODIGO_ALUNO > 0 ) ? event.CODIGO_ALUNO : '' }} 
                                                            </span>

                                                            <!-- nao vou mostrar foto do aluno aqui por enquanto -->
                                                            <!-- <span class="pt-2" v-if="(cadastro_selecionado.FOTO_URL) && (event.CODIGO_ALUNO == cadastro_selecionado.CODIGO_ALUNO) ">
                                                                <v-avatar  class="white pa-0" size="32" >
                                                                    <v-img
                                                                        alt="..."
                                                                        contain
                                                                        :src="cadastro_selecionado.FOTO_URL"
                                                                        class="hand pa-2">
                                                                    </v-img>
                                                    

                                                                </v-avatar>
                                                            </span> -->


                                                            <span v-if="event.CODIGO_ALUNO>0" class="fs-10">
                                                                {{ event.ALUNO || event.DESCRICAO}}
                                                            </span> 

                                                            <div class="mb-1 red" v-if="event.TIPO=='AGENDA'"></div>

                                                                <div class="caption ml-1 mt-n1">
                                                                    <!-- <span> {{ event.HORA }} </span> -->
                                                                    <v-chip x-small class="px-1 mt-n1 mr-1" style="height:13px"> {{ event.HORA }} </v-chip>
                                                                    <v-chip x-small class="px-1 mt-n1 mr-1" style="height:13px" :color="retorna_cor_tipo(event.TIPO)" dark> {{ event.TIPO }} </v-chip>
                                                                    

                                                                    <!-- mostra anotação -->
                                                                    <span v-if="event.DESCRICAO">
                                                                        <v-tooltip  bottom>
                                                                            <template v-slot:activator="{ on, attrs }">
                                                                            <v-chip
                                                                                color="yellow"  x-small
                                                                                class="mt-n1"
                                                                                v-bind="attrs" v-on="on"
                                                                            >
                                                                                <v-icon             
                                                                                    class="pt-0"
                                                                                    size="14"
                                                                                    color="red"
                                                                                >
                                                                                    <!-- mdi-google-maps  -->
                                                                                    <!-- mdi-note-alert  -->
                                                                                    mdi-pin
                                                                                </v-icon> 
                                                                            </v-chip> 
                                                                            </template>
                                                                            <span> {{ event.DESCRICAO }}  </span>
                                                                            <!-- <p v-html=quebra_linha(event.DESCRICAO) ></p> -->
                                                                            <!-- align="center" -->
                                                                            <!-- <p v-html="edita_cadastro.OBSERVACAO" v-if="edita_cadastro.OBSERVACAO.length<190" ></p> -->
                                                                            <!-- <span v-else> Clique pra ver </span> -->

                                                                        </v-tooltip>
                                                                        </span>

                                                                </div>

                                                                <span v-if="event.TIPO=='AGENDA'">
                                                                    {{ event.DESCRICAO}}
                                                                </span> 
                                                            </div>

                                                        </div>
                                                    </template>


                            <!-- Slot customizado de evento -->
                                <!-- <template v-slot:event="{ event }">
                                <div
                                    class="evento"
                                    :class="{
                                    'left': event.x_PLACA === 'BCX-8J17',
                                    'right': event.x_PLACA === 'BCY-0D57'
                                    }"
                                >
                                    {{ event }}
                                </div>
                                </template> -->


                                

                                                    </v-calendar>
                                                    </v-sheet>
                                </div>
                            </div>

                        </div>

                                        
                        <div :class="{'calendarios' : agenda_multipla}" v-if="(!agenda_multipla && tipo_de_cliente=='CFC')" >
                            <div 
                            :class="{'coluna' : agenda_multipla}"   
                            >

                                                <v-sheet :height=retorna_altura(-20) class="red pa-0 " v-if="2>1">
                                                <v-calendar

                                                    ref="calendar1"
                                                    v-model="selectedDate"
                                                    locale="pt-br"
                                                    :weekdays="weekday"
                                                    
                                                    :type="type"
                                                    :events="items_eventos"
                                                    :event-overlap-mode="mode"
                                                    :event-overlap-threshold="30"
                                                    :event-color="getEventColor"
                                                    :show-interval-label="showIntervalLabel"
                                                    first-day-of-week="4"

                                                    :interval-format="intervalFormat"

                                                    :interval-count="lista_horarios.length"
                                                    :interval-height="interval_height"
                                                    :interval-minutes="interval_minutes"
                                                    :first-time="first_time"
                                                    

                                                    @change="getEvents"
                                                    @click:event="abre_evento"
                                                    @click:more="viewDay"
                                                    @click:date="go_menu_data_clicada"
                                                    
                                                    @click:time="(payload) => pre_clicou_hora(payload, 'calendar1')"
                                                    
                                                >
                                                <!-- @click:event="showEvent" -->
                                                <!-- @click:time="clicou_hora" -->
                                    
                        <template v-slot:day-header="{ day }">
                            <div style="text-align: center;" v-if="agenda_multipla">

                            <div 
                                class="fs-18 bold"
                                style="
                                margin-top:-78px; 
                                margin-left: 120px; 
                                font-size: 10px;
                                color: blue;
                                "
                            >
                            <v-chip small color="success" class="py-0" style="height:18px">
                                    {{ placa_1 }}
                            </v-chip>
                                
                            </div>
                            </div>
                        </template>



                                                <template v-slot:day-body="{ date, week }">
                                                    <div v-for="(time, i) in horarios_veiculo.HORARIOS" :key="i" class="v-current-time"    
                                                        
                                                            :class="{ first: date === week[0].date }"
                                                            :style="{ top: calculateTop(time) }"> 
                                                            <!-- {{ time }} -->
                                                    </div>
                                                </template>

                                                
                                                <!-- <template v-slot:day-body="{ date, week}">
                                                    <div
                                                    class="v-current-time"
                                                    :class="{ first: date === week[0].date }"
                                                    :style="{ top: nowY }"
                                                    > 
                                                    {{ week[0].date }}
                                                    {{ nowY }}
                                                    </div>
                                                </template> -->

                                                <!-- <template v-slot:day-body="{ date, week}">
                                                    <div
                                                    class="v-current-time"
                                                    :class="{ first: date === week[0].date }"
                                                    :style="{ top: nowY }"
                                                    > 
                                                    {{ day }}
                                                    </div>
                                                </template> -->

                                                <!-- <template v-slot:event="{ event }">
                                                    <div class="custom-event" :style="{ backgroundColor: event.color }">
                                                        {{ event.name }}
                                                    </div>
                                                </template> -->



                                                <template v-slot:event="{ event }">
                                                    <div class="pa-1 pt-0 "
                                                    
                                                    :class="{
                                                        left: event.x_PLACA === 'BCX-8J17',
                                                        right: event.x_PLACA === 'BCY-0D57'
                                                        }"
                                                    >
                                                        <!-- style="max-width:50%" -->
                                                        <!-- <v-icon>mdi-calendar</v-icon> Exemplo: ícone -->

                                                        <span v-if="event.TIPO!=='AGENDA'" class="">
                                                            <v-avatar  class="white pa-0" size="26" 
                                                            v-if="(event.x_FOTO_URL_INSTRUTOR)"
                                                            >
                                                                <v-img
                                                                    alt="..."
                                                                    contain
                                                                    :src="event.x_FOTO_URL_INSTRUTOR"
                                                                    class="hand pa-2">
                                                                </v-img>
                                                

                                                            </v-avatar>

                                                            <!-- <v-icon size="32" v-else class="">
                                                                mdi-account-circle
                                                            </v-icon> -->

                                                            <span v-else  class="caption ml-1">
                                                                <!-- <span> {{ event.HORA }} </span> -->
                                                                <v-chip x-small class="px-1 mt-n1 mr-1 " style="height:13px"> {{ event.x_NOME_INSTRUTOR }} </v-chip>
                                                            </span>
                                                            

                                                            <span class="caption ml-1">
                                                                {{ event.x_PLACA }} ({{ event.CATEGORIA }})
                                                            </span>

                                                        </span>
                                                        

                                                        <div 
                                                        :class="['caption ml-1 mt-n2 fs-10 ' + cor_cadastro(event) ]"
                                                        >


                                                        <span class=" pt-2">
                                                        <!-- {{ (event.CODIGO_ALUNO > 0 ) ? event.CODIGO_ALUNO : '' }}  -->
                                                        {{ (event.CODIGO_ALUNO !=0 ) ? event.CODIGO_ALUNO : '' }} 
                                                        </span>

                                                        <!-- nao vou mostrar foto do aluno aqui por enquanto -->
                                                        <!-- <span class="pt-2" v-if="(cadastro_selecionado.FOTO_URL) && (event.CODIGO_ALUNO == cadastro_selecionado.CODIGO_ALUNO) ">
                                                            <v-avatar  class="white pa-0" size="32" >
                                                                <v-img
                                                                    alt="..."
                                                                    contain
                                                                    :src="cadastro_selecionado.FOTO_URL"
                                                                    class="hand pa-2">
                                                                </v-img>
                                                

                                                            </v-avatar>
                                                        </span> -->


                                                        <span v-if="event.CODIGO_ALUNO !=0" class="fs-10">
                                                            {{ event.ALUNO || event.DESCRICAO}} 
                                                        </span> 

                                                        <div class="mb-1 red" v-if="event.TIPO=='AGENDA'"></div>

                                                            <div class="caption ml-1 mt-n1">
                                                                <!-- <span> {{ event.HORA }} </span> -->
                                                                <v-chip x-small class="px-1 mt-n1 mr-1" style="height:13px"> {{ event.HORA }} </v-chip>
                                                                <v-chip x-small class="px-1 mt-n1 mr-1" style="height:13px" :color="retorna_cor_tipo(event.TIPO)" dark> {{ event.TIPO }} </v-chip>
                                                                

                                                                <!-- mostra anotação -->
                                                                <span v-if="event.DESCRICAO">
                                                                    <v-tooltip  bottom>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                        <v-chip
                                                                            color="yellow"  x-small
                                                                            class="mt-n1"
                                                                            v-bind="attrs" v-on="on"
                                                                        >
                                                                            <v-icon             
                                                                                class="pt-0"
                                                                                size="14"
                                                                                color="red"
                                                                            >
                                                                                <!-- mdi-google-maps  -->
                                                                                <!-- mdi-note-alert  -->
                                                                                mdi-pin
                                                                            </v-icon> 
                                                                        </v-chip> 
                                                                        </template>
                                                                        <span> {{ event.DESCRICAO }}  </span>
                                                                        <!-- <p v-html=quebra_linha(event.DESCRICAO) ></p> -->
                                                                        <!-- align="center" -->
                                                                        <!-- <p v-html="edita_cadastro.OBSERVACAO" v-if="edita_cadastro.OBSERVACAO.length<190" ></p> -->
                                                                        <!-- <span v-else> Clique pra ver </span> -->

                                                                    </v-tooltip>
                                                                    </span>

                                                            </div>

                                                            <span v-if="event.TIPO=='AGENDA'">
                                                                {{ event.DESCRICAO}}
                                                            </span> 
                                                        </div>

                                                    </div>
                                                </template>


                        <!-- Slot customizado de evento -->
                            <!-- <template v-slot:event="{ event }">
                            <div
                                class="evento"
                                :class="{
                                'left': event.x_PLACA === 'BCX-8J17',
                                'right': event.x_PLACA === 'BCY-0D57'
                                }"
                            >
                                {{ event }}
                            </div>
                            </template> -->


                            

                                                </v-calendar>
                                                </v-sheet>
                            </div>


                            <div :class="{'coluna' : agenda_multipla}"  style="margin-left:-17px;" v-if="(agenda_multipla)">
                                <!-- style="margin-left:-200px; max-width:400px" -->
                                                <v-sheet :height=retorna_altura(-20) class="red pa-0 " v-if="2>1">
                                                <v-calendar

                                                    ref="calendar2"
                                                    v-model="selectedDate"
                                                    locale="pt-br"
                                                    :weekdays="weekday"

                                                    class="calendar2"
                                                    
                                                    :type="type"
                                                    :events="items_eventos_2"
                                                    :event-overlap-mode="mode"
                                                    :event-overlap-threshold="30"
                                                    :event-color="getEventColor"
                                                    :show-interval-label="showIntervalLabel"
                                                    first-day-of-week="4"

                                                    :interval-format="intervalFormat"

                                                    :interval-count="lista_horarios.length"
                                                    :interval-height="interval_height"
                                                    :interval-minutes="interval_minutes"
                                                    :first-time="first_time"
                                                    

                                                    @change="getEvents"
                                                    @click:event="abre_evento"
                                                    @click:more="viewDay"
                                                    @click:date="go_menu_data_clicada"
                                                    
                                                    @click:time="(payload) => pre_clicou_hora(payload, 'calendar2')"
                                                    
                                                >
                                                <!-- @click:event="showEvent" -->
                                                <!-- @click:time="clicou_hora" -->
                                    

                        <template v-slot:day-header="{ day }">
                            <div style="text-align: center;" v-if="agenda_multipla">

                            <div 
                                class="fs-18 bold"
                                style="
                                margin-top:-78px; 
                                margin-left: 120px; 
                                font-size: 10px;
                                color: blue;
                                "
                            >
                            <v-chip small color="success" class="py-0" style="height:18px">
                                    {{ placa_2 }} 
                            </v-chip>
                                
                            </div>
                            </div>
                        </template>


                                                <template v-slot:day-body="{ date, week }">
                                                    <div v-for="(time, i) in horarios_veiculo.HORARIOS" :key="i" class="v-current-time"    
                                                        
                                                            :class="{ first: date === week[0].date }"
                                                            :style="{ top: calculateTop(time) }"> 
                                                            <!-- {{ time }} -->
                                                    </div>
                                                </template>

                                                
                                                <!-- <template v-slot:day-body="{ date, week}">
                                                    <div
                                                    class="v-current-time"
                                                    :class="{ first: date === week[0].date }"
                                                    :style="{ top: nowY }"
                                                    > 
                                                    {{ week[0].date }}
                                                    {{ nowY }}
                                                    </div>
                                                </template> -->

                                                <!-- <template v-slot:day-body="{ date, week}">
                                                    <div
                                                    class="v-current-time"
                                                    :class="{ first: date === week[0].date }"
                                                    :style="{ top: nowY }"
                                                    > 
                                                    {{ day }}
                                                    </div>
                                                </template> -->

                                                <!-- <template v-slot:event="{ event }">
                                                    <div class="custom-event" :style="{ backgroundColor: event.color }">
                                                        {{ event.name }}
                                                    </div>
                                                </template> -->





                                                <template v-slot:event="{ event }">
                                                    <div class="pa-1 pt-0">
                                                        <!-- <v-icon>mdi-calendar</v-icon> Exemplo: ícone -->

                                                        <span v-if="event.TIPO!=='AGENDA'" class="">
                                                            <v-avatar  class="white pa-0" size="26" 
                                                            v-if="(event.x_FOTO_URL_INSTRUTOR)"
                                                            >
                                                                <v-img
                                                                    alt="..."
                                                                    contain
                                                                    :src="event.x_FOTO_URL_INSTRUTOR"
                                                                    class="hand pa-2">
                                                                </v-img>
                                                

                                                            </v-avatar>

                                                            <!-- <v-icon size="32" v-else class="">
                                                                mdi-account-circle
                                                            </v-icon> -->

                                                            <span v-else  class="caption ml-1">
                                                                <!-- <span> {{ event.HORA }} </span> -->
                                                                <v-chip x-small class="px-1 mt-n1 mr-1 " style="height:13px"> {{ event.x_NOME_INSTRUTOR }} </v-chip>
                                                            </span>
                                                            

                                                            <span class="caption ml-1">
                                                                {{ event.x_PLACA }} ({{ event.CATEGORIA }})
                                                            </span>

                                                        </span>
                                                        

                                                        <div 
                                                        :class="['caption ml-1 mt-n2 fs-10 ' + cor_cadastro(event) ]"
                                                        >


                                                        <span class=" pt-2">
                                                        {{ (event.CODIGO_ALUNO != 0 ) ? event.CODIGO_ALUNO : '' }} 
                                                        </span>

                                                        <!-- nao vou mostrar foto do aluno aqui por enquanto -->
                                                        <!-- <span class="pt-2" v-if="(cadastro_selecionado.FOTO_URL) && (event.CODIGO_ALUNO == cadastro_selecionado.CODIGO_ALUNO) ">
                                                            <v-avatar  class="white pa-0" size="32" >
                                                                <v-img
                                                                    alt="..."
                                                                    contain
                                                                    :src="cadastro_selecionado.FOTO_URL"
                                                                    class="hand pa-2">
                                                                </v-img>
                                                

                                                            </v-avatar>
                                                        </span> -->


                                                        <span v-if="event.CODIGO_ALUNO !=0" class="fs-10">
                                                            {{ event.ALUNO || event.DESCRICAO}} 
                                                        </span> 

                                                        <div class="mb-1 red" v-if="event.TIPO=='AGENDA'"></div>

                                                            <div class="caption ml-1 mt-n1">
                                                                <!-- <span> {{ event.HORA }} </span> -->
                                                                <v-chip x-small class="px-1 mt-n1 mr-1" style="height:13px"> {{ event.HORA }} </v-chip>
                                                                <v-chip x-small class="px-1 mt-n1 mr-1" style="height:13px" :color="retorna_cor_tipo(event.TIPO)" dark> {{ event.TIPO }} </v-chip>
                                                                

                                                                <!-- mostra anotação -->
                                                                <span v-if="event.DESCRICAO">
                                                                    <v-tooltip  bottom>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                        <v-chip
                                                                            color="yellow"  x-small
                                                                            class="mt-n1"
                                                                            v-bind="attrs" v-on="on"
                                                                        >
                                                                            <v-icon             
                                                                                class="pt-0"
                                                                                size="14"
                                                                                color="red"
                                                                            >
                                                                                <!-- mdi-google-maps  -->
                                                                                <!-- mdi-note-alert  -->
                                                                                mdi-pin
                                                                            </v-icon> 
                                                                        </v-chip> 
                                                                        </template>
                                                                        <span> {{ event.DESCRICAO }}  </span>
                                                                        <!-- <p v-html=quebra_linha(event.DESCRICAO) ></p> -->
                                                                        <!-- align="center" -->
                                                                        <!-- <p v-html="edita_cadastro.OBSERVACAO" v-if="edita_cadastro.OBSERVACAO.length<190" ></p> -->
                                                                        <!-- <span v-else> Clique pra ver </span> -->

                                                                    </v-tooltip>
                                                                    </span>

                                                            </div>

                                                            <span v-if="event.TIPO=='AGENDA'">
                                                                {{ event.DESCRICAO}}
                                                            </span> 
                                                        </div>

                                                    </div>
                                                </template>


                            

                                                </v-calendar>
                                                </v-sheet>
                            </div>

                        </div>

                        <div v-if="(tipo_de_cliente=='CHAMADA')" class="ml-1">
                           <v-row class=" pa-2 mt-1" v-if="obj_clicado.CODIGO">
                             <v-col cols="12" md="9" class="grey lighten-3 pa-1">
                                <v-card class="mx-auto">
                                    <v-card-title>
                                        <v-icon color=""  class="mr-1">mdi-account </v-icon>

                                        <v-chip small color="">
                                            Contatos 
                                        </v-chip>
                                        
                                        <span v-if="obj_clicado.CODIGO && items_lista_2.length>0" class="mt-n3 ml-1 ">
                                            {{ items_lista_2.length }} 
                                        </span>
                                        
                                        <v-spacer/>
                                
                                        <span v-if="obj_clicado.CODIGO">
                                            
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">

                                                    <v-btn x-small fab color="primary" class="mr-5" 
                                                    v-bind="attrs" v-on="on"
                                                    @click="abre_janela_modal(true, false, 'ALUNOS', 'CADASTRO')"
                                                    >
                                                        <v-icon>mdi-account-search</v-icon>
                                                    </v-btn>

                                                </template>
                                                <span> Procurar Cadastro </span>
                                            </v-tooltip>

                                            <!-- chamada -->
                                            <v-menu offset-y>

                                                <template v-slot:activator="{ on: menu }">
                                                    <v-tooltip bottom :disabled="isMobile">
                                                        <template v-slot:activator="{ on: tooltip }">
                                                            <v-btn x-small fab color="primary" dark class="mr-5" 
                                                                v-on="{ ...tooltip, ...menu }"
                                                            >
                                                                <v-icon>
                                                                <!-- mdi-share-variant-outline  -->
                                                                    <!-- mdi-account-group -->
                                                                    <!-- mdi-account-details -->
                                                                    mdi-account-file-text
                                                                </v-icon>
                                                            </v-btn>

                                                        </template>
                                                        <span> Chamada </span>
                                                    </v-tooltip>
                                                </template>
                                                
                                                <v-list>
                                                <v-list-item
                                                    v-for="(item, index) in menu_link"
                                                    :key="index"
                                                    dense
                                                    @click="clicou_em(item.acao, item)"
                                                >

                                                    
                                                    <v-icon color="" v-if="(item.icon)" :color="item.icon_color" size="22" class="mr-2"> {{ item.icon }} </v-icon>

                                                    <v-list-item-title>
                                                    {{ item.title }}
                                                    <!-- <hr> -->
                                                    </v-list-item-title>


                                                </v-list-item>
                                                </v-list>
                                            </v-menu>

                                            <!-- presença -->
                                            <v-menu offset-y>

                                                <template v-slot:activator="{ on: menu }">
                                                    <v-tooltip bottom :disabled="isMobile">
                                                        <template v-slot:activator="{ on: tooltip }">
                                                            <v-btn x-small fab color="green" dark class="mr-5" 
                                                                v-on="{ ...tooltip, ...menu }"
                                                            >
                                                                <v-icon>
                                                                  <!-- mdi-account-multiple-check -->
                                                                   mdi-account-group
                                                                </v-icon>
                                                            </v-btn>

                                                        </template>
                                                        <span> Lista de Presença </span>
                                                    </v-tooltip>
                                                </template>
                                                
                                                <v-list>
                                                <v-list-item
                                                    v-for="(item, index) in menu_presenca"
                                                    :key="index"
                                                    dense
                                                    @click="clicou_em(item.acao, item)"
                                                >

                                                    
                                                    <v-icon color="" v-if="(item.icon)" :color="item.icon_color" size="22" class="mr-2"> {{ item.icon }} </v-icon>

                                                    <v-list-item-title>
                                                    {{ item.title }}
                                                    <!-- <hr> -->
                                                    </v-list-item-title>


                                                </v-list-item>
                                                </v-list>
                                            </v-menu>
                                            
                                            <!-- relatorio -->
                                            <v-menu offset-y>

                                                <template v-slot:activator="{ on: menu }">
                                                    <v-tooltip bottom :disabled="isMobile">
                                                        <template v-slot:activator="{ on: tooltip }">
                                                            <v-btn x-small fab color="primary" dark class="mr-5" 
                                                                v-on="{ ...tooltip, ...menu }"
                                                            >
                                                                <v-icon >
                                                                    mdi-printer
                                                                </v-icon>
                                                            </v-btn>

                                                        </template>
                                                        <span> Relatórios </span>
                                                    </v-tooltip>
                                                </template>

                                                <v-list>
                                                <v-list-item
                                                    v-for="(item, index) in menu_nomes"
                                                    :key="index"
                                                    dense
                                                    @click="clicou_em(item.acao)"
                                                >

                                                    <v-icon color="" v-if="(item.icon)" :color="item.icon_color" size="22" class="mr-2"> {{ item.icon }} </v-icon>

                                                    <v-list-item-title>
                                                    {{ item.title }}
                                                    <!-- <hr> -->
                                                    </v-list-item-title>
                                                </v-list-item>
                                                </v-list>
                                            </v-menu>

   
                                    

                                            <v-tooltip bottom v-if="0>1">
                                                <template v-slot:activator="{ on, attrs }">

                                                    <v-btn x-small fab color="primary" class="ml-4" 
                                                    @click="nova_tabela('item_edita','dialog_tabela',2)"
                                                    v-bind="attrs" v-on="on"
                                                    >
                                                        <v-icon>mdi-plus</v-icon>
                                                    </v-btn>

                                                </template>
                                                <span> Adicionar Contato </span>
                                            </v-tooltip>
                                        </span>
                                    

                                    </v-card-title>


                                    <v-container class="elevation-4 mb-1 " v-if="obj_clicado.CODIGO">
                                        <v-row dense class="grey lighten-4"
                                        >
                                        <!-- :class="retorna_cor_qte()+' lighten-4'" -->

                                            <v-col class="pt-3 " md="6" cols="12">
                    
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                        
                                                    <v-icon
                                                    class="pb-1"
                                                    color="primary"
                                                    size="33"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    v-if="2>1"
                                                    >
                                                    mdi-menu
                                                    </v-icon>

                                                    </template>
                                                    <v-list>
                                                    <v-list-item
                                                        v-for="(item, index) in menu_abc"
                                                        :key="index"
                                                        dense
                                                        @click="clicou_em(item.acao)"
                                                    >

                                                        <v-icon color="" v-if="(item.icon)" :color="item.icon_color" size="22" class="mr-2"> {{ item.icon }} </v-icon>

                                                        <v-list-item-title>
                                                        {{ item.title }}
                                                        <!-- <hr> -->
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                    </v-list>
                                                </v-menu>

                                                <span class="font-weight-medium fs-15 primary--text pl-2">{{ obj_clicado.CODIGO }} - </span> 
                                                <span class="font-weight-medium text-h5 primary--text">{{ obj_clicado.x_NOME_FORNECEDOR }}</span>
                                                <span class="font-weight-medium fs-15 primary--text pl-2">{{ obj_clicado.DESCRICAO }} </span> 

                                                <!-- ATIVAR -->
                                                <span class="ml-4 mt-n2 fs-14" dark v-if="(texto_limite)" :class="retorna_cor_qte()+'--text'">
                                                     {{ texto_limite }}
                                                </span>

                                            </v-col>


                                            <v-col class="ml-auto" cols="12" md="4">
                                                <v-text-field
                                                class="mt-3"
                                                dense
                                                v-model="search_2"
                                                clearable
                                                append-icon="mdi-magnify"
                                                label="Procurar"
                                                single-line                
                                                hide-details
                                                @keyup.esc="search_2=''"
                                                @keyup="search_2 = search_2.toLowerCase()"
                                                >
                                                
                                                </v-text-field>
                                                </v-col>
                                            

                                        </v-row>
                                    </v-container>



                                    <v-card flat  elevation="4" class="grey lighten-3 mt-1" v-if="obj_clicado.CODIGO">

                                        <v-container class="pa-1">
                                            <v-row dense class="">
                                                <v-col>
                                                    <v-data-table
                                                        v-model="selected_2"
                                                        item-key="CODIGO"
                                                        @click:row="(item) => seleciona_linha(item, 2)"

                                                        :headers="items_header_2"
                                                        :items="items_lista_2"
                                                        :search="search_2"

                                                        class="elevation-1 pl-1"
                                                        :items-per-page="-1"
                                                        
                                                        :mobile-breakpoint="55"
                                                        hide-default-footer
                                                        dense
                                                        :height="(isMobile)? '350' : retorna_altura(116)"
                                                        >



                                                        <template v-slot:item.SITUACAO="{ item, index }">
                                                            <div @click="update_field(item,'sub_agenda','SITUACAO', true)">
                                                                <v-icon small color="green" v-if="(item.SITUACAO=='S')">
                                                                 mdi-check-bold 
                                                                </v-icon>
                                                                <v-icon small  v-else color="orange">
                                                                 mdi-radiobox-blank 
                                                                </v-icon>
                                                            </div>
                                                        </template>

                                                        <template v-slot:item.VISTO="{ item, index }">
                                                            <div @click="update_field(item,'sub_agenda','VISTO', true)">
                                                                <v-icon  color="green" v-if="(item.VISTO=='S')">
                                                                 <!-- mdi-check-bold  -->
                                                                  mdi-check-circle
                                                                </v-icon>
                                                                <v-icon   v-else color="orange">
                                                                 mdi-radiobox-blank 
                                                                </v-icon>
                                                            </div>
                                                        </template>

                                                        <template v-slot:item.CONTATO="{ item }">
     

                                                            <span class="px-1" v-if="item.CONTATO">
                                                                <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-icon color="green" size="20" class="mr-1 mb-0"
                                                                    @click="go_send_whats(item.CONTATO, item.NOME,false)"
                                                                    v-bind="attrs" v-on="on"
                                                                    >
                                                                        mdi-whatsapp
                                                                    </v-icon>
                                                                </template>
                                                                <span> Enviar WhatsApp </span>
                                                                </v-tooltip>
                                                            </span>

                                                            <a class="font-weight-medium fs-13 green--text">{{ item.CONTATO }}</a>

                                                        </template>


                                                        <template v-slot:item.actions="{ item, index }">
                                                            <v-icon
                                                                class="mr-2"
                                                                color="blue"
                                                                :size = "size_mobile"
                                                                v-if="pode_alterar(tabela_selecionada)"
                                                                @click="editar_tabela(item, 'item_edita', 'dialog_tabela', 2)"
                                                            >
                                                            mdi-pencil
                                                            </v-icon>

                                                            <span style=" text-align: right; font-size: 8px;" class="grey--text pa-0 mt-2 ml-n1"> {{ index + 1 }}º </span>  
                                                        </template>

                                                        <template v-slot:item.NOME="{ item }">

                                                            <v-icon size="20"
                                                                class="mb-1"
                                                                color="primary"
                                                                @click="abrir_cadastro(item.CODIGO_CADASTRO, true)"
                                                            >mdi-account</v-icon>

                                                            <a class="font-weight-medium fs-13" 
                                                              :class="[(item.SITUACAO=='N'? 'orange--text' : '')]"
                                                            >
                                                            {{ item.NOME }}</a>

                                                            <v-icon v-if="(item.x_STATUS=='RESTRICAO')" size="22" color="red" class="ml-2 mb-1"
                                                            @click="alerta(item.x_OBSERVACAO,'red')"
                                                            >
                                                                mdi-alert-box
                                                                <!-- mdi-alert-rhombus -->
                                                            </v-icon>
                                                        </template>


                                                    </v-data-table>
                                                </v-col>
                                            </v-row>
                                            </v-container>
                                    </v-card>

                                </v-card> 
                             </v-col>

                             <!-- PAINEL DIREITO -->
                             <v-col v-if="(obj_clicado.CODIGO) && (obj_clicado_2.CODIGO || isMobile)" cols="12" md="3" 
                               class="grey lighten-4"
                               :class="[(isMobile) ? 'mt-10':'']"
                             
                             >
                                
                                <v-card 
                                flat
                                elevation="5"
                                class="mt-n2 grey lighten-3"
                                >



                                <!-- <v-card-text class="white">
                                    <h4>Experiências</h4>
                                    <span>
                                        {{obj_clicado_2.x_OBSERVACAO_2}}
                                    </span>
                                </v-card-text> -->


                                <v-expansion-panels 
                                    :multiple="true"
                                    :focusable='false'
                                    v-model="value_expansion_3"
                                    >

                                    
                                    <!-- OBSERVACAO DO CADASTRO -->
                                    <v-expansion-panel>
                                        <v-expansion-panel-header 
                                        class="pa-2 px-4 bold"
                                        style="min-height: 28px">
                                            <div>
                                            <v-row>
                                                <v-col cols="12" md="12">
                                                    <!-- <span class="pa-1 yellow"> -->
                                                        <v-icon size="" color="red">
                                                        <!-- mdi-clipboard-text  -->
                                                        mdi-pin
                                                        </v-icon> 
                                                    <!-- </span> -->
                                                    &nbsp
                                                    Anotação do Cadastro
                                                </v-col>
                                            </v-row>
                                            </div>
                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content class="py-0 pa-0">
                                        <v-divider class="mb-2"></v-divider>

                                        <v-row dense class="">
                                            <v-col cols="12">
                                            <v-textarea v-if="(obj_clicado_2.x_OBSERVACAO)"
                                                dense
                                                v-model="obj_clicado_2.x_OBSERVACAO"
                                                background-color="amber lighten-5"
                                                readonly
                                                auto-grow
                                                rows="0"
                                                hide-details=""
                                                class="mt-n2"
                                            >
                                            </v-textarea>
                                            </v-col>
                                        

                                        </v-row>

                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                    <!-- EXPERIENCIAS -->
                                    <v-expansion-panel>
                                        <v-expansion-panel-header 
                                        class="pa-2 px-4 bold"
                                        style="min-height: 28px">
                                            <div>
                                            <v-row>
                                                <v-col cols="12" md="12">
                                                    <v-icon size="" color="orange">
                                                    <!-- mdi-clipboard-text  -->
                                                     mdi-account-hard-hat
                                                    </v-icon> 
                                                    &nbsp
                                                    Experiências e Habilidades
                                                </v-col>
                                            </v-row>
                                            </div>
                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content class="py-0 pa-0">
                                        <v-divider class="mb-2"></v-divider>

                                        <v-row dense class="">
                                            <v-col cols="12">
                                            <v-textarea v-if="(obj_clicado_2.x_OBSERVACAO_2)"
                                                dense
                                                v-model="obj_clicado_2.x_OBSERVACAO_2"
                                                background-color="amber lighten-5"
                                                readonly
                                                auto-grow
                                                rows="0"
                                                hide-details=""
                                                class="mt-n2"
                                            >
                                            </v-textarea>
                                            </v-col>
                                        

                                        </v-row>

                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                    <!-- EQUIPAMENTOS -->
                                    <v-expansion-panel>
                                        <v-expansion-panel-header 
                                        class="pa-2 px-4 bold"
                                        style="min-height: 28px">
                                            <div>
                                            <v-row>
                                                <v-col cols="12" md="12">
                                                    <v-icon size="" color="orange">
                                                    mdi-hard-hat
                                                    </v-icon> 
                                                    &nbsp
                                                    Equipamentos de EPI
                                                </v-col>
                                            </v-row>
                                            </div>
                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content class="py-0 pa-0">
                                        <v-divider class="mb-2"></v-divider>

                                        <v-row dense class="">
                                            <v-col cols="12">
                                            <v-textarea v-if="(obj_clicado_2.x_OBSERVACAO_3)"
                                                dense
                                                v-model="obj_clicado_2.x_OBSERVACAO_3"
                                                background-color="amber lighten-5"
                                                readonly
                                                auto-grow
                                                rows="2"
                                                hide-details=""
                                                class="mt-n2"
                                            >
                                            </v-textarea>
                                            </v-col>
                                        

                                        </v-row>

                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                    <!-- RESTRIÇÕES -->
                                    <v-expansion-panel>
                                        <v-expansion-panel-header 
                                        class="pa-2 px-4 bold"
                                        style="min-height: 28px">
                                            <div>
                                            <v-row>
                                                <v-col cols="12" md="12">
                                                    <v-icon size="" color="orange">
                                                    mdi-alert-box
                                                    </v-icon> 
                                                    &nbsp
                                                    Restrições
                                                </v-col>
                                            </v-row>
                                            </div>
                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content class="py-0 pa-0">
                                        <v-divider class="mb-2"></v-divider>

                                        <v-row dense class="">
                                            <v-col cols="12">
                                            <v-textarea v-if="(obj_clicado_2.x_OBSERVACAO_4)"
                                                dense
                                                v-model="obj_clicado_2.x_OBSERVACAO_4"
                                                background-color="amber lighten-5"
                                                readonly
                                                auto-grow
                                                rows="0"
                                                hide-details=""
                                                class="mt-n2"
                                            >
                                            </v-textarea>
                                            </v-col>
                                        

                                        </v-row>

                                        </v-expansion-panel-content>
                                    </v-expansion-panel>


                                </v-expansion-panels>
                                </v-card>

                             </v-col>
                           </v-row> 
                        </div>

                    </div>


                </div>
            </div>

        </section>



    <!-- MOSTRA JANELA MODAL -->
    <div class="mt-n10">
      <v-row>
        <v-col>
        <Editar_modal 
          :aberto = 'janela_modal_abre'
          :pro_tabela = 'janela_modal_tabela'
          :pro_titulo = 'janela_modal_titulo'
          :pro_obj_menus = null
          :show_menu = 'false'
          :pro_modo_edicao = 'janela_modo_edicao'
          @muda_aberto_lembretes="janela_modal_change"
        />
        </v-col>
      </v-row>
    </div>


    </div>
    </template>
    
    <script>
    
    import DSibasico from '../assets/js/DSi_basico'//chamo funcao do arquivo
    import {get_data_hora, copiarParaClipboard, abreviarDiaSemana, send_whats, mostrar_tipo_cliente, saudacao} from '../assets/js/DSi_basico'
    import {registra_log, negritoO} from '../assets/js/DSi_login'
    // import {enviar_whats_manual} from '../assets/js/DSi_whats'

    import DSisql from '../assets/js/DSi_sql'//chamo funcao do arquivo

    
    
    export default {

      components:{
        Editar_modal: () => import("./Editar.vue")
      },

      data: () => ({    
    
        dialog_ok:false,
        dialog_ok_tipo:'',

        tipo_de_cliente:'CFC',

        texto_limite:'⠀',

        chamada_selecionou:{},

        procurar:'',

        menu_nomes: [
          { title: 'Gerar Lista 1'         , acao: 'gerar_lista_1'          , icon:'mdi-format-list-bulleted', icon_color:'primary'},
          { title: 'Gerar Lista 2'         , acao: 'gerar_lista_2'          , icon:'mdi-format-list-bulleted', icon_color:'primary'},
          { title: 'Lista de Pagamento'    , acao: 'gerar_lista_3'          , icon:'mdi-format-list-bulleted', icon_color:'primary'},
        //   { title: 'Excluir Todos'       , acao: 'del_all_contatos'     , icon:'mdi-close-box'},
        ],

        menu_abc: [
          { title: 'Excluir Todos'       , acao: 'del_all_contatos'     , icon:'mdi-close-box', icon_color:'red'},
        ],

        menu_link: [
          { title: 'Abrir Link'           , acao: 'abrir_link'          , icon:'mdi-cellphone-link'},
          { title: 'Copiar Link'          , acao: 'copiar_link'         , icon:'mdi-content-copy'},
          { title: 'Compartilhar Link'    , acao: 'compartilhar_link'   , icon:'mdi-whatsapp'},
        ],

        menu_presenca: [
          { title: 'Abrir Link'           , acao: 'abrir_link_2'          , icon:'mdi-cellphone-link'},
          { title: 'Copiar Link'          , acao: 'copiar_link_2'         , icon:'mdi-content-copy'},
          { title: 'Compartilhar Link'    , acao: 'compartilhar_link_2'   , icon:'mdi-whatsapp'},
        ],

        modoScrollHorizontal: true,

        dialog_fields:  {
            EMPRESA: { CODIGO: 0, NOME: 'TODOS' },
            NOME :''
        },
        dialog_relatorios_acao:'',
        dialog_relatorios: false,
        rel_data_de: '',
        rel_data_ate: '',
        rel_instrutor: {CODIGO:'0', NOME:'TODOS'},
        rel_categoria:'TODOS',

        isSyncingScroll: false,

        agenda_show : false,

        agendar_simultaneo: false,
        agenda_multipla_memory: false,
        agenda_multipla: false,
        mostrar_dupla: false,
        mostrar_items_multipla:[],
        


        dia_clicou:'',

        obj_user: {},

        texto_1:'',
        item_horario_clicado:{},

        obj_dados_empresa: null,


        dialog_texto: false,
        dialog_menu: false,
        item_menu:{},
        menu_de_tabelas: [],
        menu_de_tabelas_selecionados: [],
        selecionou_varios: false,
        menu_selecionado:'',

        header_aulas_aluno : [
            { text: 'N', value: 'INDEX', width: '20px'},
            { text: 'DATA', value: 'xx_DATA', width: '30px'},
            { text: 'HORA', value: 'HORA',width: '40px'},
            { text: 'CAT', value: 'CATEGORIA', width: '40px'},
            { text: 'INSTRUTOR', value: 'x_INSTRUTOR', width:'80px'},
        ],



        aluno_selecionado:[],

        tipo_lista:[    
            'AULA',
            'AULA EXTRA',
            'EX.PRATICO',
            'INTERVALO',
            'ALMOÇO',
            'LIVRE',
            'BLOQUEAR',
            'BLOQUEAR DIA',
            'BLOQUEAR INSTRUTOR',
            'FERIAS',
            'AGENDA',
            'TODOS',
        ],


        value_expansion_1 : undefined, //0 ou null ou [ 1, 0 ]
        value_expansion_2 : null, //0 ou null ou [ 1, 0 ]
        value_expansion_3 : [0,1,2,3], //0 ou null ou [ 1, 0 ]
        expansion_selecionao:'',


        janela_modal_abre  : false,
        janela_modal_tabela: '',
        janela_modal_titulo: '',
        janela_modo_edicao : false,

        timeSlots: ['08:00', '09:50', '11:40'], // Array de horários desejados

        selectedDate: '2024-10-10', // Data padrão
        blockHeight: 50,
        daysOfWeek: [],
        scheduleHours: [
            "07:00", "07:30", "08:00", "08:10", "09:00", "09:10", "10:00", "10:30", 
            "10:50", "11:00", "11:50", "12:40", "13:40", "14:30", "15:30", 
            "16:20", "17:15", "18:05", "19:00", "19:55"
        ],

        eventsByDate: {},

        customTimes: [
         '07:30', '08:45', '10:30', '11:20' // Horários personalizados
        ],

        espaco : `⠀`,
        lista_horarios: [],
        lista_fornecedores: [],
        lista_instrutores: [],
        lista_veiculos: [],
        lista_veiculos_A: [],
        lista_veiculos_slim: [],
        lista_cadastros: [],
        lista_aulas_aluno: [],

        // horarios_veiculo :{}, aumentar o interval_count : "200" caso aumente o horario final
        horarios_veiculo : { "NOME": "TODOS", "DURACAO": "60", "LIMITE_DIA": 100000, "LIMITE_SEMANA": 100000, "LIMITE_TOTAL": 100000, "HORARIOS": [ "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00","21:00","22:00" ] },

        instrutor_selecionado:{'CODIGO':'0'},
        veiculo_selecionado:{'CODIGO':'0'},
        cadastro_selecionado:{'CODIGO':'0'},
        tipo_selecionado:'AULA',
        tipo_selecionado_2:'AULA',
        categoria_filtrar:'',

        filtrar_instrutor:true,
        filtrar_veiculo:false,

        dialog_img_mais:'',
        dialog_img_titulo:'',
        dialog_img_url:'',
        dialog_img: false,
 

        first_time :"07:00:00",
        interval_count : "200",//24 144passo um qt grande para gerar ate umas 21hs por ai
        interval_height : "5",//45 10 deixo o tamanho pequeno pois estou gerando de 5 minutos ALTURA DOS BLOCOS DE HORARIOS
        interval_minutes :"5",//45 5 minutos para gera varios horarios e depois filtrar os que estao no array


        ready: false,

        carregou : false,


        selectedDate: '',

        today : '',
        in_today : '',
        data_inicial:'',
        data_final:'',
        mes_selecionado:'',

        type: 'week', //week
        // types: ['month', 'week', 'day'],
        
        viewOptions: [
        { text: 'Mês', value: 'month' },
        { text: 'Semana', value: 'week' },
        { text: 'Dia', value: 'day' },
       ],

        mode: 'column',
        modes: ['stack', 'column'],
        weekday: [1, 2, 3, 4, 5, 6],
        weekdays: [{ text: 'Seg - Sab', value: [1, 2, 3, 4, 5, 6] },],
        

        value: '',
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        events: [],
        items_eventos: [],
        items_eventos_2: [],
        items_eventos_3: [],

        placa_1:'',
        placa_2:'',
        placa_3:'',

        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
        

        w_data: '99px',
        w_fone: '125px',
        w_cpf: '120px',
        w_cnpj: '150px',
        w_nome: '220px',
        w_situacao: '60px',
        w_valor: '90px',

        // ------------ TABELAS INICIO ---------------
        icone_tabela_sel:'',

        selectedItem: -1,
        card_titulo:'',

        dialog_tabela: false,
        tabela_selecionada:'',
        search: '',
        selected: [],
        items_lista:[],
        items_header: [],
        items_editaveis: [],
        item_edita: {},
        obj_clicado : {},

        items_editaveis_agora:{},
        tabela_selecionada_agora:'',


        dialog_tabela_2: false,
        tabela_selecionada_2:'',
        search_2: '',
        selected_2: [],
        items_lista_2:[],
        items_header_2: [],
        items_editaveis_2: [],
        item_edita_2: {},
        obj_clicado_2 : {},

        sub_codigo:0,
        sub_descricao:'',

        valido: false,
        
        size_mobile:22,

        notnullRules: [
        v => !!v || 'necessário'
        ],

        noRules:[v => true],


        // ------------ TABELAS FIM ---------------

        snackbar: false,
        snack_text: 'Nova Mensagem',
        snack_color: "success",

        }),
    
    
      created(){
        this.onCreated()
      },

      computed: {


        larguraColuna() {
            const total = this.veiculosFiltrados?.length || 1

            if (total <= 3) {
              return `calc(200% / ${total})` // ocupa tudo
            }
            
            else if (total <= 4) {
              return `calc(150% / ${total})` // ocupa tudo
            }
            
            else if (total <= 5) {
              return `calc(130% / ${total})` // ocupa tudo
            }

            return '220px' // ativa scroll quando tem muitos
        },


        // variavel que busca qual veiculos mostrar
        veiculosFiltrados() {
            // se não selecionou nada, pode retornar vazio ou tudo (você decide)


            // busco salvo no localstoreage
            try{ 
                this.mostrar_items_multipla = JSON.parse(localStorage['mostrar_items_multipla']) 
                // console.log('buscou do localStorage');
                // return this.mostrar_items_multipla

            } catch(e){}

            if (!this.mostrar_items_multipla || !this.mostrar_items_multipla.length) {
                // return []
                // return this.lista_veiculos
                // return this.lista_veiculos.filter(v => v.CODIGO !== '0')//todos menos o item TODOS
                return  this.lista_veiculos_slim.map((x) => x); //clonando array copiar array

            }

            const selecionadosIds = this.mostrar_items_multipla.map(v => v.CODIGO)

            return this.lista_veiculos
                .filter(v => 
                    v.PLACA !== 'TODOS' &&
                    selecionadosIds.includes(v.CODIGO)
                )
                .map(v => ({
                    ...v,
                    PLACA: (v.PLACA || '').trim(),
                    HORARIOS_ARRAY: (v.HORARIOS || '')
                        .split('\n')
                        .map(h => h.trim())
                        .filter(Boolean)
                }))
        },


        cal () {
            return this.ready ? this.$refs.calendar1 : null
        },

        // cal() {
        //     if (!this.ready) return [];

        //     return this.veiculosFiltrados
        //         .map(v => this.$refs?.[v.CODIGO])
        //         .filter(Boolean);
        // },

        nowY () {
            console.log('this.cal.times.now:', this.cal.times.now);
            
            return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
        },
      },

      mounted () {
        this.ready = true
        this.scrollToTime()
        this.updateTime()

        this.initScrollSync();

      },


      watch:{
           

        mostrar_items_multipla(a){
            // memorizo para usar depois
            localStorage['mostrar_items_multipla'] = JSON.stringify(a)
        },


        type(a){
            if (a=='day'){
                this.agenda_multipla = this.agenda_multipla_memory//volta ao estado anterior
                this.initScrollSync()
            }
            else{
                this.agenda_multipla = false
            }
        },

        cadastro_selecionado(a){

            setTimeout(function(){
                if (this.cadastro_selecionado.POSSUI_ATRASO =='SIM'){
                    this.alerta(`** Cadastro com Parcela Atrasada! **`,'red')
                    // alert(`Cadastro com Parcela Atrasada!`)
                }
            }.bind(this), 555);//2622
        },

        tipo_selecionado(a){
            if (['BLOQUEAR DIA', 'FERIAS'].some(el => a.includes(el)) ){
                //limpa os campos veiculo e cadastro

                this.veiculo_selecionado   =  { "CODIGO": "0", "NOME": "TODOS", "PLACA": "TODOS" }
                this.cadastro_selecionado  =  { "CODIGO": "0", "NOME": "NENHUM" }
            }
        },

        data_inicial(a){
        // data_final(a){
            // const data = new Date("2025-01-01");
            const data = new Date(`${a.date}T00:00:00`); // Garantir que será o dia 1 de janeiro sem deslocamento de fuso horário
            // const data = new Date(a.date);
            this.mes_selecionado  = data.toLocaleDateString("pt-BR", { month: "long" }).toUpperCase();

        },

        janela_modal_abre(a){
            // quando fecho a janela pode chamar uma funcao
            if (!a){
              this.acao_after_modal(this.janela_modal_tabela)//passo o nome da tabela
            }
        },

        value_expansion_1(a){
            sessionStorage['agenda_value_expansion_1']     = JSON.stringify(a)
        },

        veiculo_selecionado(a){
            this.transformarHorarios();
        },


        selectedDate(a){
            this.in_today = a
        },

        in_today(a){
            // console.log('change in_today');
            if (this.tipo_de_cliente=='CHAMADA'){
                this.clicou_calendario(a)
            }else{
                // quando é CFC ele pega pelo getEvents do v-calendar
            }
            
        }

      },
    

    
      methods:{


        moeda(event){
            // console.log('event:', event);
            
            let rr =  DSibasico.moeda(event)
            return rr
        },

        clicarPrimeiro(){

            if (!this.items.length) return

            this.selecionados = [this.items[0]]
        },

        async chama_dialog_ok(tipo){

          this.overlay = true
          setTimeout(function(){
              this.dialog_ok      = true
              this.dialog_ok_tipo = tipo
              this.overlay = false
          }.bind(this), 3000);
        },

        retorna_cor_qte(){

            // return 'grey'

            if ( (this.items_lista_2.length) > (this.obj_clicado.LIMITE * 1) ){
                this.texto_limite = 'Acima do Limite'
                return 'red'
            }
            else if ((this.obj_clicado.LIMITE * 1) == (this.items_lista_2.length)){
                this.texto_limite = 'Pronta'
                return 'primary'
            }
            else{
                this.texto_limite = '⠀'
                return 'grey'
            }
        },

        async update_field(item, tabela, field, perguntar){


            if (this.isMobile){
                // alert(item.CODIGO)
            }

            // alert(item.CODIGO)
            if (perguntar){
                if (!confirm(`Alterar ${field}?`)){
                    return 'exit'
                }
            }

            let visto = item[field]
            if (visto != 'S'){ visto = 'S'} else {visto = 'N'}
            let codigo = item.CODIGO

            let sql = `update ${tabela} set ${field} = '${visto}' where CODIGO = ${codigo}`
            // alert(sql)
            await this.crud_sql(sql)
            // console.log('sql:', sql);

            await this.tabela(tabela, '',)//atualiza

        },

        go_send_whats(cel,nome, ide){
            send_whats(cel,nome, ide)
        },

        async go_link_chamada(tipo, item, tipo2){
            // console.log('item:', item);
            let codigo_chamada = item.CODIGO * 1984

            let url           = sessionStorage['url']
            let ide           = 0
            let acao          = tipo2 * 777888

            
            try {
              ide  = this.obj_dados_empresa.IDE * 777888
            }
            catch (error) { return false}

            let link = `https://dsi.app.br/f/c/#/12052009/${acao}i${ide}i${codigo_chamada}`

            if (url =='/api/'){
                link = `#/12052009/${acao}i${ide}i${codigo_chamada}` //localhost
            }


            if (tipo == 'abrir_link'){

                window.open(link, '_blank'); 

                this.chama_dialog_ok('atualiza_agenda')
            }
            else if (tipo == 'copiar_link'){

                copiarParaClipboard(link)
                this.alerta('Link copiado para a área de transferência','black', 4000)
            }
            else if (tipo == 'compartilhar_link'){

                // let msg = `${saudacao()}segue o Link para a Chamada nº *${item.CODIGO} - ${item.x_NOME_FORNECEDOR} - ${item.x_DATA}*, serão necessários *${item.LIMITE}* colaboradores.\n\n`
                let msg = ``
                if (tipo2==401){
                    msg = `${saudacao()}segue o Link para a *Chamada ${item.x_NOME_FORNECEDOR} - ${item.x_DATA} - ${item.HORA}*\n\n`
                }
                else if (tipo2==402){
                    msg = `${saudacao()}segue o Link para dar *Presença* na *Chamada  ${item.x_NOME_FORNECEDOR} - ${item.x_DATA} - ${item.HORA}*\n\n`
                }

                
                msg += link

                // alert(msg)
                // return false
                link = `https://${(this.isMobile) ? 'api':'web'}.whatsapp.com/send/?text=${encodeURIComponent(msg)}`
                console.log('link:', link);

                window.open(link, '_blank'); 
            }

        },

        async seleciona_chamada(row){

           //limpa selecao
            this.selected_2 = []
            this.obj_clicado_2 = {}

            this.chamada_selecionou = Object.assign({}, row)
            this.seleciona_linha(row)

            this.tabela('sub_agenda', '', '2')
            // this.tabela_2('WP_CONTATOS',row)

        },

        async clicou_calendario(){
            // this.in_today
            this.obj_clicado = {}//limpa 
            // this.tabela('agenda', false, '2')
            await this.tabela('agenda')
            this.clicou_em('SIMULAR_CLIQUE', this.items_lista)
        },


        muda_dia(direcao) {

            // this.$refs.calendar1.prev()
            // return false

            if (!this.agenda_multipla) {
                const cal = this.$refs.calendar1

                if (direcao === 'prev') cal?.prev?.()
                if (direcao === 'next') cal?.next?.()

                return
            }


            // múltiplos
            if (direcao === 'prev'){
                this.in_today     = this.incDay(this.in_today, -1)
                this.selectedDate = this.in_today
            }else{
                this.in_today     = this.incDay(this.in_today, 1)
                this.selectedDate = this.in_today
            }

        },

        async seleciona_veiculo_coluna(calendar) {

            let numero

            // se já for número ou string numérica
            if (!isNaN(calendar)) {
                numero = String(calendar)
            } else {
                // extrai número do tipo "calendar-1"
                numero = String(calendar).split('-')[1]
            }

            this.veiculo_selecionado = this.lista_veiculos.find(v => 
                v.CODIGO == numero
            )
        },

        eventosPorVeiculo(item) {
            return this.items_eventos.filter(e =>
            (e.CODIGO_VEICULO || '').trim().includes(item.CODIGO)
            )
        },


        async clicou_em(acao, item){
            
            let sql = ''


            if (acao == 'gerar_lista_3'){

                this.rel_data_de  = await get_data_hora('mes_inicio')
                this.dialog_relatorios = true
                this.dialog_relatorios_acao = 'gerar_lista_3_1'
            }

            else if (acao == 'SIMULAR_CLIQUE'){
                
                if (!this.items_lista.length) return

                this.seleciona_chamada(this.items_lista[0])
            }

            else if (acao == 'atualiza_agenda'){
                this.seleciona_chamada(this.obj_clicado)//atualiza lista
            }
            
            else if ((acao == 'abrir_link_2') || (acao == 'copiar_link_2') || (acao == 'compartilhar_link_2')){

                acao  = acao.replace(/_\d+$/, '')
                this.go_link_chamada(acao, this.obj_clicado, 402)
            }
            
            else if ((acao == 'abrir_link') || (acao == 'copiar_link') || (acao == 'compartilhar_link')){
                this.go_link_chamada(acao, this.obj_clicado, 401)
            }

            else if (acao == 'gerar_lista_2'){

                let header_here = this.items_header_2.map((x) => x); //clonando array copiar array

                 // METODO NOVO
                header_here = header_here.filter(x => x.value !== "CONTATO");
                header_here = header_here.filter(x => x.value !== "x_SEXO");
                header_here = header_here.filter(x => x.value !== "actions");
                header_here = header_here.filter(x => x.value !== "DATA_CADASTRADO");
                header_here = header_here.filter(x => x.value !== "CODIGO");
                header_here = header_here.filter(x => x.value !== "SITUACAO");

                header_here.push(
                    { text: 'CARGO', value: 'x_PROFISSAO' },//width: '160px'
                    // { text: 'E-MAIL', value: 'x_EMAIL' },//width: '160px'
                    { text: 'PIX', value: 'x_DADOS_PIX' },//width: '160px'

                )
                

                let titulo = `ALFA`
                await DSibasico.imprimir_conteudo(acao, false, header_here, this.items_lista_2, titulo, false, false, '100%')
            }

            else if (acao == 'gerar_lista_1'){
 
                sessionStorage['recibo_tipo']           = 'lista_chamada' 
                sessionStorage['recibo_dados_chamada']  =  JSON.stringify(this.obj_clicado)
                sessionStorage['recibo_dados_contatos'] =  JSON.stringify(this.items_lista_2)

                let route = this.$router.resolve({path: '/print_c'});
                window.open(route.href, '_blank');
            }

            else if (acao == 'del_all_contatos'){

                if ( !confirm(`Excluir tudo desta lista?`) ){
                    return false
                }

                sql = `delete from sub_agenda where codigo_agenda = ${this.obj_clicado.CODIGO}`
                // console.log('sql:', sql);
                await this.crud_sql(sql)
                await this.tabela('sub_agenda', '', '2')//atualiza
                    
            }

            else if (acao == 'teste'){
                alert('clicou_em:', acao)
            }

            else if (acao == 'agenda_multipla'){
                this.agenda_multipla_memory = this.agenda_multipla //memoriza estado atual
            }

        },

        formata_dia_da_semana(dayString) {
            
            const date = new Date(dayString+' 00:00:00');

            return date.toLocaleDateString('pt-BR', {
                day: 'numeric',   // "16"
                weekday: 'long', // "segunda-feira"
            });
        },


        initScrollSync() {

            this.$nextTick(() => {
                if (!this.veiculosFiltrados?.length) return;

                this.veiculosFiltrados.forEach((veiculo) => {
                    
                const el = document.getElementById(`calendar-${veiculo.CODIGO}`);
                // console.log('el:', el);
                

                const scroll = el?.querySelector('.v-calendar-daily__scroll-area');

                if (!scroll) return;

                scroll.addEventListener('scroll', () => {
                    this.syncScroll(veiculo.CODIGO);
                });
                });
            });
        },


        syncScroll(sourceCodigo) {
            if (!this.agenda_multipla) return true;

            if (this.isSyncingScroll) return;
            this.isSyncingScroll = true;

            const sourceEl = document
                .getElementById(`calendar-${sourceCodigo}`)
                ?.querySelector('.v-calendar-daily__scroll-area');

            if (!sourceEl) {
                this.isSyncingScroll = false;
                return;
            }

            const scrollTop = sourceEl.scrollTop;

            this.veiculosFiltrados.forEach((veiculo) => {
                if (veiculo.CODIGO === sourceCodigo) return;

                const targetEl = document
                .getElementById(`calendar-${veiculo.CODIGO}`)
                ?.querySelector('.v-calendar-daily__scroll-area');

                if (targetEl) {
                targetEl.scrollTop = scrollTop;
                }
            });

            this.$nextTick(() => {
                this.isSyncingScroll = false;
            });
        },

        pode_alterar(condicao){
            
            if ( (this.obj_user.SUPER=='S') || (this.obj_user.AGENDA_U=='S') ){
                return true
            }
            else{
                if (condicao == 'SALDO_ENTRADA'){
                    // EXEMPLO
                }

                return false
            }
        },

        async go_zap_manual_aulas_alunos(acao){
            if (acao == 'zap_manual_aulas_alunos'){
                // console.log('lista_aulas_aluno:', this.lista_aulas_aluno);

                let navegador = false


                if ( confirm(`Abrir Navegador?`) ){
                    navegador = true
                }

                let saulas      = ``
                let cat         = ``
                let sdia        = ``
                let titulo      = ``
                let nome        = ``
                let fone        = ``
                let quebra      = `\r\n`
                let obs_agenda  = quebra + quebra + (this.obj_dados_empresa.OBS_PRINT_AGENDA) || 'Favor Comparecer com 15 minutos de antecêdencia!'

                if (navegador){
                    quebra    = `%0A`    
                }

                

                // let array_aulas = this.lista_aulas_aluno.map((x) => x); //clonando array copiar array
                // filtra as datas proximas
                let array_aulas = await this.filtrar_datas(this.lista_aulas_aluno)
                // console.log('array_aulas:', array_aulas);
                // return false
                     

                fone   = this.cadastro_selecionado.CELULAR.replace(/\D/g, '');
                nome   = this.cadastro_selecionado.NOME.trim()
                nome   =  nome.split(' ')[0];
                titulo = `${this.cadastro_selecionado.CODIGO_ALUNO} ${quebra}Olá *${nome}* ${quebra}${quebra}Confira o Agendamento de suas Aulas${quebra}`

                for (let i = 0; i < array_aulas.length; i++) {
                    // console.log('array_aulas:', array_aulas[i]);
                    if      (array_aulas[i].CATEGORIA == 'A'){ cat = 'MOTO' }
                    else if (array_aulas[i].CATEGORIA == 'B'){ cat = 'CARRO' }
                    else    { cat = array_aulas[i].CATEGORIA }
                    

                    sdia = await abreviarDiaSemana(array_aulas[i].DATA)

                    saulas = `${saulas} ${quebra} *${array_aulas[i].xx_DATA.substring(0, 5)}* ${sdia} *${array_aulas[i].HORA.substring(0, 5)}* - ${cat} - ${array_aulas[i].x_INSTRUTOR}`
                }


                saulas = titulo + saulas +  obs_agenda
                // alert(saulas)
                // enviar_whats_manual('44999685172', saulas, false)
                let link = `https://${(this.isMobile) ? 'api':'web'}.whatsapp.com/send/?phone=55${fone}&text=${(saulas)}`
                console.log('link:', link);

                
                if ( navegador ){
                    window.open(link, '_blank'); 
                }
                else{
                    this.alerta('Cole o código no Console do F12 na janela do WhatsApp','green')

                    let vem = await this.colar_zap_f12('44999685172', saulas)
                    console.log('vem:', vem);
                    copiarParaClipboard(vem)
                }
                
            }
        },


        async colar_zap_f12(numero, texto){
            // Troca quebras de linha por \r\n para URL
            const textoFormatado = texto.replace(/\n/g, '\r\n');
            const textoCodificado = encodeURIComponent(textoFormatado);

            // Código completo gerado como string (template literal)
            const codigo = `(async () => {
            const numero = '${numero}';
            const mensagemOriginal = \`${texto}\`;

            const mensagemFormatada = mensagemOriginal.replace(/\\n/g, '\\r\\n');
            const textoParaUrl = encodeURIComponent(mensagemFormatada);

            const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

            const link = document.createElement('a');
            link.href = \`https://web.whatsapp.com/send?phone=\${numero}&text=\${textoParaUrl}\`;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();

            await delay(3000);

            const botaoEnviar = document.querySelector('button span[data-icon="wds-ic-send-filled"]')?.closest('button');

            if (!botaoEnviar) {
                alert("❌ Botão de enviar (wds-ic-send-filled) não encontrado.");
                return;
            }

            botaoEnviar.click();

            alert('Mensagem enviada com sucesso!');
            setTimeout(() => {
                console.clear();
            }, 100);
            })();`;

            return codigo;
            },



        async inserirQuebraGenerica(dados, get_header, campos = [], valor = '') {

            if (!dados || !dados.length) return [];

            const resultado     = [];
            const primeiroCampo = get_header?.[0]?.value;

            let chaveAnterior = null;
            let contadorGrupo = 0;
            let totalGeral    = 0;
            let somaGrupo     = 0;
            let somaGeral     = 0;

            dados.forEach((item, index) => {

                // chave composta
                let chaveAtual = campos.map(c => item[c]).join('___');

                if (chaveAtual !== chaveAnterior) {

                    // total grupo anterior
                    if (chaveAnterior !== null) {

                        resultado.push({
                            [primeiroCampo]: `${contadorGrupo}`,
                            TOTAL: somaGrupo,
                            isTotal: true
                        });

                    }

                    contadorGrupo = 0;
                    somaGrupo     = 0;

                    // linha em branco
                    resultado.push({
                        [primeiroCampo]: '',
                        isSeparador: true
                    });

                    // uma linha para cada campo
                    campos.forEach(campo => {

                        resultado.push({
                            [primeiroCampo] : `${item[campo]}`,
                            ['TITULO']      : campo, //uso no data-set, deixo negrito
                            isSeparador     : true
                        });

                    });

                    chaveAnterior = chaveAtual;
                }

                contadorGrupo++;
                totalGeral++;

                if (valor && item[valor]) {

                    // console.log('achou valor:', item[valor]);

                    const valorNumerico = parseFloat(
                        String(item[valor])
                            .replace(/\./g, '') // remove separador de milhar
                            .replace(',', '.')  // troca vírgula decimal por ponto
                    );

                    somaGrupo += valorNumerico;
                    somaGeral += valorNumerico;

                }

                resultado.push(item);

                // ultimo item
                if (index === dados.length - 1) {

                    resultado.push({
                        [primeiroCampo]: `${contadorGrupo}`,
                        TOTAL: somaGrupo,
                        isTotal: true
                    });

                    resultado.push({
                        [primeiroCampo]: '',
                        isSeparador: true
                    });

                    resultado.push({
                        [primeiroCampo]: `TOTAL: ${totalGeral}`,
                        TOTAL: somaGeral,
                        isTotalGeral: true
                    });
                }

            });

            return resultado;
        },
        

        async inserirQuebraPorPlaca(dados, campo) {

            const resultado = [];
            let placaAnterior = null;
            let contadorGrupo = 0;
            let totalGeral = 0;

            dados.forEach((item, index) => {

                if (item[campo] !== placaAnterior) {

                    // Se já existia um grupo anterior, adiciona o TOTAL dele
                    if (placaAnterior !== null) {
                        resultado.push({
                            HORA: `${contadorGrupo}`,
                            isTotal: true
                        });
                    }

                    contadorGrupo = 0;

                    // linha em branco
                    resultado.push({
                        HORA: '',
                        isSeparador: true
                    });

                    // título do grupo
                    resultado.push({
                        HORA: item[campo],
                        isSeparador: true
                    });

                    placaAnterior = item[campo];
                }

                contadorGrupo++;
                totalGeral++;

                resultado.push(item);

                // Se for o último item
                if (index === dados.length - 1) {

                    // total do último grupo
                    resultado.push({
                        HORA: `${contadorGrupo}`,
                        isTotal: true
                    });

                    // linha em branco antes do total geral
                    resultado.push({
                        HORA: '',
                        isSeparador: true
                    });

                    // TOTAL GERAL
                    resultado.push({
                        HORA: `TOTAL: ${totalGeral}`,
                        isTotalGeral: true
                    });
                }

            });

            return resultado;
        },

        async go_imprimir_agenda(acao, di, df){

            let sql        = ``
            let titulo     = ``
            let get_items  = []
            let get_header = []

            if (acao == 'aulas_instrutor_2'){
                
                sql = `
                    SELECT
                        IFNULL(INSTRUTORES.NOME,'TOTAL') AS INSTRUTOR,
                        IFNULL(AGENDA.CATEGORIA,'TOTAL') AS CATEGORIA,
                        COUNT(AGENDA.CODIGO) AS QT_AULAS
                    FROM
                        AGENDA
                    INNER JOIN ALUNOS 
                        ON ALUNOS.CODIGO_ALUNO = AGENDA.CODIGO_ALUNO
                        LEFT OUTER JOIN INSTRUTORES ON INSTRUTORES.CODIGO = AGENDA.CODIGO_INSTRUTOR
                    WHERE
                        AGENDA.ATIVO <> 'X'
                        AND AGENDA.DATA BETWEEN '${di}' AND '${df}'
                    GROUP BY
                        INSTRUTORES.NOME,
                        AGENDA.CATEGORIA WITH ROLLUP;
                `

                // console.log('sql:', sql);
                get_items = await this.crud_abrir_tabela(sql, false )

                get_header = [
                    { text: 'INSTRUTOR', value: 'INSTRUTOR',width:'110px' },
                    { text: 'CATEGORIA', value: 'CATEGORIA',width:'50px' },
                    { text: 'QT', value: 'QT_AULAS', width:'900px' },
                ]


                // acrescenta uma linha quando achar o valor TOTAL
                const resultado = get_items.flatMap(row =>
                row.CATEGORIA === 'TOTAL'
                    ? [row, {INSTRUTOR:'', CATEGORIA:'', QT_AULAS:''}]
                    : [row]
                );


                titulo = `Quantidade por Instrutor - ${DSibasico.getFormatDate(di)} - ${DSibasico.getFormatDate(df)}`
                // await DSibasico.imprimir_conteudo(acao, false, get_header, get_items, titulo, true, false, '50%')
                await DSibasico.imprimir_conteudo(acao, false, get_header, resultado, titulo, true, false, '50%')

            }

            else if (acao == 'gerar_lista_3_1'){
                
                
                let c_emp = this.dialog_fields.EMPRESA.CODIGO * 1
                let ssnome = this.dialog_fields.NOME || ''
                
                
                sql = `
                    SELECT 
                        s.VISTO,
                        c.CODIGO_ALUNO,
                        c.NOME,
                        c.CPF,
                        c.DADOS_PIX as CHAVE_PIX,
                        c.NOME_PIX,
                        e.nome AS EMPRESA,
                        a.DATA,
                        a.HORA,
                        a.CODIGO_FORNECEDOR,
                        a.double_VALOR

                    FROM sub_agenda s

                    LEFT JOIN agenda a
                        ON s.CODIGO_AGENDA = a.CODIGO

                    LEFT JOIN alunos c
                        ON s.CODIGO_CADASTRO = c.CODIGO

                    LEFT JOIN tabela_fornecedores e
                        ON a.CODIGO_FORNECEDOR = e.codigo

                    WHERE 
                       a.DATA BETWEEN '${di}' AND '${df}' and s.VISTO = 'S' and c.NOME IS NOT NULL
                       ${(c_emp>0) ? `and a.CODIGO_FORNECEDOR = ${c_emp}` : ''}
                       ${(ssnome) ? ` AND c.NOME LIKE '%${ssnome}%'` : ''}
                       
                    ORDER BY
                        c.CODIGO_ALUNO, a.DATA asc, e.CODIGO

                `
                // a.DATA BETWEEN '2026-05-01' AND '2026-05-29' and a.CODIGO_FORNECEDOR >0
                
                

                get_header = [
                    { text: 'DATA', value: 'x_DATA' },
                    // { text: 'EMPRESA', value: 'EMPRESA' },
                    // { text: 'x_VALOR', value: 'x_VALOR' },
                    // { text: 'NOME', value: 'NOME',width:'200px' },
                    // { text: 'CHAVE_PIX', value: 'CHAVE_PIX' },
                    // { text: 'NOME_PIX', value: 'NOME_PIX' },
                    // { text: 'CODIGO_INSTRUTOR', value: 'CODIGO_INSTRUTOR', },
                ]


                // console.log('sql:', sql);
                get_items = await this.crud_abrir_tabela(sql, false )
                // console.log('get_items:', get_items);


                // get_items = await this.inserirQuebraGenerica(get_items, get_header, ['NOME','EMPRESA', 'CHAVE_PIX','NOME_PIX'])
                get_items = await this.inserirQuebraGenerica(get_items, get_header, ['NOME','CPF', 'CHAVE_PIX','NOME_PIX'], 'double_VALOR')
                // console.log('get_items:', get_items);
                // return false
                
                
                titulo = `Lista de Pagamento - ${DSibasico.getFormatDate(di)} até ${DSibasico.getFormatDate(df)}`
                
                await DSibasico.imprimir_conteudo(acao, false, get_header, get_items, titulo, true, false, '50%')

            }

            else if (acao == 'imprimir_agenda_geral_veiculos'){
                
                sql = `
                SELECT
                    AGENDA.CODIGO,
                    AGENDA.ATIVO,
                    AGENDA.DATA,
                    AGENDA.HORA,
                    AGENDA.CATEGORIA,
                    AGENDA.PROCESSO,
                    AGENDA.CODIGO_ALUNO,
                    AGENDA.PLACA,
                    INSTRUTORES.NOME AS INSTRUTOR,
                    AGENDA.CODIGO_INSTRUTOR,
                    CONCAT(ALUNOS.NOME, ' (', AGENDA.CODIGO_ALUNO, ')') AS ALUNO,
                    ALUNOS.PROCESSO,
                    ALUNOS.CPF
                FROM
                    AGENDA
                    LEFT OUTER JOIN ALUNOS ON ALUNOS.CODIGO_ALUNO = AGENDA.CODIGO_ALUNO
                    LEFT OUTER JOIN INSTRUTORES ON INSTRUTORES.CODIGO = AGENDA.CODIGO_INSTRUTOR
                WHERE
                    (AGENDA.ATIVO <>'X')
                    AND (AGENDA.DATA BETWEEN '${di}' AND '${df}') 
                    ${(this.rel_instrutor.NOME != 'TODOS') ? `AND (AGENDA.CODIGO_INSTRUTOR = '${this.rel_instrutor.CODIGO}')` : ``}
                    ${(this.rel_categoria != 'TODOS') ? `AND (AGENDA.CATEGORIA = '${this.rel_categoria}')` : ``}
                    AND (AGENDA.TIPO NOT LIKE '%BLOQUEADO%') 
                    AND (AGENDA.ALUNO NOT LIKE '%BLOQUEADO%')
                ORDER BY
                    AGENDA.DATA,
                    AGENDA.PLACA,
                    AGENDA.HORA
                `

                //  console.log('sql:', sql);
                get_items = await this.crud_abrir_tabela(sql, false )
                // console.log('get_items:', get_items);

                get_items = await this.inserirQuebraPorPlaca(get_items, 'PLACA')

                
                get_header = [
                    // { text: 'CODIGO', value: 'CODIGO'},
                    // { text: 'Codigo', value: 'CODIGO',width:'130px' },
                    // { text: 'Data', value: 'DATA',width:'70px' },
                    // { text: 'Placa', value: 'PLACA',width:'70px' },
                    // { text: 'Data', value: 'DATA',width:'70px' },
                    { text: 'Hora', value: 'HORA',width:'70px' },
                    { text: 'C', value: 'CATEGORIA',width:'20px' },
                    { text: 'Processo', value: 'PROCESSO',width:'100px' },
                    { text: 'Nome', value: 'ALUNO', width:'250px'},
                    { text: 'CPF', value: 'CPF', width:'100px'},
                    { text: 'Instrutor', value: 'INSTRUTOR', },
                    // { text: 'CODIGO_INSTRUTOR', value: 'CODIGO_INSTRUTOR', },
                ]



                // adiciono o TITULO pois de outra forma o header fica aparecendo em todas as paginas
                // const headerObj = {};
                // get_header.forEach(h => {
                //     headerObj[h.value] = h.text;
                // });
                // get_items.unshift(headerObj);



                // titulo = `AGENDA GERAL VEICULOS - ${DSibasico.getFormatDate(this.dia_clicou)}`
                if (di != df){
                    titulo = `AGENDA GERAL VEICULOS - ${DSibasico.getFormatDate(di)} -- ${DSibasico.getFormatDate(df)}`
                }else{
                    titulo = `AGENDA GERAL VEICULOS - ${DSibasico.getFormatDate(di)}`
                }
                

                await DSibasico.imprimir_conteudo('AGENDA_GERAL_VEICULOS', false, get_header, get_items, titulo, true, false, '100%')

            }
        },

        async go_copiarParaClipboard(texto){
            await copiarParaClipboard(texto)

            this.alerta(`(${texto}) copiado para a área de transferência!`,'black')
        },

        async filtrar_datas(item_base) {
            if (!Array.isArray(item_base)) {
                console.warn("item_base não é um array válido.");
                return [];
            }

            // Pegando a data de hoje no fuso horário do Brasil (UTC-3)
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return item_base.filter((item) => {
                if (!item.DATA) return false; // Evita erros se DATA for undefined ou null

                // Convertendo para o formato correto (garantindo que DATA seja tratada como string de data válida)
                const itemDate = new Date(item.DATA + "T00:00:00-03:00"); // Ajuste para fuso horário do Brasil
                itemDate.setHours(0, 0, 0, 0);

                return itemDate >= today;
            });
        },



        retorna_cor_tipo(tipo){
            
            if (tipo == 'AULA EXTRA'){
                return '#8000ff'
            }

            else if (tipo == 'EX.PRATICO'){
                return '#9a0a9a'
            }

            else if (tipo == 'AULA'){
                return 'secondary'
            }

            else if (tipo == 'AGENDA'){
                return 'blue'
            }

            else if (tipo == 'BLOQUEAR'){
                return 'red'
            }

            else if ((tipo == 'BLOQUEAR DIA') || (tipo == 'BLOQUEAR INSTRUTOR')){
                return 'red'
            }

            else{
                // return 'grey black--text'
                return 'orange'
            }
        },

        imprimir(){
        
            this.vai_imprimir = true

            setTimeout(function(){
            window.print()
            this.vai_imprimir = false  
            
            // this.dialog_protocolo = false
            }.bind(this), 111);
        },


        cor_limite(cat){


            // alert(this.lista_aulas_aluno[0]['TOTAL_'+cat])

            // return 'primary'

            let count = this.lista_aulas_aluno[0]['TOTAL_'+cat]

            if ((cat == 'A') || (cat == 'B')){
                if (count==20){
                    // this.alerta(`Atingido 20 aulas`,'green')
                    return 'success'
                }
                else if (count>20){
                    // this.alerta(`Atingido mais de 20 aulas`,'red')
                    // return 'error'
                    return 'error'
                }
                else{
                    return 'primary'
                }
            }
            else{
                return 'primary'
            }

            // console.log('count:', count);
            
            // return 'primary'

            // try{  
            //     let limite = parseInt(this.veiculo_selecionado.LIMITE_TOTAL)     || 10000
            //     let jatem  = parseInt(this.lista_aulas_aluno[0][`TOTAL_${cat}`]) || 10000
                
            //     if (this.veiculo_selecionado.CATEGORIA == cat){
            //         if (jatem >= limite){
            //             // return 'warning'
            //             return 'success'
            //         }
            //     }
            // }catch(e){}
                
            // return ''
        },
        


        async restricoes_agendamento(item, hora){

            // console.log('item:', item);
            let ide       = this.cadastro_selecionado.CODIGO_ALUNO
            let carro     = Object.assign({}, this.veiculo_selecionado)  
            let horarios  = Object.assign({}, this.horarios_veiculo)  
            let retorno   = {}

            let sql = ``
            let LT_DIA = 4 //limite total de agendameetnos por dia
            

            let simultaneo = ``
            if (this.agendar_simultaneo){
                simultaneo = ` AND 0>1`
            }

            //1º verifica aluno ou veiculo agendado neste horario
            sql = `
            SELECT IFNULL(
                (SELECT codigo 
                FROM agenda 
                WHERE data   = '${item.date}' 
                AND hora     = '${hora}' 
                AND ativo    = 'S' 
                AND (CODIGO_ALUNO = ${ide || -1} or CODIGO_VEICULO = ${carro.CODIGO} )
                ${simultaneo}
                LIMIT 1), 
                0
            ) AS codigo;
            `
       
            // console.log('sql:', sql);
            retorno = await this.crud_abrir_tabela(sql, false)
            retorno = retorno[0]
            // console.log('retorno:', retorno);

            if (retorno.codigo>0){
                this.alerta(`Aluno ou Veículo já agendado nesta Data e Hora! (${retorno.codigo})`, 'orange')
                return false
            }
            


            

            //2º LIMITES POR DIA E SEMANAS POR CATEGORIA E TOTAL DE AULAS AGENDADAS
            sql = `
                SELECT

                '${carro.CATEGORIA}' AS CATEGORIA,

                IF(
                    COUNT(CASE WHEN (AGENDA.CODIGO_ALUNO = ${ide}) AND (AGENDA.DATA = '${item.date}') AND (AGENDA.CATEGORIA = '${carro.CATEGORIA}') AND (AGENDA.ATIVO = 'S') AND (AGENDA.TIPO = '${this.tipo_selecionado}') THEN AGENDA.CODIGO END) >= ${horarios.LIMITE_DIA},
                    COUNT(CASE WHEN (AGENDA.CODIGO_ALUNO = ${ide}) AND (AGENDA.DATA = '${item.date}') AND (AGENDA.CATEGORIA = '${carro.CATEGORIA}') AND (AGENDA.ATIVO = 'S') AND (AGENDA.TIPO = '${this.tipo_selecionado}') THEN AGENDA.CODIGO END),
                    0
                ) AS LIMITE_DIA,
                

                (
                        SELECT 
                            IF(COUNT(*) >= ${horarios.LIMITE_SEMANA}, COUNT(*), 0) AS LIMITE_SEMANA
                        FROM (
                            SELECT DISTINCT AGENDA.DATA  -- Apenas uma entrada por dia
                            FROM AGENDA
                            WHERE AGENDA.CODIGO_ALUNO    = ${ide}
                                AND AGENDA.DATA BETWEEN '${this.data_inicial.date}' AND '${this.data_final.date}'
                                AND DAYOFWEEK(AGENDA.DATA) IN (2, 3, 4, 5, 6)  -- Segunda a sexta
                                AND AGENDA.CATEGORIA     = '${carro.CATEGORIA}'
                                AND AGENDA.ATIVO         = 'S'
                        ) AS dias_unicos
                    ) AS LIMITE_SEMANA_ANTES,


                IF(
                    COUNT(CASE WHEN (AGENDA.CODIGO_ALUNO = ${ide}) AND (AGENDA.DATA = '${item.date}') AND (AGENDA.ATIVO = 'S') AND (AGENDA.TIPO = '${this.tipo_selecionado}') THEN AGENDA.CODIGO END) >= ${LT_DIA},
                    COUNT(CASE WHEN (AGENDA.CODIGO_ALUNO = ${ide}) AND (AGENDA.DATA = '${item.date}') AND (AGENDA.ATIVO = 'S') AND (AGENDA.TIPO = '${this.tipo_selecionado}') THEN AGENDA.CODIGO END),
                    0
                ) AS TOTAL_DIA,

                IF(
                    COUNT(CASE WHEN (AGENDA.CODIGO_ALUNO = ${ide}) AND (AGENDA.CATEGORIA = '${carro.CATEGORIA}') AND (AGENDA.DATA BETWEEN '${this.data_inicial.date}' AND '${this.data_final.date}') AND (AGENDA.ATIVO = 'S') AND (AGENDA.TIPO = '${this.tipo_selecionado}') THEN AGENDA.CODIGO END) >= ${horarios.LIMITE_SEMANA},
                    COUNT(CASE WHEN (AGENDA.CODIGO_ALUNO = ${ide}) AND (AGENDA.CATEGORIA = '${carro.CATEGORIA}') AND (AGENDA.DATA BETWEEN '${this.data_inicial.date}' AND '${this.data_final.date}') AND (AGENDA.ATIVO = 'S') AND (AGENDA.TIPO = '${this.tipo_selecionado}') THEN AGENDA.CODIGO END),
                    0
                ) AS LIMITE_SEMANA,


                IF(
                    COUNT(CASE WHEN (AGENDA.CODIGO_ALUNO = ${ide}) AND (AGENDA.CATEGORIA = '${carro.CATEGORIA}') AND (AGENDA.ATIVO = 'S') AND (AGENDA.TIPO = '${this.tipo_selecionado}') THEN AGENDA.CODIGO END) >= ${horarios.LIMITE_TOTAL},
                    COUNT(CASE WHEN (AGENDA.CODIGO_ALUNO = ${ide}) AND (AGENDA.CATEGORIA = '${carro.CATEGORIA}') AND (AGENDA.ATIVO = 'S') AND (AGENDA.TIPO = '${this.tipo_selecionado}') THEN AGENDA.CODIGO END),
                    0
                ) AS TOTAL_GERAL

                FROM AGENDA;
            `


            // console.log('sql:', sql);
            retorno = await this.crud_abrir_tabela(sql, false)
            retorno = retorno[0] || []
            // console.log('retorno:', retorno);


            if (retorno.TOTAL_GERAL > 0){
                // alert(`Aluno já atingiu Limite Total de ${retorno.TOTAL_GERAL} Aulas para a Categoria ${retorno.CATEGORIA} !`)

                if ( confirm(`Aluno já atingiu Limite Total de ${retorno.TOTAL_GERAL} Aulas para a Categoria ${retorno.CATEGORIA} !\nAdicionar mesmo assim?`) ){
                    return true
                }
                return false
            }
            else if (retorno.LIMITE_DIA > 0){
                alert(`Aluno já atingiu Limite de ${retorno.LIMITE_DIA} Aulas no dia para a Categoria ${retorno.CATEGORIA} !`)
                return false
            }
            else if (retorno.TOTAL_DIA > 0){
                alert(`Aluno já atingiu Limite de ${retorno.TOTAL_DIA} Aulas no Dia!`)
                return false
            }
            else if (retorno.LIMITE_SEMANA > 0){
                alert(`Aluno já atingiu Limite de ${retorno.LIMITE_SEMANA} Aulas por Semana na Categoria ${retorno.CATEGORIA} !`)
                return false
            }
            





            return true

        },

        async imprimir_conteudo2(modelo_relatorio, headers, items, titulo, ocultar_header, auto_print, largura){

            let componente = ''

            if (items.constructor === Array){
                componente = 'v-data-table'
                headers = JSON.stringify(headers)
                items = JSON.stringify(items)
            }
            else{
                componente = 'v-textarea'
            }


            // monto o objeto que sera lido la em relatorios.vue
            let obj_dados_impressao = {}

            this.$set(obj_dados_impressao, 'relatorios_show'    , true) //permite ver relatorio
            this.$set(obj_dados_impressao, 'qual'               , 'AUTO')
            this.$set(obj_dados_impressao, 'modelo_relatorio'   , modelo_relatorio)
            this.$set(obj_dados_impressao, 'componente'         , componente)
            this.$set(obj_dados_impressao, 'headers'            , headers)
            this.$set(obj_dados_impressao, 'items'              , items)
            this.$set(obj_dados_impressao, 'titulo'             , titulo)
            this.$set(obj_dados_impressao, 'auto_print'         , auto_print )
            this.$set(obj_dados_impressao, 'ocultar_header'     , ocultar_header) 
            this.$set(obj_dados_impressao, 'largura'            , largura) 

            this.$set(obj_dados_impressao, 'cadastro'           , this.cadastro_selecionado) 

            // salvo na session para ser lido em relatorios.vue
            sessionStorage['obj_dados_impressao']  =  JSON.stringify(obj_dados_impressao)

            // abro a pagina relatorios.vue
            let route = this.$router.resolve({path: '/relatorios'});
            window.open(route.href, '_blank');


            // apos aberto, volto para false para nao ser lido fora do contexto
            this.$set(obj_dados_impressao, 'relatorios_show'    , false)
        },

        async muda_situacao(situacao){
            let sql = `update agenda set SITUACAO = '${situacao}' where CODIGO = ${this.item_menu.CODIGO}`
            // console.log('sql:', sql);

            await this.crud_sql(sql)
            await this.tabela('agenda')//atualiza v-calendar
            
        },

        async seleciona_aluno(item_cadastro){

        //    this.tipo_selecionado =  this.item_menu.TIPO
           this.cadastro_selecionado   = Object.assign({}, item_cadastro) 
           this.salva_session('cadastro_selecionado')
           this.aulas_alunos(this.cadastro_selecionado.CODIGO_ALUNO || this.cadastro_selecionado.CODIGO)


           // evita duplicidade  adiciona na lista
           if (!this.lista_cadastros.some(cadastro => cadastro.CODIGO === item_cadastro.CODIGO)) {
               this.lista_cadastros.push(item_cadastro);
           }

        },

        async buscar_cadastro(ide){
            
            let sql = `
                SELECT 
                    A.CODIGO, 
                    A.CODIGO_ALUNO, 
                    A.NOME, 
                    A.ATIVO, 
                    A.FOTO_URL,
                    A.PROCESSO,
                    A.DATA_PROCESSO,
                    A.DESCRICAO_SERVICO AS DESCRICAO,
                    A.CELULAR,
                    CASE 
                        WHEN EXISTS (
                            SELECT 1 
                            FROM CONTA C
                            WHERE C.CODIGO_ALUNO = A.CODIGO_ALUNO
                            AND C.PAGO = 'N'
                            AND C.DATA_VENCIMENTO < CURDATE()
                        ) 
                        THEN 'SIM'
                        ELSE 'NAO'
                    END AS POSSUI_ATRASO
                FROM 
                    ALUNOS A
                WHERE
                    A.ATIVO = 'S'
                    AND A.CODIGO_ALUNO = ${ide}
                ORDER BY 
                    A.NOME;

            `

            // let sql = `
            //     SELECT 
            //         ALUNOS.CODIGO, 
            //         ALUNOS.CODIGO_ALUNO, 
            //         ALUNOS.NOME, 
            //         ALUNOS.ATIVO, 
            //         ALUNOS.FOTO_URL,
            //         ALUNOS.PROCESSO,
            //         ALUNOS.DATA_PROCESSO,
            //         ALUNOS.DESCRICAO_SERVICO AS DESCRICAO,
            //         ALUNOS.CELULAR
            //     FROM 
            //         ALUNOS
            //     WHERE
            //         ALUNOS.ATIVO = 'S' AND
            //         ALUNOS.CODIGO_ALUNO = ${ide}
            //     ORDER BY 
            //         ALUNOS.NOME;`

            // console.log('sql:', sql);
            

            let item_cadastro = await this.crud_abrir_tabela(sql, false)
            // console.log('retorno:', item_cadastro);
            item_cadastro = item_cadastro[0]//mudo para objeto
            // console.log('item_cadastro:', item_cadastro);

            await this.seleciona_aluno(item_cadastro)
            
        },

        vif_here(acao){

            // if ( (acao == 'abrir_cadastro') || (acao == 'selecionar_cadastro') || (acao == 'definir_situacao') ) {
            if ( (acao == 'abrir_cadastro') || (acao == 'selecionar_cadastro') ) {
                // (this.souDSi)
               return  (this.item_menu.CODIGO_ALUNO != 0)
            }
            else{
                return true
            }
        },

        abrir_cadastro(ide, nova_aba){
           sessionStorage['cadastro_abrir_ide'] = ide

           if (nova_aba){
            let route = this.$router.resolve({path: '/cadastro'});
             window.open(route.href, '_blank');
          }
          else{
             this.$router.push('/cadastro')//redireciono para a pagina do router
          }
           
        },

        clicou_hoje(){
            this.in_today     = this.today
            this.selectedDate = this.today
            this.tabela('agenda')
        },

        cor_cadastro(event){

            // console.log('CODIGO_ALUNO:', CODIGO_ALUNO);

            let CODIGO_ALUNO = event.CODIGO_ALUNO
            
            if (event.SITUACAO !=='MARCADO'){
                return ''
            }

            else if (event.TIPO == 'AGENDA'){
                return 'grey'
            }

            else if (CODIGO_ALUNO == 0){
                return 'orange'
            }
            
            else if (CODIGO_ALUNO == this.cadastro_selecionado.CODIGO_ALUNO){
                return 'blue'
            }
            else {
                return ''
            } 
        },

        async entao_remover_aula(item_menu, tipo){

            // console.log('entao_remover_aula:', item_menu );
            // return false
            
            if (item_menu.CODIGO < 1){
               return false
            }


            if (!confirm( (tipo == 'um') ? "Excluir este Agendamento?" : 'Excluir Todos os Agendamentos deste Aluno?')){
                return false
            }

            let sql = ``

            if (tipo == 'um'){
               sql = `update agenda set ATIVO = 'X' where CODIGO = ${item_menu.CODIGO}`

               await registra_log('AGENDA', `${negritoO('EXCLUIU AULA', 'red')} ${item_menu?.CODIGO}  (${item_menu?.x_DATA} - ${item_menu?.HORA}- ${item_menu?.x_PLACA}- ${item_menu?.x_NOME_INSTRUTOR}) de: ${item_menu?.ALUNO+':'+item_menu.CODIGO_ALUNO}`, item_menu.CODIGO_ALUNO, item_menu?.CODIGO )


            }
            else if (tipo == 'todos'){
                sql = `update agenda set ATIVO = 'X' where CODIGO_ALUNO = ${item_menu.CODIGO_ALUNO}`

                await registra_log('AGENDA', `${negritoO('EXCLUIU TODAS AS AULAS', 'red')} de: ${this.cadastro_selecionado.NOME+':'+item_menu.CODIGO_ALUNO}`, item_menu.CODIGO_ALUNO, -86 )
            }

            // console.log('sql:', sql);
            
            await this.crud_sql(sql)
            await this.tabela('agenda')//atualiza v-calendar
            await this.aulas_alunos(this.cadastro_selecionado.CODIGO_ALUNO || this.cadastro_selecionado.CODIGO)//atualiza lista de aulas do aluno


        },

       async abre_dialog_opcoes(acao){

       }, 

       async clicou_menu_de_tabelas(acao){
        //   alert(acao)
        //   console.log('item_menu:', this.item_menu);//o item que cliquei
          
          this.dialog_menu = false


          if (acao == 'gerar_lista_3_1'){
            await this.go_imprimir_agenda('gerar_lista_3_1', this.rel_data_de, this.rel_data_ate)
          }

          else if (acao == 'filtrar_multipla_agenda'){

              this.dialog_relatorios = true
              this.dialog_relatorios_acao = 'filtrar_multipla_agenda_2'
          }
          
          else if (acao == 'filtrar_multipla_agenda_2'){

              this.dialog_relatorios = false
          }

          else if (acao == 'aulas_instrutor'){

            //   this.rel_data_de  = await get_data_hora('mes_inicio')
            //   this.rel_data_ate = await get_data_hora('today')

              this.dialog_relatorios = true
              this.dialog_relatorios_acao = 'aulas_instrutor_2'
          }
          
          else if (acao == 'aulas_instrutor_2'){
              await this.go_imprimir_agenda(acao, this.rel_data_de, this.rel_data_ate)
          }

          else if (acao == 'imprimir_agenda_geral_veiculos'){
              await this.go_imprimir_agenda(acao, this.dia_clicou, this.dia_clicou)
          }

          if (acao == 'imprimir_agenda_geral_veiculos_2'){

            //   this.rel_data_de  = await get_data_hora('today')
            //   this.rel_data_ate = await get_data_hora('today')

              this.dialog_relatorios = true
              this.dialog_relatorios_acao = 'imprimir_agenda_geral_veiculos_3'
          }


          if (acao == 'imprimir_agenda_geral_veiculos_3'){
              await this.go_imprimir_agenda('imprimir_agenda_geral_veiculos', this.rel_data_de, this.rel_data_ate)
          }

          else if (acao == 'filtrar_semana'){
              this.filtrar_veiculo   = false
              this.filtrar_instrutor = false
              this.type = 'week'
          }

          else if (acao == 'filtrar_dia'){
            //   this.filtrar_veiculo   = false
            //   this.filtrar_instrutor = false
              this.type = 'day'
          }

          else if (acao == 'zap_manual_aulas_alunos'){
             await this.go_zap_manual_aulas_alunos(acao)
          }
          
          else if (acao == 'imprimir_aulas_alunos'){

            
            let item  =  Object.assign({}, this.cadastro_selecionado)

            // filtra as datas proximas
            let items_data = await this.filtrar_datas(this.lista_aulas_aluno)


            let titulo = `AGENDAMENTO DE ${this.tipo_selecionado}`
            await DSibasico.imprimir_conteudo(acao, this.cadastro_selecionado, this.header_aulas_aluno, items_data, titulo, false, false, '40%')
            // this.imprimir_conteudo2(acao, this.header_aulas_aluno, this.lista_aulas_aluno, titulo, false, false, '50%')
          }

          else if (acao == 'remover_aula'){
             this.entao_remover_aula(this.item_menu, 'um')
          }
          
          else if (acao == 'remover_aula_todas'){
             this.entao_remover_aula(this.item_menu, 'todos')
          }
          
          else if (acao == 'abrir_cadastro'){

             let meu_processo = await DSibasico.somenteNumeros(this.item_menu.PROCESSO)
             copiarParaClipboard(meu_processo)
             this.alerta(`Processo (${meu_processo}) copiado para a área de transferência`,'black', 4000)

             this.abrir_cadastro(this.item_menu.CODIGO_ALUNO, true)
          }
          
          else if (acao == 'alterar_agenda'){
            // console.log('this.item_menu:', this.item_menu);
            
            // removo campos para nao dar erro no sql
            delete this.item_menu.color;
            delete this.item_menu.end;
            delete this.item_menu.name;
            delete this.item_menu.start;
            delete this.item_menu.timed;
            
            await this.editar_tabela(this.item_menu, 'item_edita', 'dialog_tabela')

          }

          else if (acao == 'selecionar_cadastro'){
             this.tipo_selecionado =  this.item_menu.TIPO

             this.buscar_cadastro(this.item_menu.CODIGO_ALUNO)

             let meu_processo = await DSibasico.somenteNumeros(this.item_menu.PROCESSO)
             copiarParaClipboard(meu_processo)
             this.alerta(`Processo (${meu_processo}) copiado para a área de transferência`,'black', 4000)
          }
          
          else if (acao.includes('defx_')){
            // defx_confirmado
            acao = acao.split('_')[1] //copia tudo depois do _ na string acao
            acao = acao.trim().toUpperCase()
            this.muda_situacao(acao)
          }
          
       },

       retorna_titulo(menu_selecionado, item_menu){
         
        // alert(tabela)
        if (menu_selecionado == 'agenda'){
            return `${item_menu.x_DATA} - ${item_menu.HORA} - (${item_menu.CODIGO})`
            // return `${item_menu.x_DATA} às ${item_menu.HORA}`
         }

         else if (menu_selecionado == 'menu_evento'){
            return `${item_menu.x_DATA} - ${item_menu.HORA} - (${item_menu.CODIGO})`
         }
         
         else if (menu_selecionado == 'menu_aulas'){
            return `${this.cadastro_selecionado.NOME}`
         }
       },

       rightClick(item, event) {
         // console.log('rightClick event:', event)
         // console.log('rightClick item:', item)

         this.abre_menu(item)
         try{ 
            event.preventDefault()
         }catch(e){}
       },

       abre_menu(item){
        
        // console.log('abre_menu:', item);
        
        this.dialog_menu = true
        // this.item_menu = item
        if (item){
           this.item_menu  = Object.assign({}, item)  
        }


        this.seleciona_linha(item)
      },

        monta_menu_de_tabelas(qual){


          this.menu_de_tabelas              = []//limpa
          this.menu_de_tabelas_selecionados = []//limpa

          this.menu_selecionado = qual

        //   if (this.pode_alterar(this.tabela_selecionada)){

        //         this.menu_de_tabelas.push(   
        //         {type:'menu', title: 'Alterar',   icon:'mdi-pencil',    icon_color: 'primary',    click:'alterar' },
        //         )
        //   }

          if (qual == 'agenda'){

            if (this.pode_alterar()){
                this.menu_de_tabelas.push(    
                    {type:'menu', title: 'Excluir',        icon:'mdi-close',   icon_color: 'red',        click:'remover_aula' },
                    {type:'menu', title: 'Excluir Todos',   icon:'mdi-delete-circle-outline',   icon_color: 'red',        click:'remover_aula_todas' },
                )
            }

        
          }

          else if (qual == 'menu_geral'){

            this.menu_de_tabelas.push(    
                {type:'menu', title: 'Agenda Geral dos Veículos',        icon:'mdi-printer',   icon_color: 'primary',        click:'imprimir_agenda_geral_veiculos_2' },
                {type:'menu', title: 'Quantidade por Instrutor'       ,        icon:'mdi mdi-car-2-plus',   icon_color: 'primary',        click:'aulas_instrutor' },
            )

            this.abre_menu(false)

          }

          else if (qual == 'menu_data_clicada'){

            this.menu_de_tabelas.push(    
                {type:'menu', title: 'Mostrar Dia',        icon:'mdi-calendar',   icon_color: 'primary',        click:'filtrar_dia' },
                {type:'menu', title: 'Mostrar Semana',        icon:'mdi-calendar',   icon_color: 'primary',        click:'filtrar_semana' },
                {type:'menu', title: 'Agenda Geral dos Veículos',        icon:'mdi-printer',   icon_color: 'primary',        click:'imprimir_agenda_geral_veiculos' },
            )

            this.abre_menu(false)

          }

          else if (qual == 'menu_aulas'){

            this.menu_de_tabelas.push(    
                {type:'menu', title: 'Imprimir',          icon:'mdi-printer',   icon_color: 'primary',        click:'imprimir_aulas_alunos' },
                {type:'menu', title: 'Enviar Aulas',   icon:'mdi-whatsapp',  icon_color: 'green',        click:'zap_manual_aulas_alunos' },
            )

            this.abre_menu(false)

          }

          else if (qual == 'menu_evento'){


            if (this.obj_user.SUPER =='S'){
                this.menu_de_tabelas.push(    
                    // {type:'menu', title: 'Alterar',             icon:'mdi-pencil',          icon_color: 'primary',    click:'alterar_agenda' },
                )
            }

            if (this.pode_alterar()){

                    this.menu_de_tabelas.push(    
                        {type:'menu', title: 'Alterar',             icon:'mdi-pencil',          icon_color: 'primary',    click:'alterar_agenda' },
                        
                        {
                            type:'group',
                            icon:'mdi-circle',
                            icon_color: 'blue',
                            title: 'Situação',
                            click: 'definir_situacao', 
                            items: [
                                {type:'', title: 'Confirmado',        icon:'mdi-square', icon_color: '#800080',       click:'defx_confirmado'},
                                {type:'', title: 'Faltou',            icon:'mdi-square', icon_color: 'red lighten-2', click:'defx_faltou'},
                                {type:'', title: 'Concluído',         icon:'mdi-square', icon_color: 'green',         click:'defx_concluido'},
                                {type:'', title: 'Marcado',           icon:'mdi-square', icon_color: 'grey',          click:'defx_marcado'},
                                // {type:'', title: 'Aula Lançada',      icon:'mdi-square', icon_color: 'yellow',  click:'def_lancada'},
                            ],
                        },
                        
                        // {type:'menu', title: 'Excluir',             icon:'mdi-close',            icon_color: 'red',        click:'remover_aula' },
                    )
            }
            
            this.menu_de_tabelas.push(    
                {type:'menu', title: 'Cadastro',            icon:'mdi-account',          icon_color: 'primary',    click:'abrir_cadastro' },
                {type:'menu', title: 'Selecionar Cadastro', icon:'mdi-account-search',   icon_color: 'primary',    click:'selecionar_cadastro' },
            )


            if (this.pode_alterar()){

                    this.menu_de_tabelas.push(                            
                        {type:'menu', title: 'Excluir',             icon:'mdi-close',            icon_color: 'red',        click:'remover_aula' },
                    )
            }

          }
        },

        altura_desse(menosA, menosB){
            let r   = 0
            let dif = menosA
            
            if (this.value_expansion_1 >=0 ){
                dif = menosB
            }

            r = this.retorna_altura(dif)
            
            return r
        },

        async aulas_alunos(ide){


            // if (ide<1){
            if ((!ide) || (ide==0)){
                this.lista_aulas_aluno = []
                return false
            }


            let tipo = this.tipo_selecionado
            if (tipo == 'TODOS'){
                tipo = ``
            }else{
                tipo = `AND a.TIPO = '${tipo}'`
            }


            let categoria = this.categoria_filtrar
            if ((categoria == 'TODOS') || (categoria == '')){
                categoria = ''
            }else{
                categoria = ` AND a.CATEGORIA = '${categoria}' `
            }

            let sql = `

                    SELECT 
                        a.*, 
                        v.PLACA as x_PLACA, 
                        i.NOME as x_INSTRUTOR,
                        (SELECT COUNT(agenda.CATEGORIA) FROM agenda WHERE CODIGO_ALUNO = ${ide} AND CATEGORIA = 'A' AND ATIVO = 'S' AND AGENDA.TIPO = '${this.tipo_selecionado}') AS TOTAL_A,
                        (SELECT COUNT(agenda.CATEGORIA) FROM agenda WHERE CODIGO_ALUNO = ${ide} AND CATEGORIA = 'B' AND ATIVO = 'S' AND AGENDA.TIPO = '${this.tipo_selecionado}') AS TOTAL_B,
                        (SELECT COUNT(agenda.CATEGORIA) FROM agenda WHERE CODIGO_ALUNO = ${ide} AND CATEGORIA = 'C' AND ATIVO = 'S' AND AGENDA.TIPO = '${this.tipo_selecionado}') AS TOTAL_C,
                        (SELECT COUNT(agenda.CATEGORIA) FROM agenda WHERE CODIGO_ALUNO = ${ide} AND CATEGORIA = 'D' AND ATIVO = 'S' AND AGENDA.TIPO = '${this.tipo_selecionado}') AS TOTAL_D,
                        (SELECT COUNT(agenda.CATEGORIA) FROM agenda WHERE CODIGO_ALUNO = ${ide} AND CATEGORIA = 'E' AND ATIVO = 'S' AND AGENDA.TIPO = '${this.tipo_selecionado}') AS TOTAL_E
                    FROM 
                        agenda a
                    LEFT OUTER JOIN veiculos v ON a.CODIGO_VEICULO = v.CODIGO
                    LEFT OUTER JOIN instrutores i ON a.CODIGO_INSTRUTOR = i.CODIGO
                    WHERE 
                        a.ATIVO = 'S' AND
                        a.CODIGO_ALUNO = ${ide}  
                        ${tipo}
                        ${categoria}
                    ORDER BY 
                        a.DATA, a.HORA;

                `

            // console.log('sql:', sql);
            
            await this.crud_abrir_tabela(sql, 'lista_aulas_aluno')

            if (this.lista_aulas_aluno[0].TOTAL_A ==20){
                this.alerta(`Atingido 20 aulas A`,'green')
            }
            
            if (this.lista_aulas_aluno[0].TOTAL_B ==20){
                this.alerta(`Atingido 20 aulas B`,'green')
            }

            if (this.lista_aulas_aluno[0].TOTAL_A > 20){
                this.alerta(`Atingido mais de 20 aulas A`,'red')
            }
            
            if (this.lista_aulas_aluno[0].TOTAL_B  > 20){
                this.alerta(`Atingido mais de 20 aulas B`,'red')
            }


            // limpa filtro para os proximos
            this.categoria_filtrar = ''

        },

        salva_session(tipo){           
            sessionStorage[tipo]  =  JSON.stringify(this[tipo])
        },

       abre_janela_modal(status, edicao, tabela, titulo){

         this.janela_modal_tabela   = tabela
         this.janela_modal_titulo   = titulo
         this.janela_modo_edicao    = edicao
         this.janela_modal_abre     = status
       },  

       janela_modal_change(valor){
        this.janela_modal_abre = valor

        if (!valor){
          // alert('atualiza algo nesta janela')
        }
      },

      async acao_after_modal(acao){

        let ccadastro
        
        try{
            ccadastro = JSON.parse(sessionStorage['cadastro_selecionados'])
            ccadastro = ccadastro[0]
        }catch(e){
            return false
        }


        if (!ccadastro){
        return false
        }

        // console.log('ccadastro:', ccadastro);


        if ((acao == 'ALUNOS') && (this.tipo_de_cliente=='CHAMADA')){
            
            // abre dialog e pre-definicoes = default
            this.nova_tabela('item_edita','dialog_tabela',2)

            // definindo valores
            this.$set(this.item_edita, 'CODIGO_CADASTRO'    , ccadastro.CODIGO)
            this.$set(this.item_edita, 'NOME'               , ccadastro.NOME)
            this.$set(this.item_edita, 'CONTATO'            , ccadastro.CELULAR)

            // salvo os dados
            this.salvar_tabela(this.tabela_selecionada_agora, this.item_edita, 'dialog_tabela')

        }

        else if (acao == 'ALUNOS'){

           //atualizo no cadastro a data do processo.. uso isso quando clica em Selecionar Cadastro 
           let sql = 
           `
            UPDATE alunos
            SET DATA_PROCESSO = '${ccadastro.DATA_PROCESSO}',
                DESCRICAO_SERVICO = '${ccadastro.DESCRICAO}'
            WHERE CODIGO_ALUNO = ${ccadastro.CODIGO_ALUNO}
            AND ( (DATA_PROCESSO IS NULL OR DATA_PROCESSO <> '${ccadastro.DATA_PROCESSO}')
            OR (DESCRICAO_SERVICO IS NULL OR DESCRICAO_SERVICO <> '${ccadastro.DESCRICAO}'));
           `

        //    console.log('sql:', sql);
           await this.crud_sql(sql)

           await this.seleciona_aluno(ccadastro)
           
        }
      },

      calculateTop(time) {
        // Exemplo: converter o horário para pixels
        // Aqui, considere que um horário representa 60px, ajuste conforme necessário
        const [hours, minutes] = time.split(':').map(Number);
        const totalMinutes = hours * 60 + minutes;

        return this.cal ? this.cal.timeToY(totalMinutes) + 'px' : '-10px'
        // return `${totalMinutes}px`; // Ajuste a fórmula conforme necessário
      },

      getCurrentTime () {
        return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
      },

      scrollToTime() {
        const time = this.getCurrentTime()
        const first = Math.max(0, time - (time % 30) - 30)

        Object.values(this.$refs).forEach(cal => {
            cal?.scrollToTime(first)
        })
      },


      updateTime () {
        setInterval(() => this.cal.updateTimes(), 60 * 1000)
      },


        transformarHorarios() {
           const horariosArray = this.veiculo_selecionado.HORARIOS ? this.veiculo_selecionado.HORARIOS.split('\n') : [];
           

           // Adiciona o veículo selecionado ao objeto horarios_veiculo
           this.horarios_veiculo = {
                NOME          : this.veiculo_selecionado.NOME,
                DURACAO       : this.veiculo_selecionado.DURACAO,
                LIMITE_DIA    : this.veiculo_selecionado.LIMITE_DIA     > 0 ? this.veiculo_selecionado.LIMITE_DIA       : 100000,
                LIMITE_SEMANA : this.veiculo_selecionado.LIMITE_SEMANA  > 0 ? this.veiculo_selecionado.LIMITE_SEMANA    : 100000,
                LIMITE_TOTAL  : this.veiculo_selecionado.LIMITE_TOTAL   > 0 ? this.veiculo_selecionado.LIMITE_TOTAL     : 100000,
                HORARIOS      : horariosArray
            };



           // Expressão regular para validar o formato HH:MM
           const regexHora = /^([01]\d|2[0-3]):([0-5]\d)$/;

           // Filtrar apenas os horários válidos
           this.horarios_veiculo.HORARIOS = this.horarios_veiculo.HORARIOS.filter(horario =>
             regexHora.test(horario)
           );


           if (this.horarios_veiculo.HORARIOS.length === 0) {
              // caso nao tenha definido entao preencho manualmente
              this.horarios_veiculo.HORARIOS = [
                  '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', 
                  '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', 
                  '19:00', '20:00', '21:00', '22:00'
              ];

              this.horarios_veiculo.DURACAO = '60'
           }


           try{
             this.first_time = this.horarios_veiculo.HORARIOS[0] || '07:00'
           }catch(e){}
        },

        getColor(item){

            // console.log('item:', item);

            let ss = item.SITUACAO
            let r = ''
            
            // aqui é por tipo
            if ((item.TIPO == 'BLOQUEAR DIA') || (item.TIPO == 'BLOQUEAR') || (item.TIPO == 'BLOQUEAR INSTRUTOR')){
                r =  'red lighten-2'
            }
            
            else if (item.TIPO == 'FERIAS'){
                r =  'orange lighten-2'
            }


            // aqui é por situacao
            else if (ss == 'MARCADO'){
                r =  'grey lighten-0'
            }

            else if (ss == 'CONFIRMADO'){
                r =  '#800080'
                // r =  'green lighten-2'
            }

            else if (ss == 'CONCLUIDO'){
                r =  'green'
            }

            else if  (ss == 'FALTOU'){
                // r =  '#ff8080'
                r =  'red lighten-2'
            }

            else{
                r = 'blue'
            }

            return r
        },

        abre_img(titulo, url_img, mais){
          this.dialog_img        = true
          this.dialog_img_titulo = titulo
          this.dialog_img_url    = url_img
          this.dialog_img_mais   = mais
        },

        async abre_listas(){



            let sql = ''


            if(this.tipo_de_cliente == 'CHAMADA'){


                // FORNECEDORES
                sql = `select *  from tabela_fornecedores where ativo = 'S' order by nome`
                // console.log('sql:', sql);
                await this.crud_abrir_tabela(sql, 'lista_fornecedores')
                // this.lista_instrutores.unshift({CODIGO:'0', NOME:'TODOS'}) //no começo
            }


            if(this.tipo_de_cliente == 'CFC'){


                // INSTRUTORES
                sql = `select *  from instrutores where ativo = 'S' order by nome`
                // console.log('sql:', sql);
                await this.crud_abrir_tabela(sql, 'lista_instrutores')
                this.lista_instrutores.unshift({CODIGO:'0', NOME:'TODOS'}) //no começo




                // VEICULOS
                sql = `select *  from veiculos where ativo = 'S' order by placa`
                // console.log('sql:', sql);
                await this.crud_abrir_tabela(sql, 'lista_veiculos')

                // clonando sem o item TODOS
                this.lista_veiculos_slim = this.lista_veiculos.map((x) => x); //clonando array copiar array

                // adicionando o item TODOS
                this.lista_veiculos.unshift({CODIGO:'0', NOME:'TODOS', PLACA:'TODOS'}) //no começo


                //clonando array copiar array veiculos da categoria A
                this.lista_veiculos_A = this.lista_veiculos
                    .filter(x => x.CATEGORIA === 'A')   // filtra apenas categoria A
                    .map(x => ({ ...x }));              // cria cópia/clonagem de cada objeto

                // console.log('lista_veiculos_A:', this.lista_veiculos_A);
                



                // pega os dados atualizados
                if (this.veiculo_selecionado.CODIGO>0){
                    this.veiculo_selecionado  = Object.assign({}, this.lista_veiculos.find(veiculo => veiculo.CODIGO === this.veiculo_selecionado.CODIGO) )  
                }


                // this.lista_cadastros.unshift({CODIGO:'-6', NOME:'FERIAS'}) //no começo
                // this.lista_cadastros.unshift({CODIGO:'-5', NOME:'AULA EXTRA'}) //no começo
                // this.lista_cadastros.unshift({CODIGO:'-4', NOME:'EX.PRATICO'}) //no começo
                // this.lista_cadastros.unshift({CODIGO:'-3', NOME:'ALMOÇO'}) //no começo
                // this.lista_cadastros.unshift({CODIGO:'-2', NOME:'INTERVALO'}) //no começo
                // this.lista_cadastros.unshift({CODIGO:'-1', NOME:'LIVRE'}) //no começo

                this.lista_cadastros.unshift({CODIGO:'0' , NOME:'NENHUM'}) //no começo

            }


        },

        async define_dia(){
            this.today        = await get_data_hora('today')
            this.in_today     = await get_data_hora('today')
            this.selectedDate = await get_data_hora('today')

            this.rel_data_de  = await get_data_hora('today')
            this.rel_data_ate = await get_data_hora('today')

            this.carregou     = true

            this.tabela('agenda')

            // if (this.tipo_de_cliente=='CFC'){
            //     this.tabela('agenda')
            // }
            // else{
            //     this.tabela('agenda_2')
            // }
        
        },


        async go_menu_data_clicada(item){
            // viewDay mostra o dia selecionado, caso nao utilize esta funcao
            // console.log('item:', item);


            this.dia_clicou = item.date

            // coloquei esse timer pq dava conflito com o getEvents
            setTimeout(function(){
                this.monta_menu_de_tabelas('menu_data_clicada')
            }.bind(this), 555);

            
            
        },


        async renomeiaPropredades(item) {

            //obj para string 
           let ss =  JSON.stringify(item)

           // campos para renomear
           ss = ss.replaceAll('"start"'     , '"x_start"') 
           ss = ss.replaceAll('"end"'       , '"x_end"') 
           ss = ss.replaceAll('"name"'      , '"x_name"') 
           ss = ss.replaceAll('"color"'     , '"x_color"') 
           ss = ss.replaceAll('"timed"'     , '"x_timed"') 
           

          //volta string para objeto    
           item = JSON.parse(ss)

           this.item_edita  = Object.assign({}, item)  


        },


        // cliclou_evento
        async abre_evento(item){

            // console.log('abre_evento:', item);
            // console.log('abre_evento:', item.event);
            
            // if (!this.pode_alterar()){
            //     alert('Somente Visualização!')
            //     item.nativeEvent.stopPropagation()
            //     return false   
            // }

            // mostro menu com opcoes
            this.monta_menu_de_tabelas('menu_evento')
            this.rightClick(item.event, false)


            // aqui abriria o dialog de edição 
        //    await this.editar_tabela(item.event, 'item_edita', 'dialog_tabela')
        //    await this.renomeiaPropredades(this.item_edita)

            item.nativeEvent.stopPropagation()
        },

        async pre_clicou_hora(item, calendar){

            // console.log('item:', item);
            // console.log('calendar:', calendar);
            
            
            // if (this.cadastro_selecionado.CODIGO == 0){
            if (this.tipo_selecionado == 'AGENDA'){
                
                this.item_horario_clicado  =  Object.assign({}, item) //copia objeto quando clica no horario para agendar

                this.texto_1      = ''  
                this.dialog_texto = true
                //chamo a funcao no botao salvar passando o item como item_horario_clicado
                
            }
            else{
                await this.clicou_hora(item, calendar)
            }

        },

        async clicou_hora(item, calendar){
            // console.log('clicou_hora:', item);

            if (!this.pode_alterar()){
                alert('Somente Visualização')
                return false
            }


            // verifica conflito entre alunos e carros
            let restricao_carro_aluno = true

            if (this.tipo_selecionado !== 'AGENDA'){

                

                if ( ['BLOQUEAR INSTRUTOR'].some(el => this.tipo_selecionado.includes(el)) ){
                    //so vai agendar dados do instrutor entao nao precisa verificar
                    restricao_carro_aluno = false 
                }


                if (! ['BLOQUEAR DIA', 'FERIAS','BLOQUEAR','BLOQUEAR INSTRUTOR'].some(el => this.tipo_selecionado.includes(el)) ){
                 


                    
                    // caso seja agenda dupla, seleciona o veiculo conforme o calendario que clicou
                    if (this.agenda_multipla){

                        // let numero = calendar.split('-')[1];//pega o codigo do veiculo
                        // pega o veiculo conforme o calendar clicado
                        // this.veiculo_selecionado = this.lista_veiculos.find(v => numero.includes(v.CODIGO))

                       await this.seleciona_veiculo_coluna(calendar)
                       
                    }
                    

                    // necessario selecionar o veiculo
                    if (this.veiculo_selecionado.CODIGO<1){
                        this.alerta('Selecione o Veículo', 'orange')
                        // alert('Sem Veículo')
                        return false
                    }
                    

                }

                
                if (! ['BLOQUEAR DIA', 'FERIAS','BLOQUEAR','BLOQUEAR INSTRUTOR'].some(el => this.tipo_selecionado.includes(el)) ){

                    // nao precisa alertar quando nesta situacao
                    if (this.cadastro_selecionado.CODIGO == 0){
                        // this.alerta('Sem Cadastro', 'orange')
                        alert('Sem Cadastro')
                        // return false
                    }
                }


                if (this.instrutor_selecionado.CODIGO<1){
                    // this.alerta('Selecione o Instrutor', 'orange')
                    alert('Sem Instrutor')
                    // return false
                }

            }
            



            // verifica a validade do processo = 1 ano
            // if (this.cadastro_selecionado.CODIGO_ALUNO>0){
            if (this.cadastro_selecionado.CODIGO_ALUNO){

                let meses = 12//validade de 12 meses
                const validade_processo = this.incMonth(this.cadastro_selecionado.DATA_PROCESSO, meses ,'us')
                
                const data_valida      = new Date(validade_processo);
                const data_clicada     = new Date(item.date);


                if (this.cadastro_selecionado.POSSUI_ATRASO =='SIM'){
                    if ( !confirm(`** Cadastro com Parcela Atrasada! ** \nContinuar mesmo assim?`) ){
                            return false
                    }                    
                }


                if (!isNaN(data_valida.getTime())){
                    // alert('data valida')

                    if (data_valida <= data_clicada){
                        // this.alerta(`Data do Processo: ${this.cadastro_selecionado.x_DATA_PROCESSO} <br> Verifique a validade do Processo!`, 'orange')
                        if ( !confirm(`Data do Processo: ${this.cadastro_selecionado.x_DATA_PROCESSO} \nContinuar mesmo assim?`) ){
                                return false
                        }
                    }
                }
                
            }
            

            // alert(item.time)
            // let hora = await this.trata_hora(item.time, this.lista_horarios)
            let hora = await this.trata_hora(item.time, this.horarios_veiculo.HORARIOS)
            // alert(hora)


            // console.log('item:', item);
            console.log('this.item_edita:', this.item_edita);

            // verifica conflito entre alunos e carros
            if (restricao_carro_aluno){
                let restricoes = await this.restricoes_agendamento(item, hora)
                if (!restricoes ){
                    // this.alerta('Selecione um Cadastro', 'orange')
                    return false
                }
            }


            // abre modal
            this.nova_tabela('item_edita','dialog_tabela')
            // this.dialog_tabela = true//fecha modal


            let intervalo = this.horarios_veiculo.DURACAO || 10
            let hora_fim  = DSibasico.incMinutes(hora, intervalo )
            hora_fim      =  hora_fim.substring(0, 5);


            // se for bloquear o dia, define hora inicio e fim por aqui
            if ( ['BLOQUEAR DIA', 'FERIAS'].some(el => this.tipo_selecionado.includes(el)) ){
                hora     = '06:00'
                hora_fim = '23:00'
            }

            

            // define valores default
            this.$set(this.item_edita, 'ATIVO'              , 'S')
            this.$set(this.item_edita, 'TIPO'               , this.tipo_selecionado)
            this.$set(this.item_edita, 'CODIGO_ALUNO'       , this.cadastro_selecionado.CODIGO_ALUNO || this.cadastro_selecionado.CODIGO)
            this.$set(this.item_edita, 'CODIGO_VEICULO'     , this.veiculo_selecionado.CODIGO)
            this.$set(this.item_edita, 'CODIGO_INSTRUTOR'   , this.instrutor_selecionado.CODIGO)

            this.$set(this.item_edita, 'DATA'               , item.date)
            this.$set(this.item_edita, 'HORA'               , hora)
            this.$set(this.item_edita, 'HORA_FIM'           , hora_fim)
            this.$set(this.item_edita, 'DURACAO'            , intervalo)
            this.$set(this.item_edita, 'SITUACAO'           , 'MARCADO')

            if (this.cadastro_selecionado.CODIGO > 0){
                this.$set(this.item_edita, 'ALUNO'              , this.cadastro_selecionado.NOME)
            }

            if (this.tipo_selecionado == 'AGENDA'){
                this.$set(this.item_edita, 'DESCRICAO'          , this.texto_1)
            }


            this.$set(this.item_edita, 'PROCESSO'           , this.cadastro_selecionado.PROCESSO)
            this.$set(this.item_edita, 'PLACA'              , this.veiculo_selecionado.PLACA)
            this.$set(this.item_edita, 'CATEGORIA'          , this.veiculo_selecionado.CATEGORIA)
            this.$set(this.item_edita, 'INSTRUTOR'          , this.instrutor_selecionado.NOME)
            
            this.$set(this.item_edita, 'QUEM_ALTEROU'       , DSibasico.get_quem_alterou())




            // bloqueia so o instrutor, nao pega dados do veiculo
            if (this.tipo_selecionado == 'BLOQUEAR INSTRUTOR'){
                // this.$set(this.item_edita, 'TIPO'               , 'BLOQUEAR')
                this.$set(this.item_edita, 'CODIGO_VEICULO'     , 0)
                this.$set(this.item_edita, 'PLACA'              , '')
                this.$set(this.item_edita, 'CATEGORIA'          , '')
            }


            await this.salvar_tabela(this.tabela_selecionada, this.item_edita, 'dialog_tabela')
            await this.aulas_alunos(this.cadastro_selecionado.CODIGO_ALUNO || this.cadastro_selecionado.CODIGO)


        },

        async gera_lista_horas() {
            const { first_time, interval_count, interval_minutes } = this; // Desestruturação das propriedades

            // alert(interval_minutes)
            // this.interval_minutes = 5
            const timeSlots = [];
            const start = new Date(`1970-01-01T${first_time}`); // Cria um objeto Date a partir da hora inicial

            // Gera os horários começando pelo primeiro horário
            for (let i = 0; i < interval_count; i++) {
                const newTime = new Date(start.getTime() + (i * interval_minutes * 60000)); // Adiciona o intervalo em milissegundos
                const formattedTime = newTime.toTimeString().slice(0, 5); // Formata para 'HH:mm'

                // Adiciona apenas horários que são iguais ou posteriores ao first_time
                if (formattedTime >= first_time.slice(0, 5)) {
                    timeSlots.push(formattedTime); // Adiciona ao array
                }
            }

            this.lista_horarios = timeSlots;
            // return timeSlots; // Retorna o array de horários
        },


        showIntervalLabel (interval) {
        //    return interval.minute === 0
        // console.log('showIntervalLabel:', interval);
        
           return interval
        },


        getStartOfWeek(date) {
            const day = new Date(date);
            const dayOfWeek = day.getDay(); // Domingo é 0, Sábado é 6
            const diff = day.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Ajusta para segunda-feira
            return new Date(day.setDate(diff));
        },

        async onCreated(){
            this.isMobile = window.innerWidth < 800

            this.value_expansion_2 = (this.isMobile) ? null : 0

            await this.ler_sessions()
            await this.abre_listas()
            await this.gera_lista_horas()
            await this.define_dia()
        },

        viewDay ({ date }) {
            this.focus = date
            this.type = 'day'
        },


        async trata_hora(time, horarios) {
                    
            // faz com que pegue os horarios com base no array da lista de horas
            // console.log('time:', time);
            
            const [hourStr, minuteStr] = time.split(':');
            const hour = parseInt(hourStr, 10);
            const minutes = parseInt(minuteStr, 10);
            
            const selectedTotalMinutes = hour * 60 + minutes;

            // Obtém os slots de horário gerados
            // console.log('this.lista_horarios:', this.lista_horarios);
            const timeSlots = horarios 

            
            let finalTime = '';

            // Percorre a lista de horários para encontrar o mais apropriado
            for (let i = 0; i < timeSlots.length; i++) {
                const slot = timeSlots[i];
                const [slotHour, slotMinute] = slot.split(':');
                const slotTotalMinutes = parseInt(slotHour, 10) * 60 + parseInt(slotMinute, 10);
                
                // Verifica se o horário selecionado não passou do próximo slot
                if (selectedTotalMinutes < slotTotalMinutes) {
                    // Se for o primeiro slot, usa ele
                    if (i === 0) {
                        finalTime = slot; // Usa o primeiro slot
                    } else {
                        // Caso contrário, usa o slot anterior
                        finalTime = timeSlots[i - 1];
                    }
                    break; // Sai do loop
                } else if (i === timeSlots.length - 1) {
                    // Se for o último slot e o horário clicado for maior ou igual, usa o último slot
                    finalTime = slot; 
                }
            }

            // Exibe ou usa o horário final
            // alert(`Horário selecionado: ${finalTime}`);
            return finalTime
        },

        showEvent ({ nativeEvent, event }) {


            const open = () => {
            this.selectedEvent = event
            this.selectedElement = nativeEvent.target
            requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            }

            if (this.selectedOpen) {
            this.selectedOpen = false
            requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
            open()
            }

            nativeEvent.stopPropagation()
        },

        intervalFormat(interval) {

            // console.log('intervalFormat;', interval );

               // Verifica se o intervalo está na lista_horarios
            try{   
                if (this.horarios_veiculo.HORARIOS.length === 0) {
                    // caso nao tenha definido horario, mostra somente horas em ponto
                    if (interval.minute == '00'){
                        return interval.time
                    }
                }
                else if (this.horarios_veiculo.HORARIOS.includes(interval.time)){
                    // console.log('intervalFormat;', interval );
                    return interval.time; // Retorna o horário se estiver na lista
                }
            }catch(e){
                    // caso nao tenha definido horario, mostra somente horas em ponto
                    if (interval.minute == '00'){
                        return interval.time
                    }
            }

            // return `${interval.start} - ${interval.end}`
        },

        retorna_altura(menos){
            // let r = '100vh'
            // let r = '720'
            let r = (window.innerHeight - 80 - 60)
            let height = window.innerHeight;

            if (menos){
            r = (r - menos)
            }

            return r
        },

        getEvents ({ start, end }) {

            // alert('change')
            // console.log('start:', start);
            // console.log('end:', end);

        
            this.data_inicial = start
            this.data_final   = end

            
            // isto estava executando antes de carregar as coisas la em onCreated, porisso fiz esse carregou
            if (!this.carregou){
                return false
            }

            this.tabela('agenda')
            

            // this.getStartOfWeek()

            return false
            const events = []

            const min = new Date(`${start.date}T00:00:00`)
            const max = new Date(`${end.date}T23:59:59`)
            const days = (max.getTime() - min.getTime()) / 86400000
            const eventCount = this.rnd(days, days + 20)

            for (let i = 0; i < eventCount; i++) {
            const allDay = this.rnd(0, 3) === 0
            const firstTimestamp = this.rnd(min.getTime(), max.getTime())
            const first = new Date(firstTimestamp - (firstTimestamp % 900000))
            const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
            const second = new Date(first.getTime() + secondTimestamp)

            events.push({
                name: this.names[this.rnd(0, this.names.length - 1)],
                start: first,
                end: second,
                color: this.colors[this.rnd(0, this.colors.length - 1)],
                timed: !allDay,
            })
            }

            this.events = events
        },

      getEventColor (event) {
        return event.color
      },

      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },


        async ler_sessions(){


            // ativado em App.vue
            this.agenda_show = sessionStorage['agenda_show'] == 'S'


            if (!this.agenda_show){
                window.location.replace("https://www.google.com") 
                return false
            }

            // console.log('ler_sessions uma tag..se nula fecha janela..para nao usar o logado aqui');


            await DSisql.crud_empresa()//atualiza dados da empresa

            try { this.obj_user = JSON.parse(sessionStorage['obj_user']) }
            catch (error) { console.log('erro:', error); }

            try { this.obj_dados_empresa = JSON.parse(sessionStorage['obj_dados_empresa']) }
            catch (error) { console.log('erro:', error); }

            try{
              this.filtrar_instrutor = JSON.parse(sessionStorage['filtrar_instrutor'])
            }catch(e){}
            
            try{
              this.veiculo_selecionado = JSON.parse(sessionStorage['veiculo_selecionado'])
            }catch(e){}

            try{
              this.instrutor_selecionado = JSON.parse(sessionStorage['instrutor_selecionado'])
            }catch(e){}

            try{
              this.tipo_selecionado = JSON.parse(sessionStorage['tipo_selecionado'])
            }catch(e){}

            try{
              this.cadastro_selecionado = JSON.parse(sessionStorage['cadastro_selecionado'])
              this.lista_cadastros.push(this.cadastro_selecionado);//add na lista pra mostrar
              await this.aulas_alunos(this.cadastro_selecionado.CODIGO_ALUNO || this.cadastro_selecionado.CODIGO)
            }catch(e){}

            try{
              this.value_expansion_1 = JSON.parse(sessionStorage['agenda_value_expansion_1'])
            }catch(e){}


            // if  (await DSibasico.esta_empresa('novo horizonte')) {
                this.mostrar_dupla = true
            // }

            this.tipo_de_cliente = mostrar_tipo_cliente()
            if (this.tipo_de_cliente == 'CHAMADA'){
                this.value_expansion_1 = 0
            }

        },
    

        async tabela(tabela, item, nref){
        //passo 3 executo a acao quando clicar nos items e monto os campos editaveis e os campos do data-table

        
            // console.log('tabela:', tabela);
            // console.log(item);
            // this.icone_tabela_sel = item.icon

            if (tabela=='sub_agenda') {
                nref = 2
            }
        
            if (nref>0){ nref = '_'+nref }else{ nref = ''}
            
            
            if (!item){
             sessionStorage['tabela_clicou']   = tabela
             sessionStorage['tabela_titulo']   = this.card_titulo
            }

            this.rodape = false

            this['search'+nref] = ''//limpa filtro
            this['tabela_selecionada'+nref] = tabela


            //limpa array
            this['items_lista'+nref]      = [] //recebe os dados do sql
            this['items_header'+nref]     = [] //campos que tem que mostrar no header
            this['items_editaveis'+nref]  = [] //campos editaveis mas nao tem que mostrar no header

            this.monta_menu_de_tabelas(tabela)

    
            if (tabela=='sub_agenda') {
                
                this['items_header'+nref] = [
                
                  { text: '..', value: 'actions', sortable: false, type:'hide', cols:'0', width:'50px'},
                  
                //   { text: 'CODIGO_AGENDA', value: 'CODIGO_AGENDA', tag:'v-text', type:'text', cols:'2', rule:'N' },
                //   { text: 'CODIGO_CADASTRO', value: 'CODIGO_CADASTRO', tag:'v-text', type:'text', cols:'2', rule:'N' },
                  { text: 'NOME', value: 'NOME', tag:'v-text', type:'text', cols:'3', rule:'S',upper:'S', disabled:'S', width:'250px' },

                  { text: 'APR.', value: 'SITUACAO',
                    type:'text',
                    tag:'v-select',
                    tag_items:[
                        'S',
                        'N',
                        ],
                        cols:'1',rule:'N',hint:'Aprovado' 
                  },

                  { text: 'CONTATO', value: 'CONTATO', tag:'v-text', type:'text', cols:'2', rule:'N',vmask:'cel', width: '160px' },      
                  { text: 'SEXO', value: 'x_SEXO', tag:'v-text', type:'text', cols:'2', rule:'N',vmask:'cel', width: '150px' },      
                  { text: 'CPF', value: 'x_CPF', tag:'v-text', type:'text', cols:'2', rule:'N',vmask:'cpf', width: '150px' },      

                  { text: 'PRES.', value: 'VISTO',
                    type:'text',
                    tag:'v-select',
                    tag_items:[
                        'S',
                        'N',
                        ],
                        cols:'1',rule:'N' ,
                        hint:'Presente'
                  },
                  
                //   { text: 'x_NOME_PIX', value: 'x_NOME_PIX', tag:'v-text', type:'text', cols:'2', rule:'N',vmask:'cpf', width: '150px' },      
                  
                //   { text: 'x_EMAIL', value: 'x_EMAIL', tag:'v-text', type:'text', cols:'2', rule:'N',vmask:'cpf', width: '150px' },      
                //   { text: 'x_PROFISSAO', value: 'x_PROFISSAO', tag:'v-text', type:'text', cols:'2', rule:'N',vmask:'cpf', width: '150px' },      

                
                  { text: 'CADASTRADO', value: 'DATA_CADASTRADO', tag:'v-text', type:'text', cols:'2', rule:'N',width:'140px'},
                  { text: 'CODIGO', value: 'CODIGO', type:'number', cols:'0' },

                  ]

                  // clono os items
                //   this.items_editaveis = this.items_header.map((x) => x); //clonando array copiar array
                  this['items_editaveis'+nref] = this['items_header'+nref].map((x) => x); //clonando array copiar array

                 // METODO NOVO
                //   this['items_header'+nref] = this['items_header'+nref].filter(x => x.value !== "actions");


                  //edicao   
                //   this['items_editaveis'+nref] = this['items_editaveis'+nref].filter(x => x.value !== "NOME");
                  this['items_editaveis'+nref] = this['items_editaveis'+nref].filter(x => x.value !== "DATA_CADASTRADO");
                  this['items_editaveis'+nref] = this['items_editaveis'+nref].filter(x => x.value !== "x_SEXO");
                  this['items_editaveis'+nref] = this['items_editaveis'+nref].filter(x => x.value !== "x_CPF");

                 let sql = `

                    SELECT 
                        s.*,
                        a.CPF as x_CPF,
                        a.SEXO as x_SEXO,
                        a.DADOS_PIX as x_DADOS_PIX,
                        a.NOME_PIX as x_NOME_PIX,
                        a.PROFISSAO as x_PROFISSAO,
                        a.STATUS as x_STATUS,
                        a.EMAIL as x_EMAIL,
                        a.OBSERVACAO as x_OBSERVACAO,
                        a.OBSERVACAO_2 as x_OBSERVACAO_2,
                        a.OBSERVACAO_3 as x_OBSERVACAO_3,
                        a.OBSERVACAO_4 as x_OBSERVACAO_4

                    FROM sub_agenda s

                    LEFT OUTER JOIN alunos a 
                        ON s.CODIGO_CADASTRO = a.CODIGO

                    WHERE s.CODIGO_AGENDA = ${this.obj_clicado.CODIGO}

                    ORDER BY s.CODIGO;`
                 
                //   console.log(tabela+': '+sql);
                  await this.crud_abrir_tabela(sql, 'items_lista'+nref)
                          

            }

            if ((tabela=='agenda') && (this.tipo_de_cliente=='CHAMADA')) {
                

                this['items_header'+nref] = [
                
                  { text: '..', value: 'actions', sortable: false, type:'hide', cols:'0',width: this.w_actions},
                  { text: 'DATA', value: 'DATA', tag:'v-text', type:'date', cols:'2', width: this.w_data,rule:'N' },      
                  { text: 'HORA', value: 'HORA', tag:'v-text', type:'time', cols:'1', rule:'N', col_class:'ml-n2 Xtext_field_menor' },      
                //   { text: 'FIM', value: 'HORA_FIM', tag:'v-text', type:'text', cols:'1', rule:'N' },      
                //   { text: 'DURACAO', value: 'DURACAO', tag:'v-text', type:'text', cols:'1', rule:'N' }, 


                  { text: 'Empresa', value: 'CODIGO_FORNECEDOR',
                          type:'text',
                          tag:'v-select',
                          tag_items: this.lista_fornecedores,
                          tag_item_text : 'NOME',
                          tag_clear:'S',
                          cols:'3' ,
                          hint:'',
                          rule:'S',
                          col_class:'pl-5'
                  },

                //   { text: 'Valor Diária', value: 'double_VALOR', tag:'v-text', type:'text', cols:'2', rule:'N',upper:'N', width:'65px' },
                  { text: 'Descrição', value: 'DESCRICAO', tag:'v-text', type:'text', cols:'3', rule:'N',upper:'S', width:'210px' },      

                //   { text: 'x_NOME_FORNECEDOR', value: 'x_NOME_FORNECEDOR', tag:'v-text', type:'text', cols:'3', rule:'N',upper:'S', width:'210px' },      
     
                //   { text: 'TIPO', value: 'TIPO', tag:'v-text', type:'text', cols:'1', rule:'N' },      
                //   { text: 'ATIVO', value: 'ATIVO', tag:'v-text', type:'text', cols:'1', rule:'N' },      
                  { text: 'LIMITE', value: 'LIMITE', tag:'v-text', type:'number', cols:'1', rule:'N' },

                  { text: 'SITUACAO', value: 'SITUACAO',
                        type:'text',
                        tag:'v-select',
                        tag_items:[
                            'ATIVO',
                            'CONCLUIDO',
                            'CANCELADO',
                        ],
                        cols:'2',rule:'N' 
                  },


                  { text: 'Valor da Diária', value: 'double_VALOR', tag:'v-text', type:'text', cols:'2', rule:'S',upper:'N', width:'65px' },



                  { text: 'CODIGO', value: 'CODIGO', type:'number', cols:'0' },

                  ]

                  // clono os items
                //   this.items_editaveis = this.items_header.map((x) => x); //clonando array copiar array
                  this['items_editaveis'+nref] = this['items_header'+nref].map((x) => x); //clonando array copiar array


                 // METODO NOVO
                  this['items_header'+nref] = this['items_header'+nref].filter(x => x.value !== "actions");
                  this['items_header'+nref] = this['items_header'+nref].filter(x => x.value !== "DATA");
                  this['items_header'+nref] = this['items_header'+nref].filter(x => x.value !== "HORA_FIM");
                  this['items_header'+nref] = this['items_header'+nref].filter(x => x.value !== "DURACAO");
                  this['items_header'+nref] = this['items_header'+nref].filter(x => x.value !== "TIPO");
                  this['items_header'+nref] = this['items_header'+nref].filter(x => x.value !== "ATIVO");
                  this['items_header'+nref] = this['items_header'+nref].filter(x => x.value !== "CODIGO_FORNECEDOR");


                 let sql = `
                    SELECT 
                        agenda.*,
                        tabela_fornecedores.nome AS x_NOME_FORNECEDOR
                    FROM agenda
                    LEFT JOIN tabela_fornecedores 
                        ON agenda.CODIGO_FORNECEDOR = tabela_fornecedores.codigo
                    WHERE 
                        agenda.ATIVO = 'S'
                        AND agenda.DATA = '${this.in_today}'
                    ORDER BY agenda.HORA
                 `

                 
                //    console.log(tabela+': '+sql);
                //   await this.crud_abrir_tabela(sql, 'items_lista')
                  await this.crud_abrir_tabela(sql, 'items_lista'+nref)
                          

            }

            else if (tabela=='agenda'){
                
                
                this.items_header = [

                
                  { text: '..', value: 'actions', sortable: false, type:'hide', cols:'0',width: this.w_actions},
                  // { text: 'CODIGO', value: 'CODIGO', type:'number', cols:'0' },              
                //   { text: 'ALUNO', value: 'CODIGO_ALUNO', tag:'v-text', type:'text', cols:'2', rule:'N' },      
                //   { text: 'VEICULO', value: 'CODIGO_VEICULO', tag:'v-text', type:'text', cols:'2', rule:'N' },   
                // { text: 'INSTRUTOR', value: 'CODIGO_INSTRUTOR', tag:'v-text', type:'text', cols:'2', rule:'N' },      

                  { text: 'VEICULO', value: 'CODIGO_VEICULO',
                      type:'text',
                      tag:'v-autocomplete',
                      tag_items: this.lista_veiculos,

                      item_value:'CODIGO',
                      item_text : 'PLACA',
                      return_object : false,

                      cols:'2',rule:'S' , upper:'S'
                  },
                  
                  { text: 'INSTRUTOR', value: 'CODIGO_INSTRUTOR',
                      type:'text',
                      tag:'v-autocomplete',
                      tag_items: this.lista_instrutores,

                      item_value:'CODIGO',
                      item_text : 'NOME',
                      return_object : false,

                      cols:'2',rule:'S' , upper:'S'
                  },

                  
                  { text: 'DATA', value: 'DATA', tag:'v-text', type:'date', cols:'2', width: this.w_data,rule:'N' },      
                  { text: 'HORA', value: 'HORA', tag:'v-text', type:'text', cols:'1', rule:'N' },      
                  { text: 'FIM', value: 'HORA_FIM', tag:'v-text', type:'text', cols:'1', rule:'N' },      
                  { text: 'DURACAO', value: 'DURACAO', tag:'v-text', type:'text', cols:'1', rule:'N' },      

                  { text: 'TIPO', value: 'TIPO',
                        type:'text',
                        tag:'v-select',
                        tag_items: this.tipo_lista,
                        cols:'2',rule:'N' 
                  },
                  
                  { text: 'SITUACAO', value: 'SITUACAO',
                        type:'text',
                        tag:'v-select',
                        tag_items:[
                            'MARCADO',         
                            'CONFIRMADO',         
                            'CONCLUIDO',         
                            'FALTOU',
                        ],
                        cols:'2',rule:'N' 
                  },

                  { text: 'ANOTAÇÃO', value: 'DESCRICAO', tag:'v-text', type:'text', cols:'9', rule:'N',upper:'S' },      

                  ]

                  // clono os items
                  this.items_editaveis = this.items_header.map((x) => x); //clonando array copiar array

                  let cod_instrutor  = ((this.filtrar_instrutor) && (this.instrutor_selecionado.CODIGO)) || 0
                  let cod_veiculo    = ((this.filtrar_veiculo)   && (this.veiculo_selecionado.CODIGO))   || 0


                 let sql = `
                 SELECT 
                    a.CODIGO, 
                    a.CODIGO_ALUNO, 
                    a.CODIGO_VEICULO, 
                    a.CODIGO_INSTRUTOR, 
                    a.DATA, 
                    a.HORA, 
                    a.HORA_FIM, 
                    a.DESCRICAO, 
                    a.SITUACAO, 
                    a.DURACAO,
                    a.ALUNO,
                    a.PROCESSO,
                    a.CATEGORIA,
                    a.QUEM_ALTEROU,
                    a.TIPO,
                    COALESCE(v.NOME      , '.'          ) AS x_NOME_VEICULO, 
                    COALESCE(v.PLACA     , a.PLACA      ) AS x_PLACA,           /* caso seja removido o veiculo ou instrutor */
                    COALESCE(i.NOME      , a.INSTRUTOR  ) AS x_NOME_INSTRUTOR,   /* caso seja removido o veiculo ou instrutor */
                    COALESCE(i.FOTO_URL  , ''           ) AS x_FOTO_URL_INSTRUTOR   /* caso seja removido o veiculo ou instrutor */
                FROM 
                    agenda a
                LEFT JOIN 
                    veiculos v ON a.CODIGO_VEICULO = v.CODIGO 
                LEFT JOIN 
                    instrutores i ON a.CODIGO_INSTRUTOR = i.CODIGO 

                WHERE      a.ATIVO = 'S' AND
                           DATA BETWEEN '${this.data_inicial.date}' and '${this.data_final.date}'
                            ${(cod_instrutor>0) ? `and CODIGO_INSTRUTOR = ${cod_instrutor}` : ''} 
                            ${(cod_veiculo>0)   ? `and CODIGO_VEICULO   = ${cod_veiculo}`   : ''} 
                            order by a.HORA desc
                 `

                 
                //    console.log(tabela+': '+sql);
                  await this.crud_abrir_tabela(sql, 'items_lista')
            

                

                // Mapeia a lista adicionando start e end
                this.items_eventos = this.items_lista.map(item => {
                    const start = `${item.DATA}T${(item.HORA)}`;
                    const end = `${item.DATA}T${(item.HORA_FIM)}`;

                    return {
                        ...item,
                        start   : start,
                        end     : end,
                        name    : `${item.x_PLACA} - ${item.x_NOME_INSTRUTOR} - ${item.DESCRICAO}`,
                        // name    : item.DESCRICAO,
                        // color   : item.COLOR || "blue", // Use uma cor padrão se não especificada
                        color   : this.getColor(item), // Use uma cor padrão se não especificada
                        timed   : true   // Indica que é um evento com horário
                    };
                });

                // console.log('items_eventos:', this.items_eventos);

                if (this.instrutor_selecionado.NOME == 'NIUSAX'){
                // if ((this.instrutor_selecionado.NOME == 'NIUSA') || (this.instrutor_selecionado.NOME == 'JUNIOR')){

                    //clonando array copiar array
                    this.items_eventos_2 = this.items_eventos.map((x) => x);


                    // FILTRA MOTO 1
                    this.items_eventos = this.items_eventos.filter(evento => evento.x_PLACA.includes("8J17"));
                    this.placa_1 = this.lista_veiculos_A[0].PLACA
                    // this.items_eventos = this.items_eventos.filter(evento => evento.x_PLACA.includes(this.lista_veiculos_A[0].PLACA));
                    // console.log(this.lista_veiculos_A[0].PLACA);
                    

                    // FILTRA MOTO 2
                    this.items_eventos_2 = this.items_eventos_2.filter(evento => evento.x_PLACA.includes('0D57'));
                    this.placa_2         = this.lista_veiculos_A[1].PLACA
                    // this.items_eventos_2 = this.items_eventos_2.filter(evento => evento.x_PLACA === "BCY-0D57");
                    // this.items_eventos_2 = this.items_eventos_2.filter(evento => evento.x_PLACA.includes(this.lista_veiculos_A[1].PLACA));
                    // console.log(this.lista_veiculos_A[0].PLACA);

                }

 

                

            }

        },

        async before_update(tabela){
        // passo 8 antes de salvar verifico alguns campos necessarios em determinada tabela


            // VERIFICA CAMPOS NUMERICOS QUE NAO PODEM IR VAZIOS
            let VERIFICAR = [
                // 'LANCAMENTOS|DATA|null',
            ]
            
            let CAMPOS      = []
            let CAMPO_VER   = ''
            let CAMPO_VALOR = ''
            for (let i = 0; i < VERIFICAR.length; i++) {
                
                CAMPOS      = VERIFICAR[i].split("|");//divide
                CAMPO_VER   = CAMPOS[1]
                CAMPO_VALOR = this.item_edita[CAMPO_VER]

                if (tabela==CAMPOS[0]){//verifica se é a tabela selecionada
                    if (!CAMPO_VALOR){//verifica se vazio
                    this.$set(this.item_edita, CAMPOS[1], CAMPOS[2] ) 
                    }
                }
            }
        },

        async ultimo_click(){


          let tabela = sessionStorage['tabela_clicou']

          if (this.pro_tabela){
            this.card_titulo = this.pro_titulo
            await this.tabela(this.pro_tabela,'')

            sessionStorage['tabela_clicou'] = this.pro_tabela
          }
          else if (tabela){
              this.card_titulo = sessionStorage['tabela_titulo'] 
              await this.tabela(tabela,'')
          }


          
          //   ja abre em modo edicao
          if (this.pro_modo_edicao){

              if (this.pro_obj_1){
                // alert('editar')
                this.editar_tabela(this.pro_obj_1, 'item_edita', 'dialog_tabela')
              }
              else{
                // alert('novo')
                this.nova_tabela('item_edita','dialog_tabela')
              }
         }

        },

        meu_keyup(event,campo,upper){
  
          //identifica se o campo é double e muda o display
          if ((campo.includes('double_') || campo.includes('VALOR')) ){
              this.item_edita[campo] =  this.moeda(event)
              // @keyup="editedItem.double_credito = moeda($event)"
          }
          else if (campo.includes('CEP')) {
  
              this.consulta_cep(this.item_edita[campo])    
          }
          else{
              if ((campo.includes('EMAIL')==false) &&
              (campo.includes('SENHA')==false) &&
              (campo.includes('SENHA_WEB')==false)){
  
                  if (upper !=='N'){
                  this.allUpper(event, campo)
                  }
                  
              }
          }
        },

        allUpper(event, field){
              let a = event.target.value;//captura o valor do event
              if (a!==''){  
                  a = a.toUpperCase();
                  this.item_edita[field] = a;
              } 
        },

        firstUpper(event, field){
              // console.log(event);
              let a = event.target.value;//captura o valor do event

              if (a!=='' && a.length==1){  
                a = a.toUpperCase();
                // this.item_edita[field] = a;

                event.target.value = a
              } 
          },


        getVmask(qual){
            
            if (qual == 'cel'){
                return "(##) #####-####"
            }
            else if (qual == 'fone'){
                return "(##) ####-####"
            }
            else if (qual == 'cnpj'){
                return "##.###.###/####-##"
            }
            else if (qual == 'cpf'){
                return "###.###.###-##"
            }
            else if (qual == 'cep'){
                return "#####-###"
            }
            else{
                return ""
            }
          },
 

        define_defaults(tabela){

            // passo 7 defino valores default para alguns campos de determinada tabela
            if (tabela=='sub_agenda') {
   
                this.$set(this.item_edita, 'CODIGO_AGENDA'    , this.obj_clicado.CODIGO)
                this.$set(this.item_edita, 'CODIGO_CADASTRO'  , 0)
                this.$set(this.item_edita, 'SITUACAO'         , 'N')
                this.$set(this.item_edita, 'VISTO'            , 'N')
                this.$set(this.item_edita, 'NOME'             , 'NOME..')
                this.$set(this.item_edita, 'DATA_CADASTRADO'  , get_data_hora('data_hora'))
            }
            
            else if ((tabela=='agenda') && (this.tipo_de_cliente=='CHAMADA')) {
   
                // this.tabela_selecionada = 'agenda'

                this.$set(this.item_edita, 'ATIVO'          , 'S')
                this.$set(this.item_edita, 'TIPO'           , 'CHAMADA')
                this.$set(this.item_edita, 'DESCRICAO'      , '')
                this.$set(this.item_edita, 'SITUACAO'       , 'ATIVO')
                this.$set(this.item_edita, 'HORA'           , '12:00')
                // this.$set(this.item_edita, 'HORA_FIM'       , '13:00')
                this.$set(this.item_edita, 'DURACAO'        , 60)
                this.$set(this.item_edita, 'LIMITE'         , 0)
                this.$set(this.item_edita, 'DATA'           , this.in_today)

            }

            else if (tabela=='agenda'){
            //  this.$set(this.item_edita, 'CODIGO_ALUNO', 1)
            //  this.$set(this.item_edita, 'DATA'           , this.in_today)
            }

        },

        async seleciona_linha(row, nref) {
            // console.log('row:');
            // console.log(row);

            // return false
            if (nref>0){ nref = '_'+nref }else{ nref = ''}

            // console.log('obj_clicado'+nref);

            this['selected'+nref]  = [ Object.assign({}, row)] 
                //  this.selected =  [{"CODIGO" : row.CODIGO}] //via v-modal no data-table

           //clonando objeto
           this['obj_clicado'+nref] = Object.assign({}, row)
        },    
    
    
    
    
        alerta(text,color){
            DSibasico.alerta(this, text, color)
        },

        dif_datas(a,b){
            return DSibasico.dif_datas(a,b)
        },
    
        incDay(data,dias,pt){
            return DSibasico.incDay(data,dias,pt)
        },
    
        incMonth(data,dias,pt){
            return DSibasico.incMonth(data,dias,pt)
        },
    
        alerta2(text,color){
            // alert(text);
             this.snackbar = true;
             this.snack_text= text;
    
             this.snack_color = color;
        },
    
        define_data_hora(){
            DSibasico.define_data_hora(this)//passo o this para que la ele defina as variaveis daqui
        },
    


           //---------------importando funcoes sql ----------------------- INICIO
          //EXECUTAR UM SQL TIPO UPDATE
          async crud_sql (sql) {
              await DSisql.crud_sql(this, sql)
          },
  
          async tabela_create(tabela, obj_edita){
              await DSisql.tabela_create(this, tabela, obj_edita)
          },
  
          async tabela_update(tabela, obj_edita){
              await DSisql.tabela_update(this, tabela, obj_edita)
          },
  
          //ABRE OS DADOS DA TABELA
          async crud_abrir_tabela(sql, items_name){
              return await DSisql.crud_abrir_tabela(this, sql, items_name)
          }, 
  
          //FICA NO BOTAO SALVAR.. VERIFICA SE UPDATE OU CREATE
          async salvar_tabela(tabela, obj_edita, dialog_name){
            //   alert(tabela)
            //   alert(this.tabela_selecionada_agora)
            //   await this.before_update(this.tabela_selecionada)//trato alguns campos necessarios
              await this.before_update(this.tabela_selecionada_agora)//trato alguns campos necessarios

              await DSisql.salvar_tabela(this,tabela, obj_edita, dialog_name)

            //   if (this.tabela_selecionada == 'agenda'){
            //     alert('here')
            //   }
          },
  
          async remover_tabela(tabela, obj_edita, titulo){
              await DSisql.remover_tabela(this, tabela, obj_edita, titulo)
          },
  
          async editar_tabela(item, obj_edita_name, dialog_name, nref) {

              //pego qual opcao usar e associo 
              let iref = '' 
              if (nref>0){
                 iref = nref
                 nref = '_'+nref
              }else{ nref = ''}

              this.tabela_selecionada_agora = this['tabela_selecionada'+nref]
              this.items_editaveis_agora    = this['items_editaveis'+nref]
              this.item_edita               = this['item_edita'+nref]
            //   this.tabela_selecionada = this['tabela_selecionada'+nref]


              await this.seleciona_linha(item, iref)
              await DSisql.editar_tabela(this, item, obj_edita_name, dialog_name)
          },
  
          nova_tabela(obj_edita_name, dialog_name, nref){

             //pego qual opcao usar e associo  
             if (nref>0){ nref = '_'+nref }else{ nref = ''}
             this.tabela_selecionada_agora = this['tabela_selecionada'+nref]
             this.items_editaveis_agora    = this['items_editaveis'+nref]
             this.item_edita               = this['item_edita'+nref]

             //  mostro o dialog
             DSisql.nova_tabela(this, obj_edita_name,dialog_name)

             //define alguns valores default
             this.define_defaults(this['tabela_selecionada'+nref])
          },


      },
    
    
    }
    </script>
    
    <style scoped>



    .container{
        max-width: 100%;
    }

    ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 2px 2px !important;
    }

    .v-list-item {
    padding: 0 9px;
    }


      @media (max-width: 480px) {
        .chat-container .content{
          max-width: 60%;
        }
      }
    

    .fs-6{
    font-size: 6px !important;
    }
    .fs-7{
    font-size: 7px !important;
    }
    .fs-8{
        font-size: 8px !important;
    }
    .fs-9{
        font-size: 9px !important;
    }
    .fs-10{
        font-size: 10px !important;
    }
    .fs-11{
        font-size: 11px !important;
    }
    .fs-12{
        font-size: 12px !important;
    }
    .fs-13{
        font-size: 13px !important;
    }
    .fs-14{
        font-size: 14px !important;
    }
    .fs-15{
        font-size: 15px !important;
    }
    .fs-16{
        font-size: 16px !important;
    }
    .fs-17{
        font-size: 17px !important;
    }
    .bold{
        font-weight: bold !important;
    }

    .fixed-width-col {
        width: 900px !important; /* Defina a largura fixa desejada */
    }



    /* CALENDÁRIO */

    /* Título do calendário onde ficam os anos */
    ::v-deep .v-picker__title {
        padding-top: 6px !important;
        padding-bottom: 1px !important;
    }

    /* Título com a data no calendário */
    ::v-deep .v-date-picker-title__date {
        font-size: 16px !important;
        height: 16px !important;
    }

    /* O ano no calendário */
    ::v-deep .v-date-picker-title__year {
        display: inline !important;
    }

    /* Dias do calendário (botões) */
    ::v-deep .v-date-picker-table .v-btn {
        height: 18px !important;
    }

    /* Meses no calendário */
    ::v-deep .v-date-picker-table--month td {
        height: 36px !important;
    }

    /* Altura da tabela do calendário */
    ::v-deep .v-date-picker-table {
        height: 190px !important;
    }

    /* Dia da semana do calendário */
    ::v-deep .v-application--is-ltr .v-date-picker-title .v-picker__title__btn {
        height: 0;
    }

    /* Header do calendário */
    ::v-deep .v-date-picker-header {
        padding: 0 !important;
        font-size: 16px;
    }
    

    /* Alinhamento do título do date picker */
    ::v-deep .v-date-picker-title {
        flex-direction: row !important;
    }

    /* Estilo das células da tabela do calendário */
    ::v-deep .v-date-picker-table--date th, 
    ::v-deep .v-date-picker-table--date td {
        padding: 0 !important;
    }
   

    /* Estilo do botão do calendário */
    ::v-deep .v-date-picker .v-btn__content {
        background-color: red;
    }



    /* FIM DO CALENDÁRIO */

    


    /* @media only screen and (min-width: 500px) {

.grid-1 div {
  font-size: 20px;
  padding-top: 0px;
  padding-left: 2px;
}

} */

    /* specific item styles */


    .item-2 {
    /* grid-area: main; */

    display: grid;

    grid-template-columns: 100%;
    word-wrap: break-word;
    grid-template-rows: auto;
    grid-gap: 5px;

    grid-template-areas: "header"
                    "article"
                    "sidebar";

    }

    /* rwd */

    @media only screen and (min-width: 600px) {

    .item-2 {
    
    grid-template-columns: 300px auto;
    grid-template-rows: auto auto;
    
    grid-template-areas: "header header"
                        "article sidebar";
    
    }

    }
    .item-3 {
    grid-area: sidebar;
    }
    .item-4 {
    grid-area: footer;
    }
    .item-5 {

    grid-area: header;
    }
    .item-6 {
      grid-area: article;
    }
    .item-7 {
      grid-area: sidebar;
      min-width: 0;
    }


    /* V-CALENDAR */

    ::v-deep .v-calendar-daily__interval {
      /* Ajuste para dar mais espaço ao horário */
      padding-top: 4px; 

       /* padding-right: 1px;  */
    }

    ::v-deep .v-calendar-daily__interval-text {

      /* Aumentar o tamanho da fonte */
      font-size: 12px; 

        /* Deixar a fonte em negrito */
        font-weight: bold;
    }

    ::v-deep .v-calendar-daily__interval-label {
      margin-left: 5px; /* Move o rótulo do intervalo de tempo */
      z-index: 2; /* Garante que o texto do horário fique acima da linha de grade */
    }

    ::v-deep .v-calendar-daily__interval-line {
      opacity: 0.5; /* Torna a linha de grade mais suave para não sobrepor o horário */
      border-color: #ccc;
    }

    /* V-CALENDAR */





    /* MEU CALENDARIO */

    .schedule-wrapper {
  display: flex;
}

.fixed-column {
  width: 120px; /* Ajuste para a largura da coluna fixa */
}

.scrollable-columns {
  flex: 1; /* O restante do espaço será ocupado pelas colunas de dias */
  overflow-x: auto; /* Permite rolagem horizontal se necessário */
  display: flex;
}

.day-column {
  flex: 1; /* Cada coluna do dia ocupa um espaço igual */
  margin: 0 5px; /* Margem entre as colunas */
}

.block-item {
  border: 1px solid #e0e0e0; /* Borda para os itens */
}

.block-content {
  padding: 5px; /* Espaçamento interno */
  white-space: nowrap; /* Evita quebra de linha */
}


/* ocultar linhas dos horarios intervalos time */
::v-deep .theme--light.v-calendar-daily .v-calendar-daily__interval::after {
  /* display: none; */
  border: none; 
}


/* Se você quiser também ocultar os horários do lado esquerdo */
::v-deep .v-calendar-daily__head .v-calendar-daily__interval {
  display: none;
  
}

/* Aplicando o estilo de forma profunda usando ::v-deep */
/* ::v-deep .theme--light.v-calendar-daily .v-calendar-daily__day-interval:first-child { */
/* ::v-deep .theme--light.v-calendar-daily .v-calendar-daily__day-interval:nth-child(2n) { */

::v-deep .theme--light.v-calendar-daily .v-calendar-daily__day-interval:not(:first-child){ 
  /* Suas regras de estilo aqui */
  /* background-color: #f5f5f5;  Exemplo de cor de fundo */
  background-color: white;  /* Exemplo de cor de fundo */
  border: none;               /* Removendo a borda */
  /* Adicione outras regras conforme necessário */
} 


::v-deep .v-current-time {
  height: 1px;
  /* background-color: #ea4335; */
  background-color: silver;
  position: absolute;
  left: -10px;
  right: 0;
  pointer-events: none;
  z-index: 0;

  /* &.first::before {
    content: '';
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  } */
}


  /* Utilizando ::v-deep para adaptar o seletor com escopo */
  ::v-deep .theme--light.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-day-label {
    color: #b0bec5;
    font-weight: bold;
    opacity: 0.6; 
  }

  

    /* MEU CALENDARIO */


    .text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%; /* Ajusta para o tamanho máximo do v-select */
}



/* algura dos dias no header do calendario */
::v-deep .v-calendar-daily__head {
  height: 22px !important;  
  background-color: rgb(248, 242, 242);
}


/* altura dos numeros do dia no header do calendario */
::v-deep .v-btn--fab.v-size--default {
  /* background-color: red; */
   background-color: transparent !important;
  height: 25px !important;  
  margin-top: -44px;
  margin-left: -50px;
  /* justify-content: flex-start !important; */
  /* padding: 1px !important; */
}


/* ::v-deep .v-btn__content {
  background-color: red;
} */

/* altura  */
::v-deep .v-calendar-daily_head-day-label{
  height: 60px !important;  
  /* font-size: 12px !important;  */
  /* padding: 2px 4px !important;  */
}



/* largura do bloco de evento */
::v-deep .v-event-timed{
  /* width: 99% !important; */
  /* background-color: orange !important; */
  /* right: 0 !important; */
  /* margin-left: 50%; */
}


/* Evento do veículo 1 à esquerda */
::v-deep .v-event-timed .leftX {
  width: 50% !important;
  background-color: blue !important;
  left: 0 !important; /* garante que fique à esquerda */
  position: absolute; /* necessário para alinhar dentro da célula */
  box-sizing: border-box;
}

/* Evento do veículo 2 à direita */
::v-deep .v-event-timed .rightX {
  width: 50% !important;
  background-color: red !important;
  left: 50% !important; /* começa na metade da célula */
  position: absolute;
  box-sizing: border-box;
}



.calendar2 ::v-deep  .v-calendar-daily__intervals-body {
  display: none !important;
}



.calendarios {
  display: flex;
  justify-content: flex-start; /* alinha tudo à esquerda */
  gap: -1px; /* espaço fixo entre os dois */
}

.coluna {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0px;
  background: #fafafa;
  overflow-y: auto;
  max-width: 500px; /* largura máxima */
  flex: 1 1 400px;  /* tenta ficar com até 400px, mas encolhe se faltar espaço */
}

.count_item {
   position: relative !important;
   top: -2px;
   font-size: 80%;
   vertical-align: super;
   color: red;
 }



.container-calendarios {
  display: flex;
  width: 100%;
}

.container-calendarios .coluna {
  flex: 1;           /* 🔥 divide espaço igualmente */
  min-width: 0;      /* 🔥 evita bug de overflow */
}

 .container-calendarios.modo-scroll {
  overflow-x: auto;
  display: flex;
}

/* .container-calendarios.modo-scroll .coluna {
  flex: 0 0 290px;   
  min-width: 290px;
} */


  /* tamanho da fonte do data-table */
.v-data-table >>> tr>td{
  font-size:12px !important;
  /* height: 25px !important; */
}

/* tamanho da fonte do data-table */


.theme--light.v-data-table >>> tbody tr.v-data-table__selected {
    /* seleciona_linha cor */
    background: #eee9e9 !important;
}


.v-data-table >>> td.text-start{ /* padding das colunas data-table  */
      padding-left: 3px !important;
      padding-right: 3px !important;
      /* padding: 0px 2px !important; */
      /* background-color: red; */
}

.v-data-table >>>  th.text-start{ /* padding dos titulos das colunas data-table */
      padding: 0px 4px !important;
      /* background-color: red; */
}

  /* diminui distancia icone calendario no v-date-picker*/
   .text_field_menor >>> input {
      max-width: 95% !important;
      /* width: 160px !important; */
  }

.no_wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;
  min-width: 0;
}
    

</style>